import { j as s, $ as di, a as hi, b as ui, c as pi, d as mi, e as gi, g as fi, h as bi, i as yi, n as L, O as xi, k as Rs, l as Es, w as Ln, Z as _i, H as Ci, m as Fn, o as _e, p as oo, r as ur, q as vi, t as Ls, W as wi, u as Si, A as Ii, F as ki, v as pr, x as mr, y as As, z as gr, B as An, C as Di, D as Ti, E as ji, G as Ni, I as Fi, J as Pi, K as fr, L as Ri, M as Ei } from "./vendor-B4O8kiwH.js";
import f from "classnames";
import { I as P, T as $, a as U, r as Ss, B as ie, b as Zt, c as te, d as Be, S as $s, e as Ge, f as Li, g as Ai } from "./emoji-r0LV8WWJ.js";
import { E as $D, N as OD, j as BD, h as HD, i as WD } from "./emoji-r0LV8WWJ.js";
import { createContext as ke, useContext as Oe, useRef as Y, useLayoutEffect as $i, useState as V, useCallback as F, useEffect as X, cloneElement as sn, isValidElement as Ie, Component as me, PureComponent as k, forwardRef as W, Children as Re, createRef as O, memo as br, useMemo as q, Fragment as Xe, createElement as Oi, lazy as Bi, Suspense as Hi, useReducer as Wi, useImperativeHandle as on } from "react";
import { useKey as yr, useMount as Tt, useUnmount as Ze, useUpdateEffect as Qe, useToggle as Mi, useSetState as zi, useClickAway as xr, usePrevious as Jt, useDebounce as Vi } from "react-use";
import j from "moment-timezone";
import { v4 as en } from "uuid";
import { noop as Ki } from "ts-essentials";
import Ui from "react-dom";
function qi(i) {
  let e = i;
  const t = [];
  function n(r) {
    if (r !== e) {
      for (const { type: a, handler: l, options: c } of t)
        e.removeEventListener(a, l, c), r.addEventListener(a, l, c);
      e = r;
    }
  }
  return { proxy: new Proxy({}, {
    get(r, a) {
      if (a === "addEventListener")
        return (c, d, h) => {
          t.push({ type: c, handler: d, options: h }), e.addEventListener(c, d, h);
        };
      if (a === "removeEventListener")
        return (c, d, h) => {
          const u = typeof h == "boolean" ? h : h?.capture ?? !1, p = t.findIndex((m) => {
            const g = typeof m.options == "boolean" ? m.options : m.options?.capture ?? !1;
            return m.type === c && m.handler === d && g === u;
          });
          p !== -1 && t.splice(p, 1), e.removeEventListener(c, d, h);
        };
      const l = e[a];
      return typeof l != "function" ? l : new Proxy(l, {
        apply(c, d, h) {
          return l.apply(e, h);
        }
      });
    }
  }), setWindow: n };
}
const Mn = ke(
  typeof window < "u" ? window : {}
);
function Nk({
  value: i,
  children: e
}) {
  const t = Y(null);
  return t.current || (t.current = qi(i)), $i(() => {
    t.current.setWindow(i);
  }, [i]), /* @__PURE__ */ s.jsx(Mn.Provider, { value: t.current.proxy, children: e });
}
function Os() {
  return Oe(Mn);
}
const Gi = "h-tooltip--tooltip__content", Yi = "h-tooltip--tooltip__contentLight", Qi = "h-tooltip--tooltip__contentHasHead", Xi = "h-tooltip--tooltip__body", Zi = "h-tooltip--tooltip__head", Ji = "h-tooltip--tooltip__arrow", dt = {
  content: Gi,
  contentLight: Yi,
  contentHasHead: Qi,
  body: Xi,
  head: Zi,
  arrow: Ji
}, ea = 400;
function se({
  children: i,
  content: e,
  onOpenChange: t,
  side: n = "top",
  className: o,
  head: r,
  defaultOpen: a,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = ea,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: m,
  requireClick: g,
  light: b,
  ...y
}) {
  const _ = Os(), [v, S] = V(
    g ? !1 : void 0
  ), C = F(() => {
    S(!1), _.removeEventListener("click", C);
  }, [_]);
  X(() => () => {
    _.removeEventListener("click", C);
  }, [C, _]);
  const x = di();
  if (c || !e)
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const w = (T) => {
    T.stopPropagation(), _[v ? "removeEventListener" : "addEventListener"](
      "click",
      C
    ), S(!v);
  }, I = f(
    dt.content,
    {
      [dt.contentHasHead]: !!r,
      [dt.contentLight]: b
    },
    o
  );
  return /* @__PURE__ */ s.jsx(hi, { children: /* @__PURE__ */ s.jsxs(
    ui,
    {
      open: v ?? (l ? !0 : void 0),
      defaultOpen: a,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: t,
      children: [
        /* @__PURE__ */ s.jsx(pi, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ s.jsx(
          p,
          {
            onClick: g ? w : void 0,
            ...m,
            ...y,
            children: i
          }
        ) : g && Ie(i) ? sn(i, { onClick: w }) : i }),
        /* @__PURE__ */ s.jsx(mi, { container: _.document.body, children: /* @__PURE__ */ s.jsx(
          gi,
          {
            id: x,
            side: n,
            sideOffset: 4,
            align: h,
            className: I,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              r && /* @__PURE__ */ s.jsx("div", { className: dt.head, children: r }),
              /* @__PURE__ */ s.jsx("div", { className: dt.body, children: e }),
              /* @__PURE__ */ s.jsx(fi, { className: dt.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const ta = "h-attachment--attachment__root", na = "h-attachment--attachment__icon", sa = "h-attachment--attachment__name", oa = "h-attachment--attachment__buttons", hn = {
  root: ta,
  icon: na,
  name: sa,
  buttons: oa
}, ro = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function ra(i) {
  const e = i.split(".").pop()?.toLowerCase();
  return !e || !ro[e] ? "file" : ro[e];
}
const Fk = (i) => {
  const {
    className: e,
    nameClassName: t,
    fileName: n,
    label: o,
    onDownload: r,
    onPreview: a,
    isPreviewLoading: l,
    isDownloadLoading: c,
    extraButtons: d,
    ...h
  } = i, u = f(
    {
      [hn.root]: !0
    },
    e
  );
  return /* @__PURE__ */ s.jsxs("div", { ...h, className: u, children: [
    /* @__PURE__ */ s.jsx(
      P,
      {
        className: hn.icon,
        name: ra(n),
        size: 24,
        color: "neutral.700"
      }
    ),
    /* @__PURE__ */ s.jsx(
      se,
      {
        content: o || n,
        wrap: "div",
        wrapProps: { className: f(hn.name, t) },
        children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "4", color: "secondary", children: o || n })
      }
    ),
    /* @__PURE__ */ s.jsxs("div", { className: hn.buttons, children: [
      a && /* @__PURE__ */ s.jsx(
        U,
        {
          isLoading: l,
          variant: "secondary",
          icon: "eye",
          onClick: l ? void 0 : a
        }
      ),
      r && /* @__PURE__ */ s.jsx(
        U,
        {
          isLoading: c,
          variant: "secondary",
          icon: "download",
          onClick: c ? void 0 : r
        }
      ),
      d
    ] })
  ] });
}, ia = {
  onError(i, e) {
    console.error(i, e);
  }
}, aa = ke(ia), io = { error: null };
class jt extends me {
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  constructor(e) {
    super(e), this.state = io, this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.resetInternally = this.resetInternally.bind(this);
  }
  componentDidCatch(e, t) {
    this.props.onError?.(e, t), this.context?.onError?.(e, t);
  }
  static contextType = aa;
  resetErrorBoundary(...e) {
    this.props.onReset?.(...e), this.resetInternally();
  }
  resetInternally() {
    this.setState(io);
  }
  hasError(e) {
    return e !== null;
  }
  ensureErrorHandlerExists() {
    const { fallback: e, fallbackRender: t } = this.props, n = this.hasFallbackElement(e), o = this.hasFallbackRenderer(t);
    if (!n && !o)
      throw new Error(
        `${jt.name} requires either a fallback component or a fallback renderer`
      );
  }
  hasFallbackRenderer(e) {
    return typeof e == "function";
  }
  hasFallbackElement(e) {
    return e === null || typeof e == "string" || Ie(e);
  }
  render() {
    const { error: e } = this.state, { fallbackRender: t, fallback: n } = this.props;
    if (this.ensureErrorHandlerExists(), !this.hasError(e))
      return this.props.children;
    if (this.hasFallbackElement(n))
      return n;
    if (this.hasFallbackRenderer(t))
      return t({
        error: e,
        resetErrorBoundary: this.resetErrorBoundary
      });
  }
}
function rn(i, e) {
  const t = i.displayName || i.name || "Unknown";
  return bi(
    class extends me {
      static displayName = `withErrorBoundary(${t})`;
      static defaultProps = i.defaultProps;
      render() {
        const o = i;
        return /* @__PURE__ */ s.jsx(jt, { ...e, children: /* @__PURE__ */ s.jsx(o, { ...this.props }) });
      }
    },
    i
  );
}
const la = "h-avatar--avatar__root", Pn = {
  root: la,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, ca = {
  24: 16,
  32: 20,
  40: 24
}, da = ({
  icon: i,
  size: e,
  color: t = "inherit"
}) => /* @__PURE__ */ s.jsx(P, { name: i, size: ca[e], color: t }), ha = "h-image--image__image", ua = "h-image--image__error", pa = "h-image--image__complete", es = {
  image: ha,
  error: ua,
  complete: pa
};
class Bs extends me {
  static defaultProps;
  mounted;
  constructor(e) {
    super(e), this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: e } = this.props;
    this.handleSource(e);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(e) {
    const { src: t } = this.props;
    e.src !== t && this.handleSource(e.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(e) {
    typeof e == "string" ? this.setState({
      imageSrc: e
    }) : e().then((t) => {
      this.mounted && typeof t == "string" && this.setState({
        imageSrc: t
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(e) {
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), this.props.onLoad?.(e);
  }
  onError(e) {
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), this.props.onError?.(e);
  }
  render() {
    const { className: e, src: t, alt: n, ...o } = this.props, { imageSrc: r } = this.state, { loadingError: a, loadingComplete: l } = this.state, c = f(
      {
        [es.image]: !0,
        [es.error]: !!a,
        [es.complete]: !!l
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "img",
      {
        ...o,
        className: c,
        onError: this.onError,
        onLoad: this.onLoad,
        src: r,
        alt: n || ""
      }
    );
  }
}
Bs.defaultProps = {
  className: "",
  alt: ""
};
const ma = "h-avatar--imageAvatar__root", ga = {
  root: ma
}, fa = ({
  src: i,
  alt: e = "avatar"
}) => /* @__PURE__ */ s.jsx(Bs, { src: i, alt: e, className: ga.root }), ba = "h-avatar--textAvatar__root", Rn = {
  root: ba,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, ya = {
  24: Rn["avatar-24"],
  32: Rn["avatar-32"],
  40: Rn["avatar-40"]
}, xa = ({ text: i = "", size: e }) => /* @__PURE__ */ s.jsx("div", { className: f(Rn.root, ya[e]), children: i.trim().split(" ").map(
  (t, n, o) => o.length === 1 ? t : t[0]
).join("").slice(0, 2) }), _a = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class Ca {
  constructor(e) {
    this.colors = e, this.colors = e;
  }
  colors;
  generate(e) {
    const t = this.getRandomIndex(e);
    return this.colors[t];
  }
  getRandomIndex(e) {
    const t = yi(e);
    return Math.floor(t() * this.colors.length);
  }
}
var ee = /* @__PURE__ */ ((i) => (i.Icon = "Icon", i.Image = "Image", i.Text = "Text", i))(ee || {});
function ht(i) {
  return i.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function Ce(i) {
  return !!i && i.trim().length !== 0;
}
function va(i) {
  if (i.icon)
    return {
      type: ee.Icon,
      icon: i.icon,
      backgroundColor: i.color?.backgroundColor,
      iconColor: i.color?.contentColor
    };
  const { user: e } = i;
  if (!e)
    return {
      type: ee.Icon,
      icon: "user-slash"
    };
  if (Ce(e.avatar_url))
    return {
      type: ee.Image,
      src: e.avatar_url,
      alt: e.name || e.display_name || e.email || e.phone_number || e.given_name || e.family_name || ""
    };
  if (Ce(e.name)) {
    const t = ht(e.name.trim()).split(" ");
    if (t.length === 1)
      return {
        type: ee.Text,
        text: t[0]?.[0] ?? ""
      };
    const n = t[0], o = t[t.length - 1];
    return {
      type: ee.Text,
      text: (n?.[0] ?? "") + (o?.[0] ?? "")
    };
  }
  if (Ce(e.display_name))
    return {
      type: ee.Text,
      text: ht(e.display_name.trim())
    };
  if (Ce(e.given_name) && Ce(e.family_name))
    return {
      type: ee.Text,
      text: ht(e.given_name.trim())[0] + ht(e.family_name.trim())[0]
    };
  if (Ce(e.given_name) && !Ce(e.family_name))
    return {
      type: ee.Text,
      text: ht(e.given_name.trim())[0]
    };
  if (!Ce(e.given_name) && Ce(e.family_name))
    return {
      type: ee.Text,
      text: ht(e.family_name.trim())[0]
    };
  if (Ce(e.email)) {
    const [t] = e.email.split("@");
    return {
      type: ee.Text,
      text: t.trim()
    };
  }
  return Ce(e.phone_number) ? {
    type: ee.Text,
    text: e.phone_number.slice(-2)
  } : e.id ? {
    type: ee.Icon,
    icon: "user-secret"
  } : {
    type: ee.Icon,
    icon: "user-slash"
  };
}
const ve = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, ao = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...ve,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": ve,
  "user-slash": ve,
  "map-pin": ve,
  "web-form": ve,
  code: ve,
  history: ve,
  smile: ve,
  key: ve,
  webhooks: ve,
  plug: ve
}, wa = {
  24: Pn["avatar-24"],
  32: Pn["avatar-32"],
  40: Pn["avatar-40"]
};
class Sa extends k {
  static defaultProps = {
    size: "32",
    colorGenerator: new Ca(_a)
  };
  getAvatarChild(e, t) {
    if (e.type === ee.Icon)
      return /* @__PURE__ */ s.jsx(
        da,
        {
          size: t,
          icon: e.icon,
          color: e.iconColor
        }
      );
    if (e.type === ee.Image)
      return /* @__PURE__ */ s.jsx(fa, { src: e.src, alt: e.alt });
    if (e.type === ee.Text)
      return /* @__PURE__ */ s.jsx(xa, { size: t, text: e.text });
  }
  calculateColor(e) {
    if (e.type === ee.Icon) {
      if (e.backgroundColor && e.iconColor)
        return {
          backgroundColor: e.backgroundColor,
          contentColor: e.iconColor
        };
      if (ao[e.icon])
        return ao[e.icon];
    }
    return e.type === ee.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : e.type === ee.Text ? this.props.colorGenerator.generate(e.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: e, size: t } = this.props, n = va(this.props), o = this.getAvatarChild(n, t), r = this.calculateColor(n);
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: f(
          Pn.root,
          wa[t],
          e
        ),
        children: o
      }
    );
  }
}
const _r = rn(Sa, {
  fallback: null
}), Ia = "h-badge--badge__badge", ka = "h-badge--badge__badgeSmall", Da = "h-badge--badge__badgeMedium", Ta = "h-badge--badge__badgePrimary", ja = "h-badge--badge__badgeSecondary", Na = "h-badge--badge__badgeSuccess", Fa = "h-badge--badge__badgeInfo", Pa = "h-badge--badge__badgeWarning", Ra = "h-badge--badge__badgeError", $e = {
  badge: Ia,
  badgeSmall: ka,
  badgeMedium: Da,
  badgePrimary: Ta,
  badgeSecondary: ja,
  badgeSuccess: Na,
  badgeInfo: Fa,
  badgeWarning: Pa,
  badgeError: Ra
}, Ea = {
  small: $e.badgeSmall,
  medium: $e.badgeMedium
}, La = {
  primary: $e.badgePrimary,
  secondary: $e.badgeSecondary,
  success: $e.badgeSuccess,
  info: $e.badgeInfo,
  warning: $e.badgeWarning,
  error: $e.badgeError
}, Aa = "badge";
function Rk(i) {
  const { className: e, size: t, variant: n, children: o, ...r } = i, a = f(
    $e.badge,
    Ea[t],
    La[n],
    e
  );
  return /* @__PURE__ */ s.jsx("span", { className: a, ...r, "data-testid": Aa, children: o });
}
const B = W(function({
  flexWrap: e,
  flexDirection: t,
  justifyItems: n,
  justifyContent: o,
  alignItems: r,
  alignContent: a,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...e && { flexWrap: e },
    ...t && { flexDirection: t },
    ...n && { justifyItems: n },
    ...o && { justifyContent: o },
    ...r && { alignItems: r },
    ...a && { alignContent: a },
    ...l && { gap: Ss(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ s.jsx(ie, { ...h, style: p, ref: u, children: d });
}), $a = "h-banner--banner__root", Oa = "h-banner--banner__rootWithClose", Ba = "h-banner--banner__iconContainer", Ha = "h-banner--banner__closeIcon", Wa = "h-banner--banner__headline", Ma = "h-banner--banner__rootInfo", za = "h-banner--banner__icon", Va = "h-banner--banner__description", Ka = "h-banner--banner__rootWarning", Ua = "h-banner--banner__rootAnnouncement", qa = "h-banner--banner__rootSuccess", Ga = "h-banner--banner__rootFail", xe = {
  root: $a,
  rootWithClose: Oa,
  iconContainer: Ba,
  closeIcon: Ha,
  headline: Wa,
  rootInfo: Ma,
  icon: za,
  description: Va,
  rootWarning: Ka,
  rootAnnouncement: Ua,
  rootSuccess: qa,
  rootFail: Ga
}, Ya = (i, e) => {
  if (e !== void 0)
    return e;
  switch (i) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, Ek = ({
  actionSlot: i,
  className: e,
  description: t,
  headline: n,
  icon: o,
  variant: r,
  onClose: a
}) => {
  const l = f(xe.root, e, {
    [xe.rootInfo]: r === "info",
    [xe.rootAnnouncement]: r === "announcement",
    [xe.rootWarning]: r === "warning",
    [xe.rootSuccess]: r === "success",
    [xe.rootFail]: r === "fail",
    [xe.rootWithClose]: a
  }), c = Ya(r, o);
  return /* @__PURE__ */ s.jsxs("div", { className: l, children: [
    /* @__PURE__ */ s.jsxs(B, { justifyContent: "center", children: [
      c && /* @__PURE__ */ s.jsx("span", { className: xe.iconContainer, children: /* @__PURE__ */ s.jsx(P, { name: c, size: 16, className: xe.icon }) }),
      /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", children: [
        n && /* @__PURE__ */ s.jsx(
          $.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: xe.headline,
            children: n
          }
        ),
        sn(t, {
          className: xe.description
        })
      ] })
    ] }),
    i ? /* @__PURE__ */ s.jsx(B, { gap: "250", margin: "0 0 0 250", children: i }) : a && /* @__PURE__ */ s.jsx(
      U,
      {
        icon: "close",
        variant: "tertiary",
        className: xe.closeIcon,
        onClick: a
      }
    )
  ] });
}, Qa = "h-buttonGroup--buttonGroup__root", Xa = "h-buttonGroup--buttonGroup__button", Za = "h-buttonGroup--buttonGroup__buttonWithBorder", Ja = "h-buttonGroup--buttonGroup__buttonWithoutBorder", un = {
  root: Qa,
  button: Xa,
  buttonWithBorder: Za,
  buttonWithoutBorder: Ja
}, Lk = ({
  className: i,
  children: e,
  variant: t,
  size: n,
  disabled: o
}) => {
  const r = f(un.root, i);
  return /* @__PURE__ */ s.jsx("div", { className: r, role: "group", children: Re.map(e, (a) => {
    if (!Ie(a))
      return null;
    const l = (t ?? a.props.variant) === "secondary", c = f(a.props.className, {
      [un.button]: !0,
      [un.buttonWithBorder]: l,
      [un.buttonWithoutBorder]: !l
    });
    return sn(a, {
      className: c,
      disabled: o ?? a.props.disabled,
      variant: t ?? a.props.variant,
      size: n
    });
  }) });
}, el = "h-divider--divider__root", tl = "h-divider--divider__withChildren", nl = "h-divider--divider__horizontal", sl = "h-divider--divider__vertical", ts = {
  root: el,
  withChildren: tl,
  horizontal: nl,
  vertical: sl
}, zn = W(function({
  className: e,
  children: t,
  as: n,
  orientation: o = "horizontal",
  color: r,
  margin: a,
  padding: l,
  ...c
}, d) {
  const h = n ?? (t ? "div" : "hr"), u = f(
    ts.root,
    ts[o],
    {
      [ts.withChildren]: !!t
    },
    e
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": Zt(r) } : {},
    ...a ? { margin: Ss(a) } : {},
    ...l ? { padding: Ss(l) } : {}
  };
  return /* @__PURE__ */ s.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof t == "string" ? /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: t }) : t
    }
  );
}), ol = "h-buttonList--buttonList__buttonList", rl = "h-buttonList--buttonList__inner", lo = {
  buttonList: ol,
  inner: rl
};
let il = class extends k {
  render() {
    const { children: e, className: t, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(zn, { as: "li", color: "tertiary", padding: "200 250", ...n, children: e });
  }
};
const al = "h-buttonList--item__item", ll = "h-buttonList--item__icon", cl = "h-buttonList--item__button", dl = "h-buttonList--item__buttonDisabled", hl = "h-buttonList--item__buttonCentered", ul = "h-buttonList--item__checkmark", pl = "h-buttonList--item__buttonLoading", ml = "h-buttonList--item__buttonContent", He = {
  item: al,
  icon: ll,
  button: cl,
  buttonDisabled: dl,
  buttonCentered: hl,
  checkmark: ul,
  buttonLoading: pl,
  buttonContent: ml
}, gl = function({
  icon: e,
  children: t,
  className: n,
  isSelected: o,
  isCentered: r,
  isLoading: a,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const m = f(
    {
      [He.item]: !0
    },
    n
  ), g = f(
    He.button,
    {
      [He.buttonCentered]: r,
      [He.buttonLoading]: a,
      [He.buttonDisabled]: l
    },
    c
  ), b = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ s.jsx("li", { ref: p, ...u, className: m, children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...b,
      ...d,
      className: g,
      onClick: h,
      children: [
        /* @__PURE__ */ s.jsxs("span", { className: He.buttonContent, children: [
          e && /* @__PURE__ */ s.jsx(P, { className: He.icon, name: e }),
          /* @__PURE__ */ s.jsx($.Paragraph, { variant: o ? "1" : "2", children: t })
        ] }),
        o && /* @__PURE__ */ s.jsx(
          P,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: He.checkmark
          }
        )
      ]
    }
  ) });
}, fl = W(gl);
class co extends k {
  static get Item() {
    return fl;
  }
  static get Header() {
    return il;
  }
  static get Divider() {
    return bl;
  }
  render() {
    const { children: e, className: t, ...n } = this.props, o = f(
      {
        [lo.buttonList]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: /* @__PURE__ */ s.jsx("ul", { className: lo.inner, children: e }) });
  }
}
const bl = () => /* @__PURE__ */ s.jsx(zn, { as: "li", margin: "100 0" }), yl = "h-checkbox--checkbox__root", xl = "h-checkbox--checkbox__rootDisabled", _l = "h-checkbox--checkbox__rootChecked", Cl = "h-checkbox--checkbox__rootIndeterminate", vl = "h-checkbox--checkbox__checkbox", wl = "h-checkbox--checkbox__input", ut = {
  root: yl,
  rootDisabled: xl,
  rootChecked: _l,
  rootIndeterminate: Cl,
  checkbox: vl,
  input: wl
};
class an extends k {
  inputRef;
  constructor(e) {
    super(e), this.inputRef = O();
  }
  componentDidMount() {
    const e = this.inputRef.current;
    e && (e.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(e) {
    const t = this.inputRef.current;
    t && e.indeterminate !== this.props.indeterminate && (t.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: e,
      onChange: t,
      id: n,
      name: o,
      checked: r,
      indeterminate: a,
      disabled: l,
      tabIndex: c,
      ...d
    } = this.props, h = f(
      {
        [ut.root]: !0,
        [ut.rootDisabled]: l,
        [ut.rootChecked]: r,
        [ut.rootIndeterminate]: a
      },
      e
    );
    return /* @__PURE__ */ s.jsxs("span", { className: h, "data-testid": "habla-checkbox", ...d, children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": a ? "mixed" : r,
          className: ut.checkbox
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: o,
          className: ut.input,
          onChange: t || L,
          checked: r,
          disabled: l,
          ref: this.inputRef,
          tabIndex: c
        }
      )
    ] });
  }
}
const Sl = "h-collapseCard--collapseCard__card", Il = {
  card: Sl
}, Hs = ke({
  isOpen: !1,
  onToggle: L
}), kl = "h-collapseCard--content__content", Dl = "h-collapseCard--content__contentIsOpen", ho = {
  content: kl,
  contentIsOpen: Dl
};
class Tl extends k {
  static displayName = "CollapseCard.Content";
  getRootClassName(e) {
    return f(ho.content, this.props.className, {
      [ho.contentIsOpen]: e
    });
  }
  render() {
    const { children: e, className: t, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Hs.Consumer, { children: ({ isOpen: o }) => o ? /* @__PURE__ */ s.jsx(
      "ul",
      {
        ...n,
        className: this.getRootClassName(o),
        "data-testid": "content",
        children: e
      }
    ) : null });
  }
}
function Vn(i) {
  return {
    role: "button",
    onClick: i,
    onKeyDown: (e) => {
      e.key === "Enter" && i(e);
    }
  };
}
const jl = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], Nl = ["Escape", "Esc"], Kn = (i) => jl.includes(i), Nt = (i) => Nl.includes(i), Fl = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], uo = Fl.join(
  ':not([hidden]):not([tabindex="-1"]),'
), Cr = br(function({
  containerRef: e,
  children: t,
  isActive: n,
  autoFocus: o,
  restoreFocus: r,
  onActiveStateChange: a,
  bringInFocusOnTab: l
}) {
  const c = n !== void 0, d = n === void 0 || n, h = Y(null), u = Y(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = e || h;
  yr(
    "Tab",
    (b) => {
      if (!d)
        return;
      const y = p.current?.querySelectorAll(uo), _ = !p.current?.contains(
        b.target instanceof Element ? b.target : null
      );
      if (!y)
        return;
      const v = y[0], S = y[y.length - 1];
      if (!b.shiftKey && document.activeElement === S || !b.shiftKey && l && _)
        return v?.focus(), b.preventDefault();
      (b.shiftKey && document.activeElement === v || b.shiftKey && l && _) && (S?.focus(), b.preventDefault());
    },
    void 0,
    [d]
  );
  const m = () => {
    setTimeout(() => {
      o && (o === !0 ? p.current?.querySelector(uo)?.focus() : o.current && o.current.focus());
    });
  }, g = () => {
    document.activeElement !== document.body && !p.current?.contains(document.activeElement) || setTimeout(() => {
      r && (r === !0 ? u.current?.focus() : r.current && r.current.focus());
    });
  };
  return Tt(() => {
    c || (m(), a?.(!0));
  }), Ze(() => {
    c || (g(), a?.(!1));
  }), Qe(() => {
    n === !0 ? (u.current = document.activeElement, m()) : n === !1 && g(), a?.(!!n);
  }, [n]), e ? /* @__PURE__ */ s.jsx(s.Fragment, { children: t }) : /* @__PURE__ */ s.jsx("div", { ref: h, children: t });
}), Pl = "h-dropdown--dropdown__dropdown", Rl = "h-dropdown--dropdown__dropdownOpen", El = "h-dropdown--dropdown__dropdownFromRight", Ll = "h-dropdown--dropdown__dropdownFromBottom", Al = "h-dropdown--dropdown__dropdownAnimating", $l = "h-dropdown--dropdown__dropdownFixed", Ol = "h-dropdown--dropdown__loader", Bl = "h-dropdown--dropdown__error", Hl = "h-dropdown--dropdown__errorIcon", Ee = {
  dropdown: Pl,
  dropdownOpen: Rl,
  dropdownFromRight: El,
  dropdownFromBottom: Ll,
  dropdownAnimating: Al,
  dropdownFixed: $l,
  loader: Ol,
  error: Bl,
  errorIcon: Hl
};
class Je extends k {
  dropdownRef;
  timeoutAnimationStart;
  timeoutAnimationEnd;
  win;
  static defaultProps = {
    onClose: () => {
    },
    closeOnBlur: !0
  };
  constructor(e) {
    super(e), this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = O(), this.win = window, this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.win = this.getWindow(), this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const e = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: e.width,
        oldHeight: e.height
      };
    }
    return null;
  }
  componentDidUpdate(e, t, n) {
    const { isOpen: o, isLoading: r, errorMessage: a, fixed: l, closeOnBlur: c } = this.props;
    if (n && (r !== e.isLoading || a !== e.errorMessage)) {
      const d = r !== e.isLoading && r;
      this.animate(n.oldWidth, n.oldHeight, d);
    }
    o && this.calculatePosition(), o !== e.isOpen && (this.win[o ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), c && this.win[o ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), l && this.win[o ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  getWindow() {
    return this.dropdownRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentWillUnmount() {
    this.win.removeEventListener("click", this.handleClickOutsideDropdown), this.win.removeEventListener("scroll", this.handleFixedScroll), this.win.removeEventListener("blur", this.handleOnClose), this.win.clearInterval(this.timeoutAnimationStart), this.win.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: e } = this.props;
    e();
  }
  animate(e, t, n) {
    if (this.dropdownRef.current) {
      const o = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: e,
        height: t,
        animating: !n
      }), this.timeoutAnimationStart = this.win.setTimeout(() => {
        this.setState({
          width: o.width,
          height: o.height
        }), this.timeoutAnimationEnd = this.win.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(e) {
    if (!this.dropdownRef || !e.target) return;
    const t = e.target, { onClose: n } = this.props;
    this.dropdownRef.current && t !== this.dropdownRef.current && !this.dropdownRef.current.contains(t) && n();
  }
  handleDropdownClick(e) {
    e.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const e = this.dropdownRef.current.parentElement.getBoundingClientRect(), t = e.left + e.width / 2, n = e.top + e.height / 2, o = this.getWindow(), r = o.innerWidth / 2, a = o.innerHeight / 2;
      this.setState({
        fromRight: t > r,
        fromBottom: n > a,
        fromTop: n <= a
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: e, fromBottom: t, fromTop: n } = this.state, o = this.dropdownRef.current.parentElement.getBoundingClientRect(), r = {}, a = this.getWindow();
      return e ? r.right = `${a.innerWidth - o.right}px` : r.left = `${o.left}px`, t && (r.bottom = `${a.innerHeight - o.top}px`), n && (r.top = `${o.top + o.height}px`), r;
    }
    return {};
  }
  render() {
    const {
      className: e,
      children: t,
      onClose: n,
      isOpen: o,
      isLoading: r,
      closeOnBlur: a,
      errorMessage: l,
      fixed: c,
      style: d,
      autoFocus: h,
      restoreFocus: u,
      bringInFocusOnTab: p,
      ...m
    } = this.props, { fromRight: g, fromBottom: b, animating: y, width: _, height: v } = this.state, S = f(
      {
        [Ee.dropdown]: !0,
        [Ee.dropdownOpen]: o,
        [Ee.dropdownFromRight]: g,
        [Ee.dropdownFromBottom]: b,
        [Ee.dropdownAnimating]: y,
        [Ee.dropdownFixed]: c
      },
      e
    );
    let C = { ...d };
    _ && v && (C.width = `${_}px`, C.height = `${v}px`), c && (C = { ...C, ...this.getFixedPosition() });
    const x = !r && !l;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...m,
        className: S,
        ref: this.dropdownRef,
        style: C,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": o,
        children: [
          r && /* @__PURE__ */ s.jsx("div", { className: Ee.loader }),
          !!l && !r && /* @__PURE__ */ s.jsxs("div", { className: Ee.error, children: [
            /* @__PURE__ */ s.jsx(P, { className: Ee.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ s.jsx("span", { children: l })
          ] }),
          x && /* @__PURE__ */ s.jsx(
            Cr,
            {
              containerRef: this.dropdownRef,
              isActive: o,
              autoFocus: h,
              restoreFocus: u,
              bringInFocusOnTab: p,
              children: t
            }
          )
        ]
      }
    );
  }
}
const Wl = "h-dropdownButton--dropdownButton__root", Ml = "h-dropdownButton--dropdownButton__wrapper", ns = {
  root: Wl,
  wrapper: Ml
}, ln = ke({
  toggleDropdown: L,
  openDropdown: L,
  closeDropdown: L,
  dropdownOpen: !1
});
class ct extends me {
  buttonWrapperRef;
  buttonRef;
  contextState;
  timeoutId;
  win;
  static defaultProps = {
    allowEscClose: !0
  };
  constructor(e) {
    super(e);
    const t = e.show ?? !1;
    this.state = {
      dropdownOpen: t,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.win = window, this.buttonWrapperRef = O(), this.buttonRef = O(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: t
    };
  }
  getWindow() {
    return this.buttonWrapperRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentDidMount() {
    this.win = this.getWindow(), this.props.allowEscClose && this.props.show && this.win.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(e) {
    this.toggleDropdownIfNeeded(e);
  }
  componentWillUnmount() {
    this.props.allowEscClose && this.win.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && this.win.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(e) {
    return e.show !== this.props.show;
  }
  handleKeyDown(e) {
    Nt(e.key) && this.state.dropdownOpen && (e.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(e) {
    this.shouldToggleDropdown(e) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(e, t = 0) {
    return this.win.setTimeout(e, t);
  }
  handleDropdownToggle() {
    const { dropdownOpen: e } = this.state, t = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!e);
      });
    }, n = this.shouldDropdownBeAboveButton();
    e ? t() : this.setState(
      { fromBottom: n },
      t
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(e) {
    const { allowEscClose: t, onToggle: n } = this.props, { pristine: o, dropdownOpen: r } = this.state, a = e ?? !r;
    this.contextState = { ...this.contextState, dropdownOpen: a }, this.setState({ dropdownOpen: a, pristine: !1 }), t && (a ? this.win.addEventListener.bind(this.win) : this.win.removeEventListener.bind(this.win))("keydown", this.handleKeyDown, !0), n?.(a, o);
  }
  shouldDropdownBeAboveButton() {
    const e = this.buttonWrapperRef.current?.getBoundingClientRect();
    return e ? e.bottom > this.getWindow().innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: e,
      buttonProps: t,
      children: n,
      noArrow: o,
      noStyle: r,
      onMouseEnter: a,
      onMouseLeave: l
    } = this.props, { fromBottom: c } = this.state;
    return r ? /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: t?.className,
        ...t,
        onMouseEnter: a,
        onMouseLeave: l,
        ...Vn(this.handleDropdownToggle),
        children: n
      }
    ) : e && !n ? /* @__PURE__ */ s.jsx(
      U,
      {
        ref: this.buttonRef,
        icon: e,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...t,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ s.jsx(
      te,
      {
        ref: this.buttonRef,
        icon: e,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...t,
        onClick: this.handleDropdownToggle,
        slotEnd: o ? void 0 : /* @__PURE__ */ s.jsx(P, { name: c ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: e,
      children: t,
      icon: n,
      dropdown: o,
      buttonProps: r,
      dropdownProps: a,
      noArrow: l,
      noStyle: c,
      show: d,
      onToggle: h,
      isLoading: u,
      errorMessage: p,
      fixed: m,
      onMouseEnter: g,
      onMouseLeave: b,
      allowEscClose: y,
      destroyOnClose: _,
      ...v
    } = this.props, { dropdownOpen: S, pristine: C } = this.state, x = f({ [ns.root]: ns.root }, e);
    return /* @__PURE__ */ s.jsx(ln.Provider, { value: this.contextState, children: /* @__PURE__ */ s.jsx("div", { ...v, className: x, ref: this.buttonWrapperRef, children: /* @__PURE__ */ s.jsxs("div", { className: ns.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ s.jsx(
        Je,
        {
          restoreFocus: this.buttonRef,
          ...a,
          isOpen: S,
          onClose: this.close,
          isLoading: u,
          errorMessage: p,
          fixed: m,
          children: (S || !C && !_) && o
        }
      )
    ] }) }) });
  }
}
const zl = "h-collapseCard--header__header", Vl = "h-collapseCard--header__headerOpen", Kl = "h-collapseCard--header__headerHasDropdown", Ul = "h-collapseCard--header__headerStatic", ql = "h-collapseCard--header__titleWrapper", Gl = "h-collapseCard--header__title", Yl = "h-collapseCard--header__chevronPlaceholder", We = {
  header: zl,
  headerOpen: Vl,
  headerHasDropdown: Kl,
  headerStatic: Ul,
  titleWrapper: ql,
  title: Gl,
  chevronPlaceholder: Yl
};
class Ql extends k {
  // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children
  static displayName = "CollapseCard.Header";
  static defaultProps = {
    title: ""
  };
  getRootClassName(e) {
    const { dropdown: t, className: n, nonCollapsible: o } = this.props;
    return f(
      We.header,
      {
        [We.headerOpen]: e,
        [We.headerHasDropdown]: !!t,
        [We.headerStatic]: !!o
      },
      n
    );
  }
  render() {
    const {
      children: e,
      className: t,
      title: n,
      avatar: o,
      dropdown: r,
      onDropdownToggle: a,
      dropdownTrigger: l,
      slotBeforeTitle: c,
      slotAfterTitle: d,
      wrap: h = "nowrap",
      compact: u,
      nonCollapsible: p,
      ...m
    } = this.props;
    return /* @__PURE__ */ s.jsx(Hs.Consumer, { children: ({ isOpen: g, onToggle: b }) => {
      const y = this.getRootClassName(g);
      return /* @__PURE__ */ s.jsxs(
        "div",
        {
          ...m,
          onClick: p ? void 0 : b,
          className: y,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ s.jsxs(
              B,
              {
                alignItems: "center",
                padding: u ? "200 0" : "400 0",
                className: We.titleWrapper,
                children: [
                  c,
                  o,
                  /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      className: We.titleWrapper,
                      onMouseDown: (_) => _.stopPropagation(),
                      children: /* @__PURE__ */ s.jsx(
                        $.Paragraph,
                        {
                          variant: "1",
                          wrap: h,
                          className: We.title,
                          children: e
                        }
                      )
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsxs(B, { alignItems: "center", children: [
              d,
              !!r && /* @__PURE__ */ s.jsx(
                ct,
                {
                  onClick: (_) => _.stopPropagation(),
                  icon: l ? void 0 : "dots-h",
                  dropdown: r,
                  buttonProps: { variant: "tertiary" },
                  onToggle: a,
                  children: l
                }
              ),
              p ? (
                // Reserve the chevron's footprint so a slotAfter (e.g. a
                // timestamp) stays column-aligned with collapsible siblings.
                /* @__PURE__ */ s.jsx("span", { className: We.chevronPlaceholder, "aria-hidden": !0 })
              ) : /* @__PURE__ */ s.jsx(
                U,
                {
                  icon: g ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
const Xl = "h-collapseCard--line__line", Zl = "h-collapseCard--line__lineHasLabel", Jl = "h-collapseCard--line__value", ec = "h-collapseCard--line__lineHideOverflow", pn = {
  line: Xl,
  lineHasLabel: Zl,
  value: Jl,
  lineHideOverflow: ec
};
class tc extends k {
  render() {
    const { label: e, children: t, className: n, hideOverflow: o, ...r } = this.props, a = f(
      {
        [pn.line]: !0,
        [pn.lineHasLabel]: !!e,
        [pn.lineHideOverflow]: o
      },
      n
    );
    return /* @__PURE__ */ s.jsxs("li", { ...r, className: a, children: [
      e && /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: e }),
      e ? /* @__PURE__ */ s.jsx("span", { className: pn.value, children: t }) : t
    ] });
  }
}
const nc = "h-collapseCard--readMore__readMore", sc = {
  readMore: nc
};
class oc extends k {
  render() {
    const { onClick: e, url: t, children: n, className: o, ...r } = this.props, a = f({ [sc.readMore]: !0 }, o);
    return t ? /* @__PURE__ */ s.jsx($.ExternalLink, { ...r, href: t, className: a, children: n }) : /* @__PURE__ */ s.jsx(
      te,
      {
        variant: "secondary",
        ...r,
        onClick: e,
        className: a,
        children: n
      }
    );
  }
}
const rc = "h-collapseCard--status__status", ic = {
  status: rc
};
class ac extends k {
  render() {
    const { children: e, className: t, ...n } = this.props, o = f({ [ic.status]: !0 }, t);
    return /* @__PURE__ */ s.jsx("li", { ...n, className: o, children: e });
  }
}
class lc extends k {
  static defaultProps = {
    isOpen: !1
  };
  constructor(e) {
    super(e), this.handleToggle = this.handleToggle.bind(this);
  }
  static Line = tc;
  static Header = Ql;
  static Content = Tl;
  static ReadMore = oc;
  static Status = ac;
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(e) {
    return e?.type?.displayName === "CollapseCard.Header" && Ie(e);
  }
  isContent(e) {
    return e?.type?.displayName === "CollapseCard.Content" && Ie(e);
  }
  getHeaderChildren() {
    return Re.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Re.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: e } = this.props;
    return f(Il.card, e);
  }
  render() {
    const {
      className: e,
      onToggle: t,
      isOpen: n,
      children: o,
      containerRef: r,
      ...a
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Hs.Provider,
      {
        value: { isOpen: n, onToggle: this.handleToggle },
        children: /* @__PURE__ */ s.jsxs(
          "div",
          {
            ...a,
            ref: r,
            className: this.getRootClassName(),
            children: [
              this.getHeaderChildren(),
              this.getContentChildren()
            ]
          }
        )
      }
    );
  }
}
const $k = rn(lc, {
  fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), cc = "h-collapsible--collapsible__root", dc = "h-collapsible--collapsible__collapsible", hc = "h-collapsible--collapsible__children", ss = {
  root: cc,
  collapsible: dc,
  children: hc
};
class Ok extends k {
  childrenRef;
  resizeObserver = null;
  constructor(e) {
    super(e), this.childrenRef = O(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: e.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentDidUpdate(e) {
    e.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentWillUnmount() {
    this.disconnectResizeObserver();
  }
  setupResizeObserver() {
    this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.measureChildrenHeight();
    }), this.resizeObserver.observe(this.childrenRef.current));
  }
  disconnectResizeObserver() {
    this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  measureChildrenHeight() {
    const e = this.childrenRef.current;
    e && this.setState({
      childrenHeight: e.offsetHeight
    });
  }
  render() {
    const { className: e, header: t, isOpen: n, children: o, ...r } = this.props, { childrenHeight: a } = this.state, l = f(
      {
        [ss.root]: !0
      },
      e
    ), c = {
      maxHeight: n ? a : 0
    };
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("div", { children: t }) }),
      !!o && /* @__PURE__ */ s.jsx("div", { style: c, className: ss.collapsible, children: /* @__PURE__ */ s.jsx("span", { className: ss.children, ref: this.childrenRef, children: o }) })
    ] });
  }
}
const uc = "h-colorPicker--colorPicker__root", pc = {
  root: uc
}, mc = "h-colorPicker-input--colorPickerInput__input", gc = {
  input: mc
}, fc = ({
  className: i,
  ...e
}) => /* @__PURE__ */ s.jsx(Be, { prefix: "#", children: /* @__PURE__ */ s.jsx(
  xi,
  {
    className: f(gc.input, i),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...e
  }
) }), bc = "h-colorPicker-presets--colorPickerPresets__root", yc = {
  root: bc
}, xc = "h-colorPicker-presets-preset--colorPickerPreset__root", _c = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", Cc = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", vc = "h-colorPicker-presets-preset--colorPickerPreset__preset", mn = {
  root: xc,
  rootIsSelected: _c,
  rootAlpha: Cc,
  preset: vc
}, wc = ({
  color: i,
  onSelect: e,
  isSelected: t,
  alpha: n,
  className: o
}) => /* @__PURE__ */ s.jsx(
  "li",
  {
    className: f(mn.root, o, {
      [mn.rootIsSelected]: t,
      [mn.rootAlpha]: n
    }),
    children: /* @__PURE__ */ s.jsx(
      "button",
      {
        type: "button",
        "aria-label": i,
        className: mn.preset,
        style: { backgroundColor: i },
        onClick: () => {
          e?.(i);
        }
      }
    )
  }
);
Rs([Es]);
const Sc = ({
  presets: i,
  className: e,
  onChange: t,
  color: n,
  alpha: o,
  ...r
}) => /* @__PURE__ */ s.jsx(
  B,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: f(yc.root, e),
    ...r,
    children: i.map((a) => /* @__PURE__ */ s.jsx(
      wc,
      {
        onSelect: t,
        color: a,
        isSelected: n === (a.startsWith("#") ? a : Ln(a).toHex()),
        alpha: o
      },
      a
    ))
  }
);
Rs([Es]);
const Ic = ({
  onChange: i,
  color: e,
  alpha: t,
  className: n,
  ...o
}) => {
  const r = F((a) => {
    setTimeout(() => {
      i?.(Ln(a).toHex());
    });
  }, []);
  return t ? /* @__PURE__ */ s.jsx(
    Ci,
    {
      className: n,
      color: Ln(e ?? "").toRgbString(),
      onChange: r,
      ...o
    }
  ) : /* @__PURE__ */ s.jsx(
    _i,
    {
      className: n,
      color: e,
      onChange: i,
      ...o
    }
  );
};
Rs([Es]);
const kc = "colorPickerTestId", Un = ({
  className: i,
  color: e,
  onChange: t,
  alpha: n,
  children: o,
  ...r
}) => {
  const [a, l] = V();
  return q(() => {
    const c = e?.startsWith("#") ? e : Ln(e ?? "").toHex();
    l(c);
  }, [e]), /* @__PURE__ */ s.jsx(
    B,
    {
      flexDirection: "column",
      gap: "250",
      className: f(pc.root, i),
      "data-testid": kc,
      ...r,
      children: Re.map(
        o,
        (c) => Ie(c) && sn(c, {
          onChange: t,
          color: a,
          alpha: n,
          ...c.props
        })
      )
    }
  );
};
Un.Input = fc;
Un.Sliders = Ic;
Un.Presets = Sc;
const Dc = "h-columns--columns__root", Tc = {
  root: Dc
}, jc = "1fr", Nc = W(function({ as: e = "div", children: t, className: n, style: o, ...r }, a) {
  const c = Re.toArray(t).map((d) => d.props.size ?? jc).join(" ");
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...r,
      ref: a,
      className: f(Tc.root, n),
      style: { ...o, gridTemplateColumns: c },
      children: t
    }
  );
}), Fc = "h-columns-column--column__root", Pc = {
  root: Fc
}, Rc = "h-columns-column-row--columnRow__root", Ec = "h-columns-column-row--columnRow__noMinHeight", Lc = "h-columns-column-row--columnRow__noVerticalPadding", Ac = "h-columns-column-row--columnRow__noHorizontalPadding", $c = "h-columns-column-row--columnRow__borderTop", Oc = "h-columns-column-row--columnRow__borderBottom", Bc = "h-columns-column-row--columnRow__scrollable", Hc = "h-columns-column-row--columnRow__slottable", Me = {
  root: Rc,
  noMinHeight: Ec,
  noVerticalPadding: Lc,
  noHorizontalPadding: Ac,
  borderTop: $c,
  borderBottom: Oc,
  scrollable: Bc,
  slottable: Hc
}, Wc = 1, Mc = W(function({
  as: e = "div",
  children: t,
  className: n,
  noVerticalPadding: o,
  noHorizontalPadding: r,
  noMinHeight: a,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...m
}, g) {
  const b = f(n, Me.root, {
    [Me.slottable]: u,
    [Me.noVerticalPadding]: u ?? o,
    [Me.noHorizontalPadding]: r,
    [Me.borderTop]: l,
    [Me.borderBottom]: c,
    [Me.scrollable]: d,
    [Me.noMinHeight]: a
  });
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...m,
      ref: g,
      className: b,
      style: {
        ...p,
        flexGrow: h ?? d ? Wc : void 0
      },
      children: t
    }
  );
}), zc = "h-columns-column-slot--columnSlot__root", Vc = "h-columns-column-slot--columnSlot__noVerticalPadding", po = {
  root: zc,
  noVerticalPadding: Vc
}, Kc = ({
  children: i,
  className: e,
  noVerticalPadding: t,
  placement: n = "start"
}) => {
  const o = f(po.root, e, {
    [po.noVerticalPadding]: t
  });
  return /* @__PURE__ */ s.jsx(
    B,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: n,
      className: o,
      children: i
    }
  );
}, ue = ({
  as: i,
  children: e,
  className: t
}) => /* @__PURE__ */ s.jsx(
  B,
  {
    as: i,
    flexDirection: "column",
    className: f(Pc.root, t),
    children: e
  }
);
ue.Row = Mc;
ue.Slot = Kc;
const Uc = "h-copyToClipboard--copyToClipboard__copyToClipboard", qc = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", mo = {
  copyToClipboard: Uc,
  copyToClipboardTooltip: qc
};
class Gc extends me {
  timerHandle;
  static defaultProps = {
    tooltip: !0,
    disabled: !1,
    transitionDuration: 2e3,
    clickedProps: {}
  };
  constructor(e) {
    super(e), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(e) {
    const t = document.body;
    if (!e || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = e, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", t.appendChild(n), n.select(), document.execCommand("copy"), t.removeChild(n);
  }
  handleClick(e) {
    const { disabled: t, textToCopy: n, transitionDuration: o, onClick: r } = this.props;
    t || (typeof r == "function" && r(e), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, o);
    }));
  }
  render() {
    const { className: e, children: t, clickedProps: n, tooltip: o } = this.props, { clicked: r } = this.state, a = f(
      mo.copyToClipboard,
      { [mo.copyToClipboardTooltip]: r && o },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { className: a, children: Re.map(t, (l) => Ie(l) ? sn(l, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...r ? n : {}
    }) : l) });
  }
}
class Bk extends k {
  render() {
    const { buttonProps: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx(Gc, { ...t, children: /* @__PURE__ */ s.jsx(U, { icon: "copy", variant: "secondary", ...e }) });
  }
}
const Yc = "h-simplePagination--simplePagination__paginationButton", go = {
  paginationButton: Yc
}, Qc = "simplePaginationTestId", Xc = ({
  nextButtonClick: i = L,
  previousButtonClick: e = L,
  nextButtonText: t = "Next page",
  previousButtonText: n = "Previous page",
  nextButtonDisabled: o = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: a = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ s.jsxs("div", { "data-testid": Qc, ...p, children: [
  !l && /* @__PURE__ */ s.jsx(
    te,
    {
      disabled: r || h,
      onClick: e,
      variant: "secondary",
      ...d,
      className: f(
        go.paginationButton,
        d?.className
      ),
      children: h ? u : n
    }
  ),
  !a && /* @__PURE__ */ s.jsx(
    te,
    {
      disabled: o || h,
      onClick: i,
      variant: "secondary",
      ...c,
      className: f(
        go.paginationButton,
        c?.className
      ),
      children: h ? u : t
    }
  )
] }), qn = ke(
  void 0
);
var le = /* @__PURE__ */ ((i) => (i.Foot = "table-foot", i.Body = "table-body", i.Head = "table-head", i.Row = "table-row", i.PaginationRow = "table-pagination-row", i.Td = "table-body-cell", i.Th = "table-header-cell", i.RowExpansionTrigger = "table-row-expansion-trigger", i.LoadingRow = "table-loading-row", i.LoadingFailedRow = "table-loading-failed-row", i.EmptyRow = "table-empty-row", i))(le || {});
const Zc = "h-table-tfoot--tfoot__root", Jc = "h-table-tfoot--tfoot__rootIsLoading", fo = {
  root: Zc,
  rootIsLoading: Jc
}, vr = ke(
  void 0
), bo = ({ className: i, children: e, ...t }, n) => /* @__PURE__ */ s.jsx(qn.Consumer, { children: (o) => o?.status.loading && ["spinner"].includes(o?.loading.loadingStrategy) ? null : /* @__PURE__ */ s.jsx(vr.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ s.jsx(
  "tfoot",
  {
    ...t,
    ref: n,
    className: f(
      {
        [fo.rootIsLoading]: o?.status.loading
      },
      fo.root,
      i
    ),
    "data-testid": le.Foot,
    children: e
  }
) }) }), ed = Object.assign(W(bo), { name: bo.name }), td = "h-table-thead--thead__root", nd = "h-table-thead--thead__rootIsLoading", yo = {
  root: td,
  rootIsLoading: nd
}, wr = ke(
  void 0
), xo = ({ className: i, ...e }, t) => /* @__PURE__ */ s.jsx(qn.Consumer, { children: (n) => {
  const o = f(yo.root, i, {
    [yo.rootIsLoading]: n?.status.loading
  });
  return /* @__PURE__ */ s.jsx(wr.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ s.jsx(
    "thead",
    {
      ...e,
      ref: t,
      className: o,
      "data-testid": le.Head
    }
  ) });
} }), sd = Object.assign(W(xo), { name: xo.name }), Ft = (i) => {
  const e = Oe(qn);
  if (!e)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const t = Oe(wr) || {
    isTableHead: !1
  }, n = Oe(vr) || {
    isTableFoot: !1
  };
  return i.children({
    ...e,
    ...t,
    ...n
  });
}, od = "h-table-tableFooter--tableFooter__root", rd = "h-table-tableFooter--tableFooter__rootIsLoading", _o = {
  root: od,
  rootIsLoading: rd
}, Co = ({ children: i, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Ft, { children: ({ status: o }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: n,
    className: f(
      {
        [_o.rootIsLoading]: o.loading
      },
      _o.root,
      e
    ),
    ...t,
    children: i
  }
) }), Ws = Object.assign(W(Co), {
  name: Co.name
});
function id(i) {
  return Re.toArray(i).reduce(
    (e, t) => {
      const n = t;
      return n.type === Ws ? e.footers.push(n) : e.children.push(n), e;
    },
    { children: [], footers: [] }
  );
}
var $n = /* @__PURE__ */ ((i) => (i.PageNumber = "page-number", i.PrevPageButton = "prev-page-button", i.NextPageButton = "next-page-button", i))($n || {});
const ad = "h-pagination--pageNumber__button", ld = "h-pagination--pageNumber__text", cd = "h-pagination--pageNumber__textSelected", os = {
  button: ad,
  text: ld,
  textSelected: cd
}, dd = ({
  number: i,
  isSelected: e = !1,
  onClick: t
}) => {
  const n = f(os.text, {
    [os.textSelected]: e
  });
  return /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
    te,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => t(i),
      "data-testid": $n.PageNumber,
      className: os.button,
      children: /* @__PURE__ */ s.jsx("span", { className: n, children: i })
    }
  ) });
}, hd = "h-pagination--pagination__root", ud = "h-pagination--pagination__pageNumberSeparatorWrapper", vo = {
  root: hd,
  pageNumberSeparatorWrapper: ud
};
class pd extends me {
  static defaultProps = {
    pageRangeDisplayed: 6
  };
  constructor(e) {
    super(e), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: e, pageCount: t, pageRangeDisplayed: n } = this.props, o = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [e, t, n].every(
      o
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(e) {
    const { currentPage: t, onPageChange: n } = this.props;
    e !== t && n(e);
  }
  areAllPagedDisplayable() {
    const { pageCount: e, pageRangeDisplayed: t } = this.props;
    return t >= e;
  }
  leadingTruncationIsNeeded() {
    const { start: t } = this.calculateMiddlePagesRange();
    return t - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: e } = this.props, { start: t, length: n } = this.calculateMiddlePagesRange(), o = t - 1 + n;
    return e - o > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: e } = this.props;
    return e - 2;
  }
  calculateMiddlePagesRange(e) {
    const { pageCount: t, currentPage: n } = this.props, o = Math.max(
      this.getMiddlePagesLength() - (e?.extraPadding ?? 0),
      1
    ), r = o % 2 === 0 ? o / 2 - 1 : Math.floor(o / 2);
    return { start: Fn(
      n - r,
      2,
      t - o
    ), length: o };
  }
  createPageNumbers(e, t = 1) {
    return Array.from({ length: e }, (n, o) => o + t);
  }
  renderPageNumbers(e, t = 1) {
    return this.createPageNumbers(e, t).map(
      (n) => this.renderSinglePageNumber(n)
    );
  }
  renderSinglePageNumber(e) {
    const { currentPage: t } = this.props, n = e === t;
    return /* @__PURE__ */ s.jsx(
      dd,
      {
        number: e,
        isSelected: n,
        onClick: this.handlePageSelect
      },
      e
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(e = 0) {
    return /* @__PURE__ */ s.jsx("li", { className: vo.pageNumberSeparatorWrapper, children: /* @__PURE__ */ s.jsx(P, { name: "dots-h" }) }, `gap-${e}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: e } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(e)] : this.renderSinglePageNumber(e);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: n, length: o } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(o, n);
    }
    const { start: e, length: t } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(t, e);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: e } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ s.jsxs("ul", { className: f(vo.root, e), children: [
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        U,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": $n.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        U,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": $n.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
const wo = ({ children: i, ...e }, t) => /* @__PURE__ */ s.jsx(Ft, { children: ({ pagination: n }) => !n.paginated || n.pageCount <= 1 ? null : /* @__PURE__ */ s.jsx(Ws, { children: /* @__PURE__ */ s.jsx("div", { ref: t, ...e, "data-testid": le.PaginationRow, children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
  pd,
  {
    currentPage: n.selectedPage,
    pageCount: n.pageCount,
    onPageChange: n.onPageChange,
    pageRangeDisplayed: n.pageRangeDisplayed
  }
) }) }) }) }), md = Object.assign(W(wo), {
  name: wo.name
}), gd = "h-table-tbody--tbody__root", fd = "h-table-tbody--tbody__rootIsLoading", bd = "h-table-tbody--tbody__rootIsLoadingFade", rs = {
  root: gd,
  rootIsLoading: fd,
  rootIsLoadingFade: bd
}, yd = "h-emptyState--emptyState__textWrapper", xd = "h-emptyState--emptyState__rootSmall", _d = "h-emptyState--emptyState__rootLarge", is = {
  textWrapper: yd,
  rootSmall: xd,
  rootLarge: _d
}, Cd = ({
  className: i,
  title: e,
  description: t,
  icon: n = "info",
  iconColor: o = "neutral.500",
  size: r = "large",
  buttonProps: a
}) => {
  const l = f(
    {
      [is.rootSmall]: r === "small",
      [is.rootLarge]: r === "large"
    },
    i
  );
  return /* @__PURE__ */ s.jsxs(
    B,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        n && /* @__PURE__ */ s.jsx(P, { name: n, size: 20, color: Zt(o) }),
        /* @__PURE__ */ s.jsxs(
          B,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: is.textWrapper,
            children: [
              /* @__PURE__ */ s.jsx($.Paragraph, { variant: "1", children: e }),
              /* @__PURE__ */ s.jsx(
                $.Paragraph,
                {
                  variant: "2",
                  as: typeof t == "string" ? "p" : "div",
                  children: t
                }
              )
            ]
          }
        ),
        a?.children && /* @__PURE__ */ s.jsx(te, { ...a })
      ]
    }
  );
};
function vd(i) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": le.EmptyRow, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ s.jsx(Cd, { ...i }) }) }) });
}
function wd({
  onRetry: i,
  ...e
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": le.LoadingFailedRow, ...e, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    B,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: "Something went wrong..." }),
        i && /* @__PURE__ */ s.jsx(te, { variant: "tertiary", onClick: i, children: "Try again" })
      ]
    }
  ) }) });
}
function Sd({
  ...i
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": le.LoadingRow, ...i, children: /* @__PURE__ */ s.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    B,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx($s, {}),
        /* @__PURE__ */ s.jsx(ie, { margin: "300", children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const So = ({ children: i, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Ft, { children: ({
  status: { loading: o, loadingFailed: r, onLoadingRetry: a, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !o, h = ["spinner"].includes(c) ? !o && !d : !d;
  return /* @__PURE__ */ s.jsxs(
    "tbody",
    {
      ...t,
      "data-testid": le.Body,
      ref: n,
      className: f(
        {
          [rs.rootIsLoading]: o,
          [rs.rootIsLoadingFade]: o && c === "fade"
        },
        rs.root,
        e
      ),
      children: [
        c === "spinner" && o && /* @__PURE__ */ s.jsx(Sd, {}),
        d && /* @__PURE__ */ s.jsx(wd, { onRetry: a }),
        l && /* @__PURE__ */ s.jsx(vd, { ...l }),
        h && i
      ]
    }
  );
} }), Id = Object.assign(W(So), { name: So.name }), kd = "h-table-td--td__root", Dd = "h-table-td--td__rootExtraPaddingForFirstChild", Td = "h-table-td--td__rootStickyFooterTd", as = {
  root: kd,
  rootExtraPaddingForFirstChild: Dd,
  rootStickyFooterTd: Td
}, Io = ({ className: i, children: e, ...t }, n) => /* @__PURE__ */ s.jsx(Ft, { children: ({ rows: o, presentation: r, isTableFoot: a }) => {
  const l = f(
    as.root,
    {
      [as.rootExtraPaddingForFirstChild]: !o.expandableRows,
      [as.rootStickyFooterTd]: r.stickyFooter === !0 && a === !0
    },
    i
  );
  return /* @__PURE__ */ s.jsx(
    ie,
    {
      as: "td",
      ref: n,
      className: l,
      ...t,
      "data-testid": le.Td,
      children: e
    }
  );
} }), it = Object.assign(W(Io), { name: Io.name }), jd = "h-table-th--th__root", Nd = "h-table-th--th__rootSticky", Fd = "h-table-th--th__rootShowBG", Pd = "h-table-th--th__rootClickable", Rd = "h-table-th--th__icon", Ed = "h-table-th--th__contentWrapper", Ld = "h-table-th--th__tooltip", tt = {
  root: jd,
  rootSticky: Nd,
  rootShowBG: Fd,
  rootClickable: Pd,
  icon: Rd,
  contentWrapper: Ed,
  tooltip: Ld
};
class ko extends k {
  context = void 0;
  columnIsInSortableColumns() {
    return this.context?.sorting.sortableColumns?.some(
      (e) => e === this.props.columnId
    ) ?? !0;
  }
  getContextualInfo() {
    const { columnId: e } = this.props, { context: t } = this;
    return {
      sortByThisColumn: t?.sorting.sortStatus?.sortBy === e,
      sortDirection: t?.sorting.sortStatus?.direction,
      columnIsSortable: t?.sorting.sortable && !_e(e) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(e) {
    const { sortByThisColumn: t, sortDirection: n } = this.getContextualInfo(), o = {
      sortBy: e,
      direction: "asc"
    };
    if (!t)
      return o;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return o;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: e,
          direction: "desc"
        };
      default:
        return o;
    }
  }
  getClickHandler() {
    const { onClick: e } = this.props, { context: t } = this;
    return (n) => {
      const { columnIsSortable: o } = this.getContextualInfo(), { columnId: r } = this.props;
      e?.(n), o && !_e(r) && t?.sorting.onSortChange(this.getTheNewSortDirection(r));
    };
  }
  renderIcon(e) {
    return e ? /* @__PURE__ */ s.jsx(
      P,
      {
        className: tt.icon,
        name: e === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ s.jsx(Ft, { children: (e) => {
      this.context = e;
      const { sorting: t, presentation: n } = e;
      t.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: o,
        children: r,
        tooltip: a,
        columnId: l,
        thRef: c,
        ...d
      } = this.props, { sortByThisColumn: h, columnIsSortable: u, sortDirection: p } = this.getContextualInfo(), m = f(
        tt.root,
        {
          [tt.rootClickable]: u,
          [tt.rootSticky]: n.stickyHeader,
          [tt.rootShowBG]: n.headerWithBackground
        },
        o
      ), g = f({
        [tt.tooltip]: a
      });
      return /* @__PURE__ */ s.jsx(
        ie,
        {
          as: "th",
          ...d,
          ref: c,
          className: m,
          onClick: this.getClickHandler(),
          "data-testid": le.Th,
          children: /* @__PURE__ */ s.jsxs("span", { className: tt.contentWrapper, children: [
            /* @__PURE__ */ s.jsx(se, { content: a, disabled: !a, children: /* @__PURE__ */ s.jsx("span", { className: g, children: r }) }),
            h && this.renderIcon(p)
          ] })
        }
      );
    } });
  }
}
const Is = Object.assign(
  W(
    function(e, t) {
      return /* @__PURE__ */ s.jsx(ko, { ...e, thRef: t });
    }
  ),
  { name: ko.name }
), Ad = (i) => i === !1, $d = "h-table-tr--tr__trHoverable", Od = "h-table-tr--tr__expansionTriggerWrapper", Bd = "h-table-tr--tr__expansionTriggerWrapperExpanded", Hd = "h-table-tr--tr__checkboxCell", Wd = "h-table-tr--tr__checkboxCellExpanded", Md = "h-table-tr--tr__expandedRowContentWrapper", we = {
  trHoverable: $d,
  expansionTriggerWrapper: Od,
  expansionTriggerWrapperExpanded: Bd,
  checkboxCell: Hd,
  checkboxCellExpanded: Wd,
  expandedRowContentWrapper: Md
}, zd = ({
  rowId: i,
  isExpandable: e,
  isExpanded: t,
  onExpansionToggle: n,
  expandableContent: o,
  isSelectable: r,
  isSelected: a,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = f(u.className, {
    [we.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": le.Row,
        children: [
          e && /* @__PURE__ */ s.jsx(
            it,
            {
              className: f(we.expansionTriggerWrapper, {
                [we.expansionTriggerWrapperExpanded]: t
              }),
              children: o && /* @__PURE__ */ s.jsx(
                U,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right",
                  "data-testid": le.RowExpansionTrigger,
                  onClick: () => {
                    _e(i) || n(i);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ s.jsx(
            it,
            {
              className: f(we.checkboxCell, {
                [we.checkboxCellExpanded]: t
              }),
              children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
                an,
                {
                  checked: a,
                  name: `selection-trigger-${i}`,
                  id: `selection-trigger-${i}`,
                  onChange: () => {
                    _e(i) || l(i);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    e && t && /* @__PURE__ */ s.jsxs("tr", { "data-testid": le.Row, children: [
      /* @__PURE__ */ s.jsx(it, { className: we.expansionTriggerWrapper }),
      r && /* @__PURE__ */ s.jsx(it, { className: we.checkboxCell }),
      /* @__PURE__ */ s.jsx(
        it,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: we.expandedRowContentWrapper,
          children: o
        }
      )
    ] })
  ] });
}, Vd = ({
  isExpandable: i,
  children: e,
  trRef: t,
  ...n
}) => /* @__PURE__ */ s.jsxs("tr", { ...n, ref: t, "data-testid": le.Row, children: [
  i && /* @__PURE__ */ s.jsx(it, { className: we.expansionTriggerWrapper, children: /* @__PURE__ */ s.jsx("span", {}) }),
  e
] }), Kd = ({
  isExpandable: i,
  isSelectable: e,
  allRowsSelected: t,
  allRowsSelectedIndeterminate: n,
  onAllRowsSelect: o,
  children: r,
  trRef: a,
  ...l
}) => /* @__PURE__ */ s.jsxs("tr", { ...l, ref: a, "data-testid": le.Row, children: [
  i && /* @__PURE__ */ s.jsx(Is, { className: we.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ s.jsx("span", {}) }),
  e && /* @__PURE__ */ s.jsx(Is, { className: we.checkboxCell, columnId: null, children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
    an,
    {
      checked: t,
      indeterminate: n,
      onChange: o,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class Do extends k {
  context = void 0;
  isRowExpanded(e, t) {
    return e.includes(t);
  }
  hasSelectableRow() {
    const { rowId: e } = this.props;
    return this.context?.rows.selectableRows === !0 && !_e(e);
  }
  hasExpandableRow() {
    const { expandableContent: e, rowId: t } = this.props;
    return this.context?.rows.expandableRows === !0 && !_e(e) && !_e(t);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(Ad);
  }
  rowIdIsPresent(e) {
    return !_e(e);
  }
  render() {
    const { children: e, expandableContent: t, rowId: n, ...o } = this.props;
    return /* @__PURE__ */ s.jsx(Ft, { children: (r) => {
      this.context = r;
      const { rows: a } = r;
      if (r.isTableHead)
        return /* @__PURE__ */ s.jsx(
          Kd,
          {
            ...o,
            isExpandable: a.expandableRows,
            isSelectable: a.selectableRows,
            allRowsSelected: a.allRowsSelected,
            allRowsSelectedIndeterminate: a.allRowsSelectedIndeterminate,
            onAllRowsSelect: a.onAllRowsSelect,
            children: e
          }
        );
      if (r.isTableFoot)
        return /* @__PURE__ */ s.jsx(Vd, { ...o, isExpandable: a.expandableRows, children: e });
      const l = _e(n) ? !1 : this.isRowExpanded(a.expandedRows, n), c = _e(n) ? !1 : a.selectedRowIds.includes(n);
      return /* @__PURE__ */ s.jsx(
        zd,
        {
          ...o,
          rowId: n,
          isExpanded: l,
          isSelected: c,
          onSelect: a.onRowSelect,
          isExpandable: a.expandableRows,
          expandableContent: t,
          isSelectable: a.selectableRows,
          onExpansionToggle: a.onExpansionToggle,
          isHoverable: r.presentation.hoverable,
          children: e
        }
      );
    } });
  }
}
const Ud = Object.assign(
  W(function(e, t) {
    return /* @__PURE__ */ s.jsx(Do, { ...e, trRef: t });
  }),
  { name: Do.name }
), qd = "h-table--table__wrapper", Gd = "h-table--table__wrapperIsFramed", Yd = "h-table--table__wrapperIsLoading", Qd = "h-table--table__innerWrapper", Xd = "h-table--table__wrapperIsDisabled", Zd = "h-table--table__table", pt = {
  wrapper: qd,
  wrapperIsFramed: Gd,
  wrapperIsLoading: Yd,
  innerWrapper: Qd,
  wrapperIsDisabled: Xd,
  table: Zd
};
class On extends k {
  static defaultProps = {
    headerWithBackground: !0,
    stickyHeader: !1,
    stickyFooter: !1,
    framed: !0,
    hoverable: !1,
    loadingStrategy: "spinner"
  };
  constructor(e) {
    super(e), this.state = {
      expandedRows: e.expandableRowsProps?.initiallyExpandedRows ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  static fallback = /* @__PURE__ */ s.jsx(
    B,
    {
      justifyContent: "center",
      alignItems: "center",
      style: { minHeight: "10vh" },
      children: /* @__PURE__ */ s.jsx($.Paragraph, { children: "Oops! something went wrong..." })
    }
  );
  handleExpansionToggle(e) {
    this.state.expandedRows.includes(e) ? this.setState(({ expandedRows: t }) => ({
      expandedRows: t.filter((n) => n !== e)
    })) : this.setState(({ expandedRows: t }) => ({
      expandedRows: [...t, e]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: e,
        stickyHeader: t,
        stickyFooter: n,
        sortingProps: o,
        paginationProps: r,
        selectableRowsProps: a,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: m
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!e,
        stickyHeader: !!t,
        stickyFooter: !!n,
        hoverable: !!m
      },
      sorting: {
        sortable: !!o,
        sortableColumns: o?.sortableColumns,
        sortStatus: o?.sortStatus ?? null,
        onSortChange: o?.onSortChange ?? L
      },
      pagination: {
        paginated: !!r,
        selectedPage: r?.selectedPage ?? 1,
        pageCount: r?.pageCount ?? 1,
        onPageChange: r?.onPageChange ?? L,
        pageRangeDisplayed: r?.pageRangeDisplayed
      },
      rows: {
        expandableRows: l?.expandableRows ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!a,
        selectedRowIds: a?.selectedRowIds ?? [],
        onRowSelect: a?.onRowSelect ?? L,
        onAllRowsSelect: a?.onAllRowsSelect ?? L,
        allRowsSelected: a?.allRowsSelected ?? !1,
        allRowsSelectedIndeterminate: a?.allRowsSelectedIndeterminate ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: e,
      className: t,
      children: n,
      wrapperProps: o,
      wrapperRef: r,
      innerWrapperClassName: a,
      nativeProps: l,
      tableRef: c
    } = this.props, d = id(n), h = f(pt.wrapper, o?.className, {
      [pt.wrapperIsFramed]: e,
      [pt.wrapperIsLoading]: this.props.loading,
      [pt.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = f(
      {
        [pt.innerWrapper]: !0
      },
      a
    ), p = f(pt.table, t), m = this.getContextValue();
    return /* @__PURE__ */ s.jsx(jt, { fallback: On.fallback, children: /* @__PURE__ */ s.jsx(qn.Provider, { value: m, children: /* @__PURE__ */ s.jsxs("div", { ...o, className: h, children: [
      /* @__PURE__ */ s.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ s.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      m.pagination.paginated && /* @__PURE__ */ s.jsx(md, {}),
      !m.pagination.paginated && d.footers
    ] }) }) });
  }
}
const pe = Object.assign(
  W(
    function(e, t) {
      return /* @__PURE__ */ s.jsx(On, { ...e, tableRef: t });
    }
  ),
  {
    name: On.name,
    Thead: sd,
    Tbody: Id,
    Tfoot: ed,
    Tr: Ud,
    Th: Is,
    Td: it,
    Footer: Ws
  }
), Jd = "h-helpIcon--helpIcon__infoIcon", eh = {
  infoIcon: Jd
};
class Ms extends k {
  render() {
    const {
      side: e,
      text: t,
      title: n,
      disabled: o,
      requireClick: r,
      className: a,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      se,
      {
        head: n,
        content: t,
        disabled: o,
        side: e,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ s.jsx("span", { className: f(eh.infoIcon, a), children: /* @__PURE__ */ s.jsx(P, { name: "info" }) })
      }
    );
  }
}
const Sr = ({
  columns: i
}) => /* @__PURE__ */ s.jsx(s.Fragment, { children: i.map(({ label: e, style: t, helpIcon: n, columnId: o }, r) => /* @__PURE__ */ s.jsxs(pe.Th, { columnId: o || e, style: t, children: [
  e,
  n?.title && n?.text && /* @__PURE__ */ s.jsx(Ms, { side: "bottom", ...n })
] }, e || r)) }), th = ({
  columns: i,
  data: e
}) => /* @__PURE__ */ s.jsxs(pe, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ s.jsx(pe.Thead, { children: /* @__PURE__ */ s.jsx(pe.Tr, { children: /* @__PURE__ */ s.jsx(Sr, { columns: i }) }) }),
  /* @__PURE__ */ s.jsx(pe.Tbody, { children: e.map((t, n) => /* @__PURE__ */ s.jsx(pe.Tr, { children: i.map(({ selector: o }, r) => /* @__PURE__ */ s.jsx(pe.Td, { children: o(t) }, r)) }, n)) })
] }), nh = ({
  data: i,
  rowId: e,
  columns: t,
  subTableColumns: n,
  subTableDataSelector: o
}) => /* @__PURE__ */ s.jsx(
  pe.Tr,
  {
    expandableContent: !!(n && o) && /* @__PURE__ */ s.jsx(
      th,
      {
        data: o(i),
        columns: n
      }
    ),
    rowId: e,
    children: t.map(({ selector: r }, a) => /* @__PURE__ */ s.jsx(pe.Td, { children: r(i) }, a))
  }
), Hk = ({
  columns: i,
  subTableColumns: e,
  data: t,
  subTableDataSelector: n,
  tableWrapperProps: o,
  tableInnerWrapperClassName: r,
  paginationProps: a,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: m
}) => {
  const g = i.filter((b) => b.sortable).reduce(
    (b, y) => y.columnId ? [...b, y.columnId] : b,
    []
  );
  return g.length && l && (l.sortableColumns = g), /* @__PURE__ */ s.jsxs(
    pe,
    {
      stickyHeader: !0,
      wrapperProps: o,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(e && n)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: m,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ s.jsx(pe.Thead, { children: /* @__PURE__ */ s.jsx(pe.Tr, { children: /* @__PURE__ */ s.jsx(Sr, { columns: i }) }) }),
        /* @__PURE__ */ s.jsx(pe.Tbody, { children: t.map((b, y) => /* @__PURE__ */ s.jsx(
          nh,
          {
            rowId: u ? u(b) : y,
            data: b,
            columns: i,
            subTableDataSelector: n,
            subTableColumns: e
          },
          y
        )) }),
        a && /* @__PURE__ */ s.jsx(pe.Footer, { children: /* @__PURE__ */ s.jsx(Xc, { ...a }) })
      ]
    }
  );
}, sh = "h-datePickerOld--datePickerDay__root", oh = "h-datePickerOld--datePickerDay__rootActive", rh = "h-datePickerOld--datePickerDay__rootDisabled", ih = "h-datePickerOld--datePickerDay__rootDim", ah = "h-datePickerOld--datePickerDay__label", $t = {
  root: sh,
  rootActive: oh,
  rootDisabled: rh,
  rootDim: ih,
  label: ah
};
class lh extends k {
  render() {
    const {
      className: e,
      dim: t,
      active: n,
      disabled: o,
      children: r,
      onClick: a,
      ...l
    } = this.props, c = f(
      {
        [$t.root]: !0,
        [$t.rootDim]: t,
        [$t.rootActive]: n,
        [$t.rootDisabled]: !n && o
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...l,
        onClick: a,
        className: c,
        disabled: o,
        children: /* @__PURE__ */ s.jsx("span", { className: $t.label, children: r })
      }
    );
  }
}
const ch = "h-datePickerOld--datePickerOld__grid", dh = "h-datePickerOld--datePickerOld__gridItem", hh = "h-datePickerOld--datePickerOld__day", uh = "h-datePickerOld--datePickerOld__month", ph = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", mh = "h-datePickerOld--datePickerOld__timeButtonContainerRight", gh = "h-datePickerOld--datePickerOld__arrowTime", fh = "h-datePickerOld--datePickerOld__arrow", bh = "h-datePickerOld--datePickerOld__dayNames", yh = "h-datePickerOld--datePickerOld__dayName", xh = "h-datePickerOld--datePickerOld__time", _h = "h-datePickerOld--datePickerOld__timeDisplay", Q = {
  grid: ch,
  gridItem: dh,
  day: hh,
  month: uh,
  timeButtonContainerLeft: ph,
  timeButtonContainerRight: mh,
  arrowTime: gh,
  arrow: fh,
  dayNames: bh,
  dayName: yh,
  time: xh,
  timeDisplay: _h
}, Wk = (i) => [0, 6].indexOf(i.getDay()) !== -1;
class Qt extends k {
  static defaultProps;
  static getDateValue(e) {
    const t = e.value instanceof Date ? e.value : /* @__PURE__ */ new Date();
    return new Date(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes()
    );
  }
  constructor(e) {
    super(e);
    const t = Qt.getDateValue(e.input);
    this.state = {
      selectedDate: t,
      showDate: t
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(e) {
    const { input: t } = this.props;
    e.input !== t && this.setState({
      selectedDate: Qt.getDateValue(e.input)
    });
  }
  generateGrid() {
    const { selectedDate: e, showDate: t } = this.state, { input: n, disabled: o, minDate: r, maxDate: a } = this.props, l = [], c = new Date(
      t.getFullYear(),
      t.getMonth(),
      1,
      e.getHours(),
      e.getMinutes()
    ), d = c.getDay() || 7, h = new Date(
      c.getFullYear(),
      c.getMonth() + 1,
      1
    );
    d < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (d - 1));
    const u = Qt.getDateValue(n).getTime();
    let p = 0;
    for (; c < h || c.getDay() !== 1 || p < 6; ) {
      const m = c.getTime(), g = new Date(m);
      l.push({
        date: g,
        label: c.getDate().toString(),
        isThisMonth: c.getMonth() === t.getMonth(),
        selected: m === u,
        disabled: o(c) || !!(a && g > a) || !!(r && g < r)
      }), c.getDay() === 1 && (p += 1), c.setDate(c.getDate() + 1);
    }
    return l;
  }
  goToMonth(e) {
    const { showDate: t } = this.state, n = new Date(t.getTime());
    n.setMonth(t.getMonth() + e), this.setState({
      showDate: n
    });
  }
  nextMonth = (e) => {
    e.preventDefault(), this.goToMonth(1);
  };
  prevMonth = (e) => {
    e.preventDefault(), this.goToMonth(-1);
  };
  handleDateClick(e, t) {
    e.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: o } = this.state, r = {
      ...this.state,
      selectedDate: t
    };
    o.getMonth() !== t.getMonth() && (r.showDate = t), this.setState(r), n(t);
  }
  goToTime(e, t, n = "hours") {
    const o = n === "minutes" ? "setMinutes" : "setHours", r = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: a }
    } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    c[o](c[r]() + t), this.setState({
      selectedDate: c
    }), a(c);
  }
  nextMinutes = (e) => {
    e.preventDefault(), this.goToTime(e, 15, "minutes");
  };
  prevMinutes = (e) => {
    e.preventDefault(), this.goToTime(e, -15, "minutes");
  };
  nextHour = (e) => {
    e.preventDefault(), this.goToTime(e, 1);
  };
  prevHour = (e) => {
    e.preventDefault(), this.goToTime(e, -1);
  };
  canGoPrevMonth() {
    const { minDate: e } = this.props, { showDate: t } = this.state;
    if (e === null) return !0;
    const n = new Date(
      t.getFullYear(),
      t.getMonth(),
      1
    );
    return e < n;
  }
  canGoNextMonth() {
    const { maxDate: e } = this.props, { showDate: t } = this.state;
    if (e === null) return !0;
    const n = new Date(
      t.getFullYear(),
      t.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return e > n;
  }
  canGoDirection(e = "hours", t) {
    const n = e === "minutes" ? "setMinutes" : "setHours", o = e === "minutes" ? "getMinutes" : "getHours", { maxDate: r } = this.props, { selectedDate: a } = this.state, l = new Date(a.getTime());
    return l[n](l[o]() + t), !(l.getDate() !== a.getDate()) && (r === null || r >= l);
  }
  render() {
    const {
      className: e,
      input: t,
      hasTime: n,
      disabled: o,
      minDate: r,
      maxDate: a,
      ...l
    } = this.props, { selectedDate: c, showDate: d } = this.state, h = f({}, e), u = this.generateGrid(), p = {
      month: "long",
      year: "numeric"
    };
    let m = null;
    try {
      m = d.toLocaleDateString("en-US", p);
    } catch (g) {
      m = `${d.getMonth() + 1} / ${d.getFullYear()}`, console.warn("toLocaleDateString exception", g);
    }
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsxs("div", { className: Q.month, children: [
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: Q.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ s.jsx(P, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        m,
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: Q.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ s.jsx(P, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: Q.dayNames, children: [
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Mon" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Tue" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Wed" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Thu" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Fri" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Sat" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: Q.grid, children: u.map((g) => /* @__PURE__ */ s.jsx("div", { className: Q.gridItem, children: /* @__PURE__ */ s.jsx(
        lh,
        {
          onClick: (b) => this.handleDateClick(b, g.date),
          dim: !g.isThisMonth,
          active: g.selected,
          disabled: g.disabled,
          className: Q.day,
          children: g.label
        }
      ) }, g.date.getTime())) }),
      n && /* @__PURE__ */ s.jsxs("div", { className: Q.time, children: [
        /* @__PURE__ */ s.jsxs("div", { className: Q.timeButtonContainerLeft, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(P, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(P, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: Q.timeDisplay, children: `${oo(
          c.getHours().toString(),
          2,
          "0"
        )}:${oo(c.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ s.jsxs("div", { className: Q.timeButtonContainerRight, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(P, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(P, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
}
Qt.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function Ch(i) {
  return Math.abs(i.diff(j())) < 25e3 ? "just now" : i.fromNow();
}
function ks(i) {
  return j(i, j.ISO_8601).isValid();
}
function It(i) {
  return !!j.tz.zone(i ?? "");
}
const Fe = "HH:mm", Ir = ur(24), kr = ur(0, 60, 15), Dr = (i) => j("1995-12-25").format(i);
function Tr(i) {
  if (i < 0 || i > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function jr(i) {
  if (i < 0 || i > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function Nr({
  hour: i,
  minute: e,
  timeFormat: t
}) {
  const n = j({ hour: i, minute: e });
  return {
    id: n.format(Fe),
    name: n.format(t)
  };
}
function vh(i, e) {
  return e?.map(({ hour: t, minute: n }) => (Tr(t), jr(n), Nr({ hour: t, minute: n, timeFormat: i }))) || [];
}
function Fr({
  hours: i,
  minutes: e,
  overrides: t,
  timeFormat: n
}) {
  return vi(
    i.reduce(
      (o, r, a) => [
        ...o,
        ...e.map((l, c) => (c === 0 && Tr(r), a === 0 && jr(l), Nr({ hour: r, minute: l, timeFormat: n })))
      ],
      []
    ).concat(vh(n, t)),
    ["id"]
  );
}
const wh = "h-datePicker--datePicker__root", Sh = "h-datePicker--datePicker__navigationButton", Ih = "h-datePicker--datePicker__nextMonthButton", kh = "h-datePicker--datePicker__prevMonthButton", St = {
  root: wh,
  navigationButton: Sh,
  nextMonthButton: Ih,
  prevMonthButton: kh
}, Bn = {
  previousMonth({ ariaLabel: i, ...e }) {
    const t = f(
      St.navigationButton,
      St.prevMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: t, children: /* @__PURE__ */ s.jsx(P, { ...e, "aria-label": i, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: i, ...e }) {
    const t = f(
      St.navigationButton,
      St.nextMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: t, children: /* @__PURE__ */ s.jsx(P, { ...e, "aria-label": i, size: 24, name: "angle-right" }) });
  }
}, Pr = (i) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx("span", { className: "date-number-container", children: i.date() }),
  /* @__PURE__ */ s.jsx("span", { className: "day-complimentary-highlight" })
] }), Rr = ({ month: i }) => /* @__PURE__ */ s.jsx("span", { children: i.format("MMMM YYYY") }), Er = (i) => {
  const { value: e, presets: t, onSelect: n } = i, o = F(
    (r) => {
      n(r.key === e ? null : r);
    },
    [n, e]
  );
  return /* @__PURE__ */ s.jsxs(Xe, { children: [
    /* @__PURE__ */ s.jsx(zn, { orientation: "vertical" }),
    /* @__PURE__ */ s.jsx(co, { children: t.map((r) => /* @__PURE__ */ s.jsx(
      co.Item,
      {
        isSelected: r.key === e,
        onClick: () => o(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, Dh = "h-fieldLabel--fieldLabel__root", Th = "h-fieldLabel--fieldLabel__label", jh = "h-fieldLabel--fieldLabel__labelChildren", Nh = "h-fieldLabel--fieldLabel__rootRequired", Fh = "h-fieldLabel--fieldLabel__helpIcon", Ot = {
  root: Dh,
  label: Th,
  labelChildren: jh,
  rootRequired: Nh,
  helpIcon: Fh
}, Ph = "fieldLabel";
class zs extends k {
  render() {
    const { required: e, helpIcon: t, className: n, children: o, ...r } = this.props, a = f(Ot.root, n, {
      [Ot.rootRequired]: e
    });
    return /* @__PURE__ */ s.jsxs("div", { className: a, "data-testid": Ph, children: [
      /* @__PURE__ */ s.jsx("label", { className: Ot.label, ...r, children: /* @__PURE__ */ s.jsx("div", { className: Ot.labelChildren, children: o }) }),
      !!t?.text && /* @__PURE__ */ s.jsx(
        Ms,
        {
          ...t,
          className: f(Ot.helpIcon, t.className)
        }
      )
    ] });
  }
}
const Rh = "h-dropdownSelect--dropdownInfinite__item", Eh = "h-dropdownSelect--dropdownInfinite__list", To = {
  item: Rh,
  list: Eh
};
class jo extends k {
  render() {
    const {
      item: e,
      itemComponent: t,
      tooltip: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, m = /* @__PURE__ */ s.jsx(
      t,
      {
        item: e,
        onSelect: o,
        onChange: r,
        onKeyDown: a,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: u ? 0 : -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return n ? /* @__PURE__ */ s.jsx(se, { ...n, children: m }, e.id) : m;
  }
}
const Lh = 6, Ah = 48;
class Vs extends k {
  listRef;
  infiniteListRef;
  static defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  constructor(e) {
    super(e), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = O(), this.infiniteListRef = O();
  }
  componentDidUpdate(e) {
    const { activeItem: t, items: n, pagination: o } = this.props, r = typeof e.activeItem == "object" && e.activeItem ? e.activeItem.id : e.activeItem, a = typeof t == "object" && t ? t.id : t;
    if (r !== a && a !== null) {
      const l = n.findIndex(
        (c) => c.id === a
      );
      if (l >= 0) {
        if (typeof o == "object" && o.infinite && this.infiniteListRef.current)
          this.infiniteListRef.current.scrollToItem(l, "smart");
        else if (this.listRef.current) {
          const c = this.listRef.current.children[l];
          c && c.scrollIntoView({ block: "nearest" });
        }
      }
    }
  }
  isItemLoaded(e) {
    const { items: t } = this.props;
    return e < t.length;
  }
  isItemActive(e) {
    if (!e) return !1;
    const { activeItem: t } = this.props;
    return t ? typeof t == "object" && "id" in t ? e.id === t.id : e.id === t : !1;
  }
  isItemChecked(e) {
    if (!e) return !1;
    const { selectedItems: t } = this.props;
    return (t?.findIndex((o) => typeof o == "object" ? o.id === e.id : o === e.id) ?? -1) > -1;
  }
  isItemDisabled(e) {
    return e ? (this.props.disabledItems?.indexOf(e.id) ?? -1) >= 0 : !0;
  }
  getTooltip(e) {
    const { tooltipItems: t } = this.props;
    return !e || Ls(t?.[e.id]) ? null : t?.[e.id] ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  focusActiveItem() {
    const { items: e, activeItem: t } = this.props;
    if (!t || !this.listRef.current) return;
    const n = typeof t == "object" && "id" in t ? t.id : t, o = e.findIndex((r) => r.id === n);
    if (o >= 0 && this.listRef.current.children[o]) {
      const r = this.listRef.current.children[o];
      (r.querySelector('[tabindex="0"]') || r)?.focus();
    }
  }
  getItemId(e) {
    const { id: t } = this.props;
    return t ? `${t}-option-${e}` : void 0;
  }
  /**
   * This attribute is supposed to be a React component. The FixedSizeList
   * component expects a component is a child.
   *
   * @see https://react-window.vercel.app/#/examples/list/fixed-size
   */
  ListItem = ({
    index: e,
    style: t
  }) => {
    const { items: n, itemComponent: o, onSelect: r, onChange: a, clearSearch: l } = this.props, c = this.isItemLoaded(e), d = e === n.length - 1, h = c ? n[e] : { id: en(), name: "Loading..." }, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
    return /* @__PURE__ */ s.jsxs("div", { style: t, className: To.item, children: [
      /* @__PURE__ */ s.jsx(
        jo,
        {
          id: this.getItemId(e),
          checked: this.isItemChecked(h),
          clearSearch: l,
          disabled: this.isItemDisabled(h),
          isLoading: !c,
          item: h,
          itemComponent: o,
          onChange: a,
          onSelect: r,
          tooltip: this.getTooltip(h),
          active: this.isItemActive(h)
        }
      ),
      d && u && c && /* @__PURE__ */ s.jsx(wi, { onEnter: this.loadMoreItems })
    ] });
  };
  loadMoreItems = async () => {
    this.props.pagination && await this.props.pagination.onNext?.();
  };
  render() {
    const {
      items: e,
      pagination: t,
      itemComponent: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      itemsDisplayCount: c = Lh,
      itemHeight: d = Ah,
      id: h,
      ariaLabelledby: u
    } = this.props;
    if (!t || !t.infinite || !t.onNext)
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          style: { maxHeight: `${c * d}px` },
          className: To.list,
          ref: this.listRef,
          role: "listbox",
          id: h,
          "aria-labelledby": u,
          children: e.map((_, v) => {
            const S = Si(_) ? _ : _.id.toString() || _.name.toString() || _.toString();
            return /* @__PURE__ */ s.jsx(
              jo,
              {
                id: this.getItemId(v),
                checked: this.isItemChecked(_),
                clearSearch: l,
                disabled: this.isItemDisabled(_),
                item: _,
                itemComponent: n,
                onChange: r,
                onSelect: o,
                onKeyDown: a,
                tooltip: this.getTooltip(_),
                active: this.isItemActive(_)
              },
              S
            );
          })
        }
      );
    const { nextEnable: p, itemCount: m } = t, g = m || (p ? e.length + c : e.length), b = {
      items: e,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, y = Math.min(
      g * d,
      c * d
    );
    return /* @__PURE__ */ s.jsx(Ii, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: _ }) => /* @__PURE__ */ s.jsx(
      ki,
      {
        ...b,
        ref: this.infiniteListRef,
        width: _,
        height: y,
        itemCount: g,
        itemSize: d,
        "aria-labelledby": u,
        children: this.ListItem
      }
    ) });
  }
}
const $h = "h-selectItems-checkableBaseItem--checkableBaseItem__root", Oh = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", Bh = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", Hh = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", Wh = "h-selectItems-checkableBaseItem--checkableBaseItem__content", Bt = {
  root: $h,
  rootActive: Oh,
  rootDisabled: Bh,
  checkbox: Hh,
  content: Wh
};
class Ks extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleChange() {
    const { onChange: e, item: t, checked: n } = this.props;
    typeof e == "function" && e(t, !n);
  }
  handleKeyDown(e) {
    const { disabled: t, onKeyDown: n } = this.props;
    (e.key === "Enter" || e.key === " ") && !t && (e.preventDefault(), this.handleChange()), n && n(e);
  }
  noop(e) {
    e.preventDefault();
  }
  render() {
    const {
      item: e,
      onChange: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      children: l,
      active: c,
      tabIndex: d,
      onKeyDown: h,
      ...u
    } = this.props, p = f(Bt.root, {
      [Bt.rootDisabled]: r,
      [Bt.rootActive]: c
    }), m = r ? L : this.handleChange;
    return /* @__PURE__ */ s.jsxs(
      "label",
      {
        ...u,
        className: p,
        tabIndex: d,
        onKeyDown: this.handleKeyDown,
        children: [
          /* @__PURE__ */ s.jsx(
            an,
            {
              id: e?.id,
              name: "",
              className: Bt.checkbox,
              checked: o,
              onChange: m,
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: Bt.content, children: l })
        ]
      }
    );
  }
}
const Mh = "h-selectItems-emptySelectItem--emptySelectItem__root", zh = "h-selectItems-emptySelectItem--emptySelectItem__name", No = {
  root: Mh,
  name: zh
};
class cn extends k {
  render() {
    const { label: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx("div", { ...t, className: No.root, children: /* @__PURE__ */ s.jsx("div", { className: No.name, children: e }) });
  }
}
const Vh = "h-selectItems-selectItem--selectItem__root", Kh = "h-selectItems-selectItem--selectItem__rootActive", Uh = "h-selectItems-selectItem--selectItem__name", qh = "h-selectItems-selectItem--selectItem__nameBold", Gh = "h-selectItems-selectItem--selectItem__nameWithDescription", Yh = "h-selectItems-selectItem--selectItem__description", Qh = "h-selectItems-selectItem--selectItem__icon", nt = {
  root: Vh,
  rootActive: Kh,
  name: Uh,
  nameBold: qh,
  nameWithDescription: Gh,
  description: Yh,
  icon: Qh
};
class Lr extends me {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: e,
      onSelect: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      active: a,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = e, m = f(nt.root, {
      [nt.rootActive]: a
    }), g = f(nt.name, {
      [nt.nameBold]: o,
      [nt.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": a,
        className: m,
        disabled: r,
        onClick: () => {
          t(e);
        },
        children: [
          u ? /* @__PURE__ */ s.jsx(P, { className: nt.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ s.jsx("span", { className: g, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ s.jsx("span", { className: nt.description, "data-testid": "description", children: d })
          ] }),
          o && /* @__PURE__ */ s.jsx(P, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
const Xh = "h-selectItems-checkableSelectItem--checkableSelectItem__name", Zh = {
  name: Xh
};
class Mk extends k {
  render() {
    const { item: e, isLoading: t } = this.props, { name: n } = t ? { name: "Loading..." } : e;
    return /* @__PURE__ */ s.jsx(Ks, { ...this.props, children: /* @__PURE__ */ s.jsx("span", { className: Zh.name, children: n }) });
  }
}
const Jh = "h-selectItems-tagSelectItem--tagSelectItem__root", eu = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", tu = "h-selectItems-tagSelectItem--tagSelectItem__name", nu = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", su = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", ou = "h-selectItems-tagSelectItem--tagSelectItem__dot", mt = {
  root: Jh,
  rootActive: eu,
  name: tu,
  nameBold: nu,
  dotContainer: su,
  dot: ou
};
class zk extends k {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: e,
      onSelect: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = e, u = f(mt.root, {
      [mt.rootActive]: l
    }), p = f(mt.name, {
      [mt.nameBold]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          t(e), n();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: mt.dotContainer, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: mt.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ s.jsx("div", { className: p, children: d }),
          o && /* @__PURE__ */ s.jsx(P, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
const ru = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", iu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", au = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", lu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", gn = {
  name: ru,
  dotContainer: iu,
  dot: au,
  nameContainer: lu
};
class Vk extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: e, item: t, checked: n } = this.props;
    typeof e == "function" && e(t, !n);
  }
  render() {
    const { item: e, isLoading: t, disabled: n } = this.props, { name: o, color: r } = t ? { name: "Loading...", color: "#000" } : e;
    return /* @__PURE__ */ s.jsx(
      Ks,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : n,
        children: /* @__PURE__ */ s.jsxs("div", { className: gn.nameContainer, children: [
          r && /* @__PURE__ */ s.jsx("div", { className: gn.dotContainer, children: /* @__PURE__ */ s.jsx("div", { className: gn.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ s.jsx("span", { className: gn.name, children: o }),
          n && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const cu = "h-selectItems-avatarSelectItem--avatarSelectItem__root", du = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", hu = "h-selectItems-avatarSelectItem--avatarSelectItem__names", uu = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", pu = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", mu = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", gu = "h-selectItems-avatarSelectItem--avatarSelectItem__container", fu = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", ze = {
  root: cu,
  rootActive: du,
  names: hu,
  primaryName: uu,
  secondaryName: pu,
  namesBold: mu,
  container: gu,
  containerCheckable: fu
};
class bu extends k {
  static defaultProps = {
    checked: !1
  };
  getNames(e) {
    const t = /* @__PURE__ */ new Set();
    typeof e.name == "string" && t.add(e.name), typeof e.name != "string" && typeof e.display_name == "string" && t.add(e.display_name), typeof e.phone_number == "string" && t.add(e.phone_number), typeof e.email == "string" && t.add(e.email);
    const n = Array.from(t);
    return {
      primaryName: n.length > 0 ? n[0] : "No name",
      secondaryName: n.length > 1 ? n[1] : null
    };
  }
  getAvatar(e) {
    return typeof e.icon == "string" ? /* @__PURE__ */ s.jsx(P, { name: e.icon, size: 16 }) : /* @__PURE__ */ s.jsx(_r, { user: e });
  }
  renderContent() {
    const e = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, t = this.getAvatar(e), n = this.getNames(e), o = f(ze.container, {
      [ze.containerCheckable]: this.props.checkable
    }), r = f(ze.names, {
      [ze.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ s.jsxs("div", { className: o, children: [
      t,
      /* @__PURE__ */ s.jsxs("div", { className: r, children: [
        /* @__PURE__ */ s.jsx("div", { className: ze.primaryName, children: n.primaryName }),
        n.secondaryName !== null && /* @__PURE__ */ s.jsx("div", { className: ze.secondaryName, children: n.secondaryName })
      ] })
    ] });
  }
  render() {
    const e = this.renderContent(), { checkable: t, ...n } = this.props;
    if (t) {
      const m = n;
      return /* @__PURE__ */ s.jsx(Ks, { ...m, children: e });
    }
    const o = n, { item: r, disabled: a, onSelect: l, active: c, checked: d, isLoading: h, ...u } = o, p = f(ze.root, {
      [ze.rootActive]: c
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: a,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          e,
          d && /* @__PURE__ */ s.jsx(P, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
class Kk extends k {
  render() {
    return /* @__PURE__ */ s.jsx(bu, { checkable: !0, ...this.props });
  }
}
const yu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", xu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", _u = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", Cu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", fn = {
  root: yu,
  rootActive: xu,
  suggestion: _u,
  icon: Cu
};
class Uk extends me {
  static defaultProps = {
    searchSuggestion: (e, t) => e.find((n) => n.name.toLowerCase() === t.toLowerCase()),
    renderSuggestion: (e) => `Add "${e}" tag`
  };
  constructor(e) {
    super(e), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(e) {
    const { searched: t, active: n } = this.props;
    t !== e.searched && this.searchItem(), n !== e.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: e, searched: t, searchSuggestion: n } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const o = await n?.(e, t);
        this.setState({ item: o });
      } catch (o) {
        console.error(o);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: e, onSuggest: t, clearSearch: n, triggerClose: o } = this.props;
    o?.(), t?.(e), n();
  }
  handleKeyDown(e) {
    this.props.active && e.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: e,
      triggerClose: t,
      onSuggest: n,
      searched: o,
      items: r,
      active: a,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!o || p || u)
      return null;
    const m = f(e, fn.root, {
      [fn.rootActive]: a
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": a,
        className: m,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: fn.suggestion, children: l?.(o) }),
          /* @__PURE__ */ s.jsx("div", { className: fn.icon, children: /* @__PURE__ */ s.jsx(P, { name: "plus" }) })
        ]
      }
    );
  }
}
const vu = "h-selectItems-deselectItem--deselectItem__root", wu = "h-selectItems-deselectItem--deselectItem__rootDisabled", Su = "h-selectItems-deselectItem--deselectItem__name", Iu = "h-selectItems-deselectItem--deselectItem__icon", bn = {
  root: vu,
  rootDisabled: wu,
  name: Su,
  icon: Iu
};
class ku extends k {
  render() {
    const { item: e, onSelect: t, clearSearch: n, disabled: o, ...r } = this.props, { name: a } = e, l = f(bn.root, {
      [bn.rootDisabled]: o
    });
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { className: bn.name, children: a }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: bn.icon,
          onClick: () => {
            t(e);
          },
          disabled: o,
          children: /* @__PURE__ */ s.jsx(P, { name: "close" })
        }
      )
    ] });
  }
}
const Du = "h-selectItems-tagDeselectItem--tagDeselectItem__root", Tu = "h-selectItems-tagDeselectItem--tagDeselectItem__name", ju = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", Nu = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", Fu = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", Ht = {
  root: Du,
  name: Tu,
  icon: ju,
  dotContainer: Nu,
  dot: Fu
};
class qk extends k {
  render() {
    const { item: e, onSelect: t, clearSearch: n, disabled: o, isLoading: r, ...a } = this.props, { name: l, color: c } = e, d = f(Ht.root);
    return /* @__PURE__ */ s.jsxs("div", { ...a, className: d, children: [
      /* @__PURE__ */ s.jsx("div", { className: Ht.dotContainer, children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: Ht.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ s.jsx("div", { className: Ht.name, children: l }),
      o && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Ht.icon,
          onClick: () => {
            t(e);
          },
          children: /* @__PURE__ */ s.jsx(P, { name: "close" })
        }
      )
    ] });
  }
}
const Pu = "h-chip--chip__root", Ru = "h-chip--chip__rootLight", Eu = "h-chip--chip__rootNoBorder", Lu = "h-chip--chip__rootDisabled", Au = "h-chip--chip__rootInteractable", Wt = {
  root: Pu,
  rootLight: Ru,
  rootNoBorder: Eu,
  rootDisabled: Lu,
  rootInteractable: Au
}, $u = ({
  className: i,
  children: e,
  onClick: t,
  light: n,
  noBorder: o,
  disabled: r,
  ...a
}) => {
  const l = f(
    {
      [Wt.root]: !0,
      [Wt.rootLight]: n,
      [Wt.rootNoBorder]: o,
      [Wt.rootDisabled]: r,
      [Wt.rootInteractable]: typeof t == "function" && !r
    },
    i
  ), c = typeof t == "function" ? "button" : "div";
  return /* @__PURE__ */ s.jsx(ie, { ...a, as: c, className: l, onClick: t, children: e });
}, Ou = "h-tag--tag__tagName", Bu = "h-tag--tag__tagNameTruncated", Hu = "h-tag--tag__icon", Wu = "h-tag--tag__deleteButton", Mu = "h-tag--tag__deleteButtonDisabled", zu = "h-tag--tag__deleteIcon", gt = {
  tagName: Ou,
  tagNameTruncated: Bu,
  icon: Hu,
  deleteButton: Wu,
  deleteButtonDisabled: Mu,
  deleteIcon: zu
}, kt = ({
  className: i,
  tagNameClassName: e,
  children: t,
  onDelete: n,
  color: o,
  light: r,
  noBorder: a,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = f(
    {
      [gt.tagName]: !0,
      [gt.tagNameTruncated]: !l
    },
    e
  ), u = f(gt.deleteButton, {
    [gt.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ s.jsxs(
    $u,
    {
      ...d,
      className: i,
      light: r,
      noBorder: a,
      disabled: c,
      children: [
        o && /* @__PURE__ */ s.jsx(
          "span",
          {
            className: gt.icon,
            style: { backgroundColor: Zt(o) ?? void 0 }
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: h, children: t }),
        !!n && !c && /* @__PURE__ */ s.jsx("button", { className: u, type: "button", onClick: n, children: /* @__PURE__ */ s.jsx(P, { name: "close", className: gt.deleteIcon }) })
      ]
    }
  );
}, Vu = "h-select--select__root", Ku = "h-select--select__rootDisabled", Uu = "h-select--select__inputWrapper", qu = "h-select--select__control", Gu = "h-select--select__rootHasIcon", Yu = "h-select--select__selection", Qu = "h-select--select__selectionItem", Xu = "h-select--select__tag", Zu = "h-select--select__tagName", Ju = "h-select--select__tagLimiter", ep = "h-select--select__text", tp = "h-select--select__rootSearchable", np = "h-select--select__rootDropdownOpen", sp = "h-select--select__rootIsSearching", op = "h-select--select__search", rp = "h-select--select__rootSingle", ip = "h-select--select__indicators", ap = "h-select--select__spinner", lp = "h-select--select__clearIndicator", cp = "h-select--select__dropdownIndicator", dp = "h-select--select__dropdown", hp = "h-select--select__dropdownFixed", up = "h-select--select__pagination", G = {
  root: Vu,
  rootDisabled: Ku,
  inputWrapper: Uu,
  control: qu,
  rootHasIcon: Gu,
  selection: Yu,
  selectionItem: Qu,
  tag: Xu,
  tagName: Zu,
  tagLimiter: Ju,
  text: ep,
  rootSearchable: tp,
  rootDropdownOpen: np,
  rootIsSearching: sp,
  search: op,
  rootSingle: rp,
  indicators: ip,
  spinner: ap,
  clearIndicator: lp,
  dropdownIndicator: cp,
  dropdown: dp,
  dropdownFixed: hp,
  pagination: up
};
class Dt extends k {
  static contextType = Mn;
  controlRef;
  searchRef;
  listRef;
  static defaultProps = {
    id: pr("select"),
    selectedItems: [],
    disabledItems: [],
    itemComponent: Lr,
    emptyComponent: cn,
    emptyMessage: "No options",
    placeholder: "",
    disabled: !1,
    loading: !1,
    multiple: !1,
    searchable: !1,
    clearable: !1,
    keepOpen: !1,
    hideSelectedItems: !1,
    hasDropDownIndicator: !0
  };
  constructor(e) {
    super(e), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = O(), this.searchRef = O(), this.listRef = O();
    const t = this.initSelectedItems(), n = this.initHighlightedIndex(t);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: t,
      highlightedIndex: n
    }, !Dt.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), Dt.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(e, t) {
    const { dropdownOpen: n } = this.state;
    if (n !== t.dropdownOpen)
      if ((this.context ?? window)[n ? "addEventListener" : "removeEventListener"]("click", this.handleClickOutside), n) {
        this.searchRef.current?.focus();
        const o = this.initHighlightedIndex();
        this.highlightIndex(o, "auto");
      } else
        this.searchRef.current?.blur();
    mr(e.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: e } = this.state;
    e && (this.context ?? window).removeEventListener(
      "click",
      this.handleClickOutside
    );
  }
  static isSuggestionComponentWarningShown = !1;
  get a11y() {
    const { id: e } = this.props, { highlightedIndex: t } = this.state, n = `${e}-label`, o = `${e}-dropdown`, r = t !== null ? `${o}-option-${t}` : "";
    return { label: n, dropdown: o, option: r };
  }
  isItemIdType(e) {
    return typeof e == "string" || typeof e == "number";
  }
  initSelectedItems() {
    const { selectedItems: e = [] } = this.props;
    return e.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(e = this.state.selectedItems) {
    const { multiple: t, items: n, hideSelectedItems: o } = this.props;
    if (!t && !o && e.length) {
      const r = this.resolveItem(e[0]);
      return n.indexOf(r);
    }
    return null;
  }
  resolveItem(e) {
    return this.isItemIdType(e) ? this.props.items.find((n) => n.id === e) : e;
  }
  resetSearch() {
    this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
  }
  handleSearch(e) {
    const { onSearch: t } = this.props, { value: n } = e.target;
    this.setState({ search: n }, () => {
      t?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
    });
  }
  handleDropdown(e = "toggle") {
    const { dropdownOpen: t } = this.state, { keepOpen: n, onToggle: o } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (e === "toggle")
      return o?.(!t), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !t });
    if (e === "open")
      return o?.(!0), this.setState({ dropdownOpen: !0 });
    if (e === "close" && t)
      return o?.(!1), this.controlRef.current?.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(e) {
    if (!this.controlRef || !(e.target instanceof Node)) return;
    const t = this.controlRef.current, { target: n } = e;
    n && n !== t && !t?.contains(n) && this.handleDropdown("close");
  }
  highlightIndex(e, t = "smooth") {
    this.setState({ highlightedIndex: e }, () => {
      if (e === null || e === -1) return;
      (this.listRef.current?.listRef.current?.children ?? [])[e]?.scrollIntoView({
        behavior: t,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(e) {
    const { search: t, dropdownOpen: n, highlightedIndex: o, selectedItems: r } = this.state, { multiple: a, hideSelectedItems: l } = this.props, c = this.getAvailableItems(), d = e.key === "Escape", h = e.key === "Enter", u = e.key === "ArrowUp", p = e.key === "ArrowDown", m = e.key === "Backspace";
    if ((h || u || p) && e.preventDefault(), p && !n)
      return e.preventDefault(), this.handleDropdown("open");
    if (d && (n && e.stopPropagation(), this.handleDropdown("close")), m && a && !t) {
      const g = r[r.length - 1];
      g && this.handleRemove(g);
    }
    if (this.hasSuggestionComponent()) {
      if (p && (o === null || o === c.length - 1 || o === 0 && c.length === 0))
        return this.highlightIndex(-1);
      if (u && o === 0)
        return this.highlightIndex(-1);
      if (h && o === -1) {
        this.props.onSuggest?.(t), this.resetSearch();
        return;
      }
    }
    if (p && o === null)
      return this.highlightIndex(0);
    if (o !== null) {
      if (p && o === c.length - 1)
        return this.highlightIndex(0);
      if (p)
        return this.highlightIndex(o + 1);
      if (u && o > 0)
        return this.highlightIndex(o - 1);
      if (u && o <= 0)
        return this.highlightIndex(c.length - 1);
      if (h) {
        const g = c[o], b = g && this.isItemDisabled(g);
        if (g && !b) {
          this.handleSelect(g);
          const y = Math.min(
            l ? o : o + 1,
            c.length - 2
          );
          this.highlightIndex(y);
        }
      }
    }
  }
  handleSelect(e) {
    const { multiple: t, keepOpen: n, onSelect: o } = this.props;
    if (t) {
      const r = this.isItemSelected(e);
      this.handleChange(e, !r);
    } else
      this.setState({
        selectedItems: [e],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), o?.(e);
  }
  handleChange(e, t) {
    const { onChange: n } = this.props, { selectedItems: o } = this.state;
    this.setState({
      selectedItems: t ? [...o, e] : o.filter((r) => r.id !== e.id)
    }), this.resetSearch(), n?.(e, t);
  }
  handleRemove(e, t) {
    t && (t.preventDefault(), t.stopPropagation()), this.handleChange(e, !1);
  }
  handleClear(e) {
    e.stopPropagation();
    const { onClear: t } = this.props;
    t?.(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(e) {
    e.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
  }
  getItemName(e) {
    return e.name.toString().trim();
  }
  getAvailableItems() {
    const { search: e } = this.state, { items: t, hideSelectedItems: n, onSearch: o, searchBy: r } = this.props, a = new RegExp(As(e), "i");
    return t.filter((c) => {
      const d = [];
      return e && !o && (r && typeof r == "function" ? d.push(r(c, e)) : r && r instanceof Array ? d.push(
        r.some((h) => {
          const u = c[h];
          return (typeof u == "string" || typeof u == "number") && a.test(u.toString().trim());
        })
      ) : d.push(a.test(this.getItemName(c)))), n && d.push(!this.isItemSelected(c)), d.every((h) => h);
    });
  }
  isItemSelected(e) {
    return this.state.selectedItems.some(
      (t) => t.id === e.id
    );
  }
  isItemDisabled(e) {
    return this.props.disabledItems?.includes(e.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(e) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: e } = this.props, { selectedItems: t } = this.state;
    if (e && e > 0)
      return /* @__PURE__ */ s.jsx(B, { flexDirection: "column", children: t?.slice(e).map((n) => /* @__PURE__ */ s.jsxs(
        B,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ s.jsx(ie, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ s.jsx(
              U,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (o) => this.handleRemove(n, o)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(e) {
    return this.props.renderSelection?.(e) ?? this.getItemName(e);
  }
  renderMultipleSelection() {
    const { selectedItems: e } = this.state, t = this.props.limit || e.length, n = t < e.length, o = e?.slice(0, t).map((r) => {
      const a = this.renderSelection(r);
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          "data-testid": "select-selection",
          className: G.selectionItem,
          children: /* @__PURE__ */ s.jsx(
            kt,
            {
              className: G.tag,
              tagNameClassName: G.tagName,
              onDelete: (l) => this.handleRemove(r, l),
              color: r.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: a
            }
          )
        },
        r.id
      );
    });
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      n && /* @__PURE__ */ s.jsx("div", { onClick: (r) => r.stopPropagation(), children: /* @__PURE__ */ s.jsx(
        se,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ s.jsxs(
            kt,
            {
              className: f(G.tag, G.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                e.length - t
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: e, selectedItems: t } = this.state, n = t[0], o = /* @__PURE__ */ s.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: G.text,
        "aria-hidden": !!e,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : o;
  }
  renderSearch() {
    const { searchable: e } = this.props;
    return !e && !this.isEmpty() ? null : /* @__PURE__ */ s.jsx(
      "input",
      {
        className: G.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (t) => t.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !e,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: e, highlightedIndex: t, search: n } = this.state, {
      disabledItems: o,
      tooltipItems: r,
      emptyComponent: a,
      suggestionComponent: l,
      emptyMessage: c,
      pagination: d,
      dropdownProps: h,
      searchSuggestion: u,
      renderSuggestion: p,
      onSuggest: m,
      multiple: g
    } = this.props, b = f(
      {
        [G.dropdown]: !0,
        [G.dropdownFixed]: h?.fixed ?? !1
      },
      h?.className
    ), y = this.getAvailableItems(), _ = y[t ?? -1] ?? null, v = !y.length;
    return /* @__PURE__ */ s.jsxs(
      Je,
      {
        onClick: this.handleDropdownClick,
        ...h,
        className: b,
        isOpen: e,
        "data-testid": "select-dropdown",
        children: [
          v && typeof a == "function" && /* @__PURE__ */ s.jsx(
            a,
            {
              label: c ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(l) && /* @__PURE__ */ s.jsx(
            l,
            {
              searched: n,
              onSuggest: m,
              triggerClose: g ? void 0 : () => this.handleDropdown("close"),
              items: y,
              active: t === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: u,
              renderSuggestion: p
            }
          ),
          !v && /* @__PURE__ */ s.jsx(
            Vs,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: d,
              items: y,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: o,
              tooltipItems: r,
              activeItem: _,
              itemComponent: this.props.itemComponent
            }
          ),
          !!d && !d.infinite && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: G.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ s.jsx(
                  te,
                  {
                    variant: "secondary",
                    disabled: !d.previousEnable,
                    onClick: d.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  te,
                  {
                    variant: "secondary",
                    disabled: !d.nextEnable,
                    onClick: d.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: e,
      disabled: t,
      hasDropDownIndicator: n,
      loading: o,
      multiple: r,
      searchable: a,
      clearable: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u
    } = this.props, { search: p, dropdownOpen: m } = this.state, g = f(
      {
        [G.root]: !0,
        [G.rootSingle]: !r,
        [G.rootDisabled]: t,
        [G.rootSearchable]: a,
        [G.rootDropdownOpen]: m,
        [G.rootIsSearching]: !!p,
        [G.rootHasIcon]: !!h
      },
      e
    ), b = p ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: g,
        role: "combobox",
        "aria-expanded": m,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ s.jsx(
            Be,
            {
              prefix: c,
              suffix: d,
              icon: h,
              status: u,
              active: m,
              disabled: t,
              className: G.inputWrapper,
              children: /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: G.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: b,
                  tabIndex: t ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ s.jsxs("div", { className: G.selection, children: [
                      r ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: G.indicators, children: [
                      o && /* @__PURE__ */ s.jsx(
                        $s,
                        {
                          className: G.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && l && /* @__PURE__ */ s.jsx(
                        U,
                        {
                          tabIndex: -1,
                          className: G.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ s.jsx(
                        U,
                        {
                          tabIndex: -1,
                          className: G.dropdownIndicator,
                          icon: m ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (y) => {
                            y.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": m ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !t && m && this.renderDropdown()
        ]
      }
    );
  }
}
function pp(i) {
  return /* @__PURE__ */ s.jsx(
    jt,
    {
      fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ s.jsx(Dt, { ...i })
    }
  );
}
const mp = "h-datePicker-timezoneSelector--timezoneSelector__root", gp = "h-datePicker-timezoneSelector--timezoneSelector__label", Fo = {
  root: mp,
  label: gp
}, Ar = ({
  disabled: i,
  tooltipProps: e,
  selectedTimezone: t,
  onChange: n
}) => {
  const o = j.tz.guess(!0), r = F((h, u) => {
    const [p, m] = j.tz(h).format("Z").split(":"), [g, b] = j.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(m) - (+parseInt(g) * 60 + parseInt(b));
  }, []), a = (h) => `(GMT${j.tz(h).format("Z")})`, l = (h) => `${a(h)} ${h}`, c = q(() => {
    const h = j.tz.names().filter((m) => m !== o), u = {
      id: o,
      name: `Default ${a(o)}`
    }, p = h.sort(r).map((m) => ({ id: m, name: l(m) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    n(h);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: Fo.root, children: [
    /* @__PURE__ */ s.jsx(zs, { className: Fo.label, children: "Time zone" }),
    /* @__PURE__ */ s.jsx(se, { ...e, side: "top", children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
      pp,
      {
        disabled: i,
        items: c,
        onSelect: d,
        selectedItems: [
          It(t) ? t : o
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, fp = "h-fieldAlert--fieldAlert__root", bp = "h-fieldAlert--fieldAlert__alert", yp = "h-fieldAlert--fieldAlert__icon", ls = {
  root: fp,
  alert: bp,
  icon: yp
}, xp = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", _p = {
  root: xp
};
function Cp({
  className: i,
  variant: e = "tertiary",
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    te,
    {
      ...t,
      variant: e,
      className: f(i, _p.root)
    }
  );
}
const vp = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function Gn({
  children: i,
  className: e,
  ...t
}) {
  const n = t.variant || "title", o = f(ls.root, e), [r, a] = V(!1), l = vp[n], c = F(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      a(h < u);
    },
    [i]
  );
  return /* @__PURE__ */ s.jsxs($.Input, { ...t, variant: n, className: o, children: [
    !!l && /* @__PURE__ */ s.jsx(P, { className: ls.icon, name: l }),
    /* @__PURE__ */ s.jsx("div", { className: ls.alert, ref: c, children: r ? /* @__PURE__ */ s.jsx(se, { content: i, children: i }) : i })
  ] });
}
Gn.Button = Cp;
const wp = "hmm A", Sp = (i, e) => {
  const t = `${i}`.padStart(2, "0"), n = `${e}`.padStart(2, "0");
  return `${t}:${n}`;
}, Po = (i, e) => {
  const t = i.hours(), n = i.minutes();
  return {
    id: Sp(t, n),
    name: i.format(e)
  };
}, tn = ({
  hasDropDownIndicator: i = !0,
  allowCustomTimeInput: e = !1,
  timeOptions: t,
  overrides: n,
  selectedItems: o,
  selectableHours: r = Ir,
  selectableMinutes: a = kr,
  timeFormat: l = j.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = o || [], [p, m] = V(
    () => typeof u == "object" ? u?.id : u || null
  ), [g, b] = V(""), y = q(
    () => t || Fr({
      hours: r,
      minutes: a,
      overrides: n,
      timeFormat: l
    }),
    [
      t,
      r,
      a,
      n,
      l
    ]
  ), _ = q(() => {
    const C = j(
      g || (typeof u == "object" ? u.id : u) || p,
      [l, wp]
    );
    if (!C.isValid())
      return null;
    const w = C.hours(), I = C.minutes();
    if (!d || d(w, I))
      return Po(C, l);
    const T = w <= 12, N = w + 12, H = d(N, I);
    return T && H ? Po(j({ hours: N, minutes: I }), l) : null;
  }, [u, g]), v = q(() => {
    if (!e)
      return y;
    const C = p ? y.filter(({ name: w }) => w !== _?.name) : y.filter(
      ({ name: w }) => w.startsWith(g) && w !== _?.name
    );
    if (!_)
      return C;
    const x = p !== _.id ? 0 : C.findIndex(
      (w) => j(w.id, [l]) > j(_.id, [l])
    );
    return C.splice(
      // If it's -1 then there was no later time, so add it to the end.
      x === -1 ? C.length : x,
      0,
      _
    ), C;
  }, [_, g, p, y]), S = F(
    (C) => {
      C?.id !== _?.id && b(""), c(C?.id || null), m(C?.id || null);
    },
    [_]
  );
  return X(() => {
    u ? (b(""), m(
      typeof u == "object" ? u.id : u
    )) : m(null);
  }, [u]), /* @__PURE__ */ s.jsx(
    Dt,
    {
      searchable: !0,
      placeholder: Dr(l),
      ...h,
      selectedItems: o,
      hasDropDownIndicator: i,
      items: e ? v : y,
      onChange: L,
      onClear: S,
      onSelect: S,
      ...e && { onSearch: b }
    }
  );
}, Ip = "h-timePicker-range--timeRangePicker__root", kp = "h-timePicker-range--timeRangePicker__timePickerFrom", Dp = "h-timePicker-range--timeRangePicker__timePickerTo", Tp = "h-timePicker-range--timeRangePicker__arrowContainer", jp = "h-timePicker-range--timeRangePicker__arrowContainerHasError", Np = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", Fp = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", st = {
  root: Ip,
  timePickerFrom: kp,
  timePickerTo: Dp,
  arrowContainer: Tp,
  arrowContainerHasError: jp,
  arrowContainerHasWarning: Np,
  arrowContainerHasSuccess: Fp
}, Pp = ({
  className: i,
  disabled: e,
  endTime: t,
  onSelect: n,
  overrides: o,
  placeholder: r,
  selectableHours: a = Ir,
  selectableMinutes: l = kr,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = j.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: m, endTime: g }, b] = V({
    startTime: d || null,
    endTime: t || null
  }), y = q(
    () => Fr({
      hours: a,
      minutes: l,
      overrides: o,
      timeFormat: u
    }),
    [a, l, o, u]
  ), _ = q(() => {
    const x = y.map(
      ({ id: T }) => j(T, [u])
    ), w = j(m, [u]), I = m && x.findIndex(
      (T) => T > w
    ) || 0;
    return y.slice(I);
  }, [y, m, u]);
  X(() => {
    const x = typeof d == "string", w = typeof d == "string";
    (x && d !== m || w && t !== g) && b((I) => ({
      ...I,
      ...x && { startTime: d },
      ...w && { endTime: t }
    }));
  });
  const v = F(
    (x) => (w) => {
      b((I) => {
        const T = j(w, [u]), N = j(I.startTime, [u]), H = j(I.endTime, [u]), D = y.map(
          ({ id: ne }) => j(ne, [u])
        ), R = D.findIndex(
          (ne) => ne >= T
        ) || -1, A = x === "startTime" ? R : D.findIndex(
          (ne) => ne >= N
        ), K = x === "endTime" ? -1 : D.findIndex(
          (ne) => ne >= H
        ), oe = {
          ...I,
          [x]: w,
          ...I.endTime !== null && x !== "endTime" && A >= K && {
            endTime: y[R + 1]?.id || null
          }
        };
        return n(oe), oe;
      });
    },
    [n]
  ), S = F(
    (x, w) => {
      const I = j(m, [u]);
      if (!I.isValid())
        return !0;
      const N = I.hours(), H = I.minutes();
      return N < x || N === x && H < w;
    },
    [m, u]
  ), C = (x) => r?.[x] || r || Dr(u);
  return /* @__PURE__ */ s.jsxs(ie, { className: f(st.root, i), children: [
    /* @__PURE__ */ s.jsx(
      tn,
      {
        className: st.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: e,
        hasDropDownIndicator: !1,
        timeOptions: y,
        onSelect: v("startTime"),
        placeholder: C("startTime"),
        allowCustomTimeInput: h,
        selectedItems: m ? [m] : [],
        status: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      ie,
      {
        className: f(st.arrowContainer, {
          [st.arrowContainerHasError]: c === "error",
          [st.arrowContainerHasWarning]: c === "warning",
          [st.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ s.jsx(P, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ s.jsx(
      tn,
      {
        className: st.timePickerTo,
        searchable: !0,
        disabled: e || !m,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: _,
        onSelect: v("endTime"),
        placeholder: C("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: S
        },
        selectedItems: g ? [g] : [],
        status: c
      }
    )
  ] });
};
class qe {
  constructor(e, t, n) {
    this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n, this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n;
  }
  dateFormat;
  dateParser;
  dateRangeConstraint;
  static validationOK = { isValid: !0, error: null };
  isValidDate(e) {
    try {
      return this.dateParser(e).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(e) {
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: t, maxDate: n } = this.dateRangeConstraint, o = this.dateParser(e);
    return o.isBefore(t, "day") ? {
      isValid: !1,
      error: `Date must be after ${t.format(this.dateFormat)}`
    } : o.isAfter(n, "day") ? {
      isValid: !1,
      error: `Date must be before ${n.format(this.dateFormat)}`
    } : qe.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: e,
    endDateInputValue: t
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(e), a = this.dateParser(t);
    return r.isBefore(n, "day") ? {
      isValid: !1,
      error: `From date must be after ${n.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && r.isAfter(a, "day") ? {
      isValid: !1,
      error: `From date must be before ${a.format(
        this.dateFormat
      )}`
    } : r.isAfter(o, "day") ? {
      isValid: !1,
      error: `From date must be before ${o.format(this.dateFormat)}`
    } : qe.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: e,
    endDateInputValue: t
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(e), a = this.dateParser(t);
    return a.isAfter(o, "day") ? {
      isValid: !1,
      error: `To date must be before ${o.format(this.dateFormat)}`
    } : e && this.isValidDate(e) && a.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : a.isBefore(n, "day") ? {
      isValid: !1,
      error: `To date must be after ${n.format(this.dateFormat)}`
    } : qe.validationOK;
  }
  isTimeOrderValid({
    startDate: e,
    endDate: t
  }) {
    return !e || !t ? qe.validationOK : e.isAfter(t) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : qe.validationOK;
  }
}
const Rp = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", Ep = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", Lp = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", Ap = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", $p = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", Op = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", Bp = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", Ve = {
  root: Rp,
  rootPlacementTop: Ep,
  rootPlacementTopWithTimezoneSelector: Lp,
  rootPlacementBottom: Ap,
  fields: $p,
  input: Op,
  alert: Bp
};
Array(24).fill(0).map((i, e) => e);
class Us extends k {
  dateRangeValidators;
  timeOptions;
  instanceId;
  constructor(e) {
    super(e);
    const { dateFormat: t } = e;
    this.state = {
      startDateInputValue: this.props.startDate?.format(t) ?? "",
      startDateError: null,
      endDateInputValue: this.props.endDate?.format(t) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = Us.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new qe(
      e.dateFormat,
      this.parseDateString,
      { maxDate: e.maxDate, minDate: e.minDate }
    );
  }
  componentDidUpdate(e) {
    this.syncStartDateWithProps(e), this.syncEndDateWithProps(e), this.validateTimesOrder();
  }
  static instanceCount = 0;
  validateTimesOrder() {
    const { startDate: e, endDate: t } = this.props, { isValid: n, error: o } = this.dateRangeValidators.isTimeOrderValid({
      startDate: e,
      endDate: t
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: o
    });
  }
  syncEndDateWithProps(e) {
    const { endDate: t, timeRoundingStrategy: n } = this.props;
    if (!(t === e.endDate || t?.isSame(e.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(e) {
    const { startDate: t, timeRoundingStrategy: n } = this.props;
    if (!(t === e.startDate || t?.isSame(e.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(e, t) {
    const n = e.target.value;
    switch (t) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: e, endDateInputValue: t } = this.state;
    if (e === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    });
    if (!n) {
      this.setState({ startDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    }), l = t !== "" && !r ? a : null;
    this.setState(
      {
        startDateError: null,
        endDateError: l
      },
      () => this.props.onStartDateChange(this.parseDateString(e))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: e, endDateInputValue: t } = this.state;
    if (t === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    });
    if (!n) {
      this.setState({ endDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    }), l = e !== "" && !r ? a : null;
    this.setState(
      {
        endDateError: null,
        startDateError: l
      },
      () => this.props.onEndDateChange(this.parseDateString(t))
    );
  }
  parseDateString(e) {
    return j(e, this.props.dateFormat, !0);
  }
  ensureValidChars(e) {
    return e.replace(/[^0-9/]/g, "");
  }
  getOverrides(e) {
    if (e !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(e, t, n, o, r, a, l) {
    const {
      dateFormat: c,
      disabled: d,
      focusedInput: h,
      onFocusChange: u,
      onTimeChange: p,
      timeFormat: m,
      withTimePicker: g,
      withDateInput: b
    } = this.props, { timeOrderError: y } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx(zs, { children: e === "startDate" ? "From" : "To" }),
      b && /* @__PURE__ */ s.jsx(
        Ge,
        {
          className: Ve.input,
          placeholder: c.toLowerCase(),
          name: `input__${e}__${this.instanceId}`,
          value: r,
          onChange: (_) => this.handleInputValueChange(_, e),
          onFocus: () => u(e),
          autoComplete: "off",
          status: a ? "error" : void 0,
          disabled: d,
          active: h === e
        }
      ),
      g && /* @__PURE__ */ s.jsx("div", { className: Ve.input, children: /* @__PURE__ */ s.jsx(
        se,
        {
          content: "Please select a date first.",
          disabled: !!n || d,
          side: "right",
          children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
            tn,
            {
              disabled: !n,
              overrides: this.getOverrides(t),
              selectedItems: o ? [o] : void 0,
              status: y ? "error" : void 0,
              ...l,
              timeFormat: m,
              onSelect: (_) => p(t, _)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: e, endDateError: t, timeOrderError: n } = this.state;
    return e || t || n || null;
  }
  renderErrors() {
    const e = this.getError();
    return /* @__PURE__ */ s.jsx(
      Gn,
      {
        className: Ve.alert,
        variant: e ? "error" : void 0,
        children: e
      }
    );
  }
  render() {
    const {
      startDate: e,
      startTime: t,
      endDate: n,
      endTime: o,
      timePickerProps: r = { start: {}, end: {} },
      hasTimezoneSelector: a
    } = this.props, {
      startDateInputValue: l,
      startDateError: c,
      endDateInputValue: d,
      endDateError: h
    } = this.state, { placement: u } = this.props, p = f(Ve.root, {
      [Ve.rootPlacementTop]: u === "top",
      [Ve.rootPlacementTopWithTimezoneSelector]: u === "top" && a,
      [Ve.rootPlacementBottom]: u === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: p, children: [
      /* @__PURE__ */ s.jsxs("div", { className: Ve.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          e,
          t,
          l,
          c,
          r.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          o,
          d,
          h,
          r.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
}
const Hp = "dateRangePickerTestId";
class Wp extends k {
  static defaultProps = {
    withDateInput: !0,
    withTimePicker: !1,
    timePickerProps: { start: {}, end: {} },
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(e) {
    super(e);
    const {
      startDate: t,
      endDate: n,
      timezone: o,
      presetKey: r,
      presets: a,
      focusedInput: l = "startDate"
    } = e;
    this.state = {
      startTime: t ? j(t).format(Fe) : null,
      endTime: n ? j(n).format(Fe) : null,
      timezone: It(o) ? o : j.tz.guess(!0),
      presetKey: a?.find(({ key: c }) => c === r)?.key ?? null,
      focusedInput: l,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(e) {
    this.updateTimeOnDateChange(e), this.recalculateDatePickerKey(e), this.updateTimezoneFromProps(e), this.updatePresetKey(e);
  }
  visibleCalendarMonthRef = O();
  updatePresetKey(e) {
    const { presetKey: t } = this.props;
    e.presetKey !== t && this.setState({
      presetKey: this.props.presets?.find(({ key: n }) => n === t)?.key ?? null
    });
  }
  updateTimezoneFromProps(e) {
    const { timezone: t } = this.props;
    e.timezone !== t && It(t) && this.setState({ timezone: t });
  }
  getDateConstraints() {
    const { maxDate: e, minDate: t } = this.props, n = this.dateFormat;
    return {
      minDate: t ? j(t, n) : j("0001-01-01"),
      maxDate: e ? j(e, n) : j("9999-12-31")
    };
  }
  onTimezoneChange(e) {
    const { startDate: t, endDate: n } = this.props, { presetKey: o } = this.state;
    this.setState(
      { timezone: e },
      () => this.onDatesChange({ startDate: t, endDate: n }, o)
    );
  }
  onStartDateChange(e) {
    this.onDatesChange({ startDate: e, endDate: this.props.endDate });
  }
  onEndDateChange(e) {
    this.onDatesChange({ endDate: e, startDate: this.props.startDate });
  }
  onDatesChange(e, t = null) {
    const { startTime: n, endTime: o, timezone: r } = this.state, { timeRoundingStrategy: a } = this.props, l = this.addTimezoneToDate(
      e.startDate,
      r
    ), c = this.addTimezoneToDate(
      e.endDate,
      r
    );
    let d = l?.clone().startOf(a) || null, h = c?.clone().endOf(a) || null, u = e.startDate?.clone().startOf(a) || null, p = e.endDate?.clone().endOf(a) || null;
    if (this.setState({ presetKey: t }), t) {
      this.setState(
        {
          startTime: e.startDate?.clone().startOf(a).format(Fe) ?? null,
          endTime: e.endDate?.clone().startOf(a).format(Fe) ?? null
        },
        () => {
          this.props.onChange({
            startDate: d,
            localStartDate: u,
            endDate: h,
            localEndDate: p,
            timezone: r,
            localTimezone: j.tz.guess(!0),
            presetKey: t
          });
        }
      );
      return;
    }
    n && (d = this.addTimeToDate(
      l,
      n,
      "startDate"
    ), u = this.addTimeToDate(
      e.startDate,
      n,
      "startDate"
    )), o && (h = this.addTimeToDate(c, o, "endDate"), p = this.addTimeToDate(e.endDate, o, "endDate")), this.props.onChange({
      startDate: d,
      localStartDate: u,
      endDate: h,
      localEndDate: p,
      timezone: r,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(e) {
    if (!e)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: t, endDate: n, key: o } = e;
      this.onDatesChange({ startDate: t, endDate: n }, o);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(e, t) {
    const { startDate: n, endDate: o } = this.props;
    this.setState(
      (r) => ({
        ...r,
        [e]: t
      }),
      () => this.onDatesChange({ startDate: n, endDate: o })
    );
  }
  addTimezoneToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props;
    return It(t) ? e.clone().tz(t, !0) : e.clone().startOf(n);
  }
  handleFocusChange(e) {
    this.setState({ focusedInput: e ?? "startDate" });
  }
  addTimeToDate(e, t, n) {
    if (!e)
      return null;
    const { timeRoundingStrategy: o } = this.props, [r, a] = t.split(":");
    return !r || !a ? n === "startDate" ? e.clone().startOf(o) : e.clone().endOf(o) : e.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(a, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(e) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: t } = this.props, { minDate: n, maxDate: o } = this.getDateConstraints();
    return !e.isBetween(n, o, t);
  }
  updateTimeOnDateChange({
    startDate: e,
    endDate: t
  }) {
    const { startDate: n, endDate: o } = this.props;
    n?.isSame(e) || this.setState({
      startTime: n ? j(n).format(Fe) : null
    }), o?.isSame(t) || this.setState({
      endTime: o ? j(o).format(Fe) : null
    });
  }
  recalculateDatePickerKey({
    startDate: e,
    endDate: t
  }) {
    const { startDate: n, endDate: o } = this.props;
    if (t && e && !n && !o)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!o && !t) && !(!o && t)) {
      if (o && !t) {
        const r = this.visibleCalendarMonthRef.current?.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && o.isSame(r, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (o && t) {
        if (o.isSame(t, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: e } = this.props;
    return e || j.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: e,
      endDate: t,
      disabled: n,
      withTimezoneSelector: o,
      timezoneSelectorProps: r
    } = this.props, { timezone: a } = this.state;
    if (!o)
      return null;
    const l = !!e || !!t, c = !l && !n, d = !l || n || r?.disabled;
    return /* @__PURE__ */ s.jsx(
      Ar,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: a
      }
    );
  }
  renderInputFields(e) {
    const {
      withDateInput: t,
      withTimePicker: n,
      withTimezoneSelector: o,
      timePickerProps: r,
      disabled: a,
      startDate: l,
      endDate: c,
      selectableMinutes: d,
      selectableHours: h,
      inputsPlacement: u,
      timeFormat: p,
      timeRoundingStrategy: m
    } = this.props;
    if (u !== e || !t && !n)
      return null;
    const { startTime: g, endTime: b, focusedInput: y } = this.state, { minDate: _, maxDate: v } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Us,
      {
        dateFormat: this.dateFormat,
        timeFormat: p,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: l,
        endDate: c,
        startTime: g,
        endTime: b,
        minDate: _,
        maxDate: v,
        disabled: a,
        withDateInput: t,
        withTimePicker: n,
        hasTimezoneSelector: o,
        timePickerProps: r,
        selectableMinutes: d,
        selectableHours: h,
        placement: e,
        timeRoundingStrategy: m,
        focusedInput: y
      }
    );
  }
  renderPresets() {
    const { presets: e } = this.props, { presetKey: t } = this.state;
    return e?.length ? /* @__PURE__ */ s.jsx(
      Er,
      {
        value: t,
        presets: e,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: e, calendarProps: t, disabled: n, startDate: o, endDate: r } = this.props, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Bn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Bn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Hp,
        className: f(St.root, e),
        children: [
          /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              gr.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: o,
                endDate: r,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Pr,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Rr,
                initialVisibleMonth: () => o || r || j(),
                transitionDuration: 0,
                ...t
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Mp = "h-datePicker-single-inputFields--datePickerInputFields__root", zp = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", Vp = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", Kp = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", Up = "h-datePicker-single-inputFields--datePickerInputFields__input", qp = "h-datePicker-single-inputFields--datePickerInputFields__alert", ot = {
  root: Mp,
  rootPlacementTop: zp,
  rootPlacementTopWithTimezoneSelector: Vp,
  rootPlacementBottom: Kp,
  input: Up,
  alert: qp
};
class qs extends k {
  dateValidators;
  instanceId;
  constructor(e) {
    super(e);
    const { dateFormat: t } = e;
    this.state = {
      dateInputValue: this.props.date?.format(t) ?? "",
      dateError: null
    }, this.instanceId = qs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new qe(
      e.dateFormat,
      this.parseDateString,
      { maxDate: e.maxDate, minDate: e.minDate }
    );
  }
  componentDidUpdate(e) {
    this.syncDateWithProps(e);
  }
  static instanceCount = 0;
  syncDateWithProps(e) {
    const { date: t, timeRoundingStrategy: n } = this.props, o = j(t);
    if (!(t === e.date || o?.isSame(j(e.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: o.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(e) {
    const t = this.ensureValidChars(e.target.value);
    this.setState({ dateInputValue: t }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: e } = this.state;
    if (e === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: t, error: n } = this.dateValidators.isSingleDateValid(e);
    if (!t) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(e))
    );
  }
  parseDateString(e) {
    return j(e, this.props.dateFormat, !0);
  }
  ensureValidChars(e) {
    return e.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: e, dateFormat: t, withDateInput: n } = this.props, { dateInputValue: o, dateError: r } = this.state;
    return n ? /* @__PURE__ */ s.jsx(
      Ge,
      {
        className: ot.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: o,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: t.toLowerCase(),
        disabled: e,
        status: r ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: e,
      time: t,
      withTimePicker: n,
      timePickerProps: o = {},
      disabled: r,
      onTimeChange: a,
      timeFormat: l
    } = this.props;
    if (!n)
      return null;
    const c = !e && !r, d = !e || r;
    return /* @__PURE__ */ s.jsx(
      se,
      {
        content: "Please select a date first.",
        disabled: !c,
        side: "right",
        children: /* @__PURE__ */ s.jsx("div", { className: ot.input, children: /* @__PURE__ */ s.jsx(
          tn,
          {
            disabled: d,
            onSelect: a,
            selectedItems: t ? [t] : void 0,
            ...o,
            timeFormat: l
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: e } = this.state;
    return /* @__PURE__ */ s.jsx(
      Gn,
      {
        className: ot.alert,
        variant: e ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: e, placement: t } = this.props, n = f(ot.root, {
      [ot.rootPlacementTop]: t === "top",
      [ot.rootPlacementTopWithTimezoneSelector]: t === "top" && e,
      [ot.rootPlacementBottom]: t === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
}
const Gp = "datePickerTestId";
class Yp extends k {
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    withDateInput: !1,
    withTimePicker: !1,
    timePickerProps: {},
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(e) {
    super(e);
    const { date: t, timezone: n, presets: o, presetKey: r } = e;
    this.state = {
      time: t ? j(t).format(Fe) : null,
      timezone: It(n) ? n : j.tz.guess(!0),
      presetKey: o?.find(({ key: a }) => a === r)?.key ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(e) {
    this.updateTimeOnDateChange(e), this.recalculateDatePickerKey();
  }
  visibleCalendarMonthRef = O();
  getDateConstraints() {
    const { maxDate: e, minDate: t } = this.props;
    return {
      minDate: t || j("0001-01-01"),
      maxDate: e || j("9999-12-31")
    };
  }
  onTimezoneChange(e) {
    const { date: t } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: e }, () => this.onDateChange(t, n));
  }
  onDateChange(e, t = null) {
    const { time: n, timezone: o } = this.state, { timeRoundingStrategy: r } = this.props, a = this.addTimezoneToDate(e, o);
    let l = a?.clone().startOf(r) || null, c = e?.clone().startOf(r) || null;
    if (this.setState({ presetKey: t }), t) {
      this.setState(
        {
          time: e?.clone().startOf(r).format(Fe) ?? null
        },
        () => {
          this.props.onChange({
            date: l,
            localDate: c,
            timezone: o,
            localTimezone: j.tz.guess(!0),
            presetKey: t
          });
        }
      );
      return;
    }
    n && (l = this.addTimeToDate(a, n), c = this.addTimeToDate(e, n)), this.props.onChange({
      date: l,
      localDate: c,
      timezone: o,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(e) {
    e ? this.onDateChange(e.date, e.key) : this.onDateChange(null);
  }
  handleTimeChange(e) {
    const { date: t } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: e
      }),
      () => this.onDateChange(t)
    );
  }
  addTimezoneToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props;
    return It(t) ? j(e).clone().tz(t, !0) : e.clone().startOf(n);
  }
  addTimeToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props, [o, r] = t.split(":");
    return !o || !r ? e.clone().startOf(n) : e.clone().set({
      hours: parseInt(o, 10),
      minutes: parseInt(r, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(e) {
    const { disabled: t, timeRoundingStrategy: n } = this.props;
    if (t)
      return !0;
    const { minDate: o, maxDate: r } = this.getDateConstraints();
    return !e.isBetween(o, r, n);
  }
  updateTimeOnDateChange(e) {
    const { date: t } = this.props;
    e.date?.isSame(t) || this.setState({
      time: t ? j(t).format(Fe) : null
    });
  }
  recalculateDatePickerKey() {
    const { date: e } = this.props, t = this.visibleCalendarMonthRef.current?.state.currentMonth;
    if (t && e && !e.isSame(t, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: e, disabled: t, withTimezoneSelector: n, timezoneSelectorProps: o } = this.props, { timezone: r } = this.state;
    if (!n)
      return null;
    const a = !!e, l = !a && !t, c = !a || t || o?.disabled;
    return /* @__PURE__ */ s.jsx(
      Ar,
      {
        disabled: c,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !l,
          ...o?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: r,
        ...o
      }
    );
  }
  renderInputFields(e) {
    const {
      dateFormat: t,
      timeFormat: n,
      withDateInput: o,
      withTimePicker: r,
      withTimezoneSelector: a,
      timePickerProps: l,
      selectableMinutes: c,
      selectableHours: d,
      disabled: h,
      date: u,
      inputsPlacement: p,
      timeRoundingStrategy: m
    } = this.props;
    if (p !== e || !o && !r)
      return null;
    const { time: g } = this.state, { minDate: b, maxDate: y } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      qs,
      {
        dateFormat: t,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: g,
        date: u,
        minDate: b,
        maxDate: y,
        disabled: h,
        withDateInput: o,
        withTimePicker: r,
        hasTimezoneSelector: a,
        timePickerProps: l,
        selectableMinutes: c,
        selectableHours: d,
        placement: e,
        timeRoundingStrategy: m
      }
    );
  }
  renderPresets() {
    const { presets: e } = this.props, { presetKey: t } = this.state;
    return e?.length ? /* @__PURE__ */ s.jsx(
      Er,
      {
        value: t,
        presets: e,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: e, calendarProps: t, disabled: n, date: o } = this.props, { datePickerKey: r } = this.state, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Bn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Bn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Gp,
        className: f(St.root, e),
        children: [
          /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              gr.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: o,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Pr,
                daySize: 32,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Rr,
                initialVisibleMonth: () => o || j(),
                onFocusChange: L,
                focused: !0,
                transitionDuration: 0,
                ...t
              },
              r
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Qp = "h-dialer--dialer__dialer", Xp = "h-dialer--dialer__number", Zp = "h-dialer--dialer__letters", Jp = "h-dialer--dialer__asterisk", En = {
  dialer: Qp,
  number: Xp,
  letters: Zp,
  asterisk: Jp
}, em = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: En.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class Gk extends k {
  render() {
    const { className: e, onInput: t, ...n } = this.props, o = f(En.dialer, e);
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: em.map((r) => /* @__PURE__ */ Oi(
      "div",
      {
        className: f(En.number),
        ...Vn(() => t(r.value)),
        key: r.value
      },
      /* @__PURE__ */ s.jsx($.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ s.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ s.jsx($.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ s.jsx("span", { className: En.letters, children: r.letters }) })
    )) });
  }
}
const tm = "h-fieldWrapper--fieldWrapper__root", nm = "h-fieldWrapper--fieldWrapper__rootDisabled", sm = "h-fieldWrapper--fieldWrapper__label", om = "h-fieldWrapper--fieldWrapper__alert", yn = {
  root: tm,
  rootDisabled: nm,
  label: sm,
  alert: om
}, rm = "fieldWrapper";
class z extends k {
  static hasStatus(e, t) {
    return e?.[t] ? e?.touched === void 0 || e.touched === !0 : !1;
  }
  static getStatusMessage(e, t) {
    if (this.hasStatus(e, t))
      return e?.[t];
  }
  static getStatus(e) {
    return z.hasStatus(e, "error") ? "error" : z.hasStatus(e, "warning") ? "warning" : z.hasStatus(e, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: e, description: t } = this.props;
    let n = t, o;
    return z.hasStatus(e, "error") ? (n = z.getStatusMessage(e, "error"), o = "error") : z.hasStatus(e, "warning") ? (n = z.getStatusMessage(e, "warning"), o = "warning") : z.hasStatus(e, "success") && (n = z.getStatusMessage(e, "success"), o = "success"), /* @__PURE__ */ s.jsx(Gn, { variant: o, className: yn.alert, children: n });
  }
  render() {
    const {
      className: e,
      labelFor: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = f(
      yn.root,
      {
        [yn.rootDisabled]: a
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": rm,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ s.jsx(
            zs,
            {
              required: r,
              htmlFor: t,
              helpIcon: l,
              className: yn.label,
              children: n
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Ds extends k {
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ s.jsx(
          Ge,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const im = "h-dropdownSelect--dropdownSelectContainer__search", am = "h-dropdownSelect--dropdownSelectContainer__pagination", lm = "h-dropdownSelect--dropdownSelectContainer__selectionActions", cm = "h-dropdownSelect--dropdownSelectContainer__extra", xn = {
  search: im,
  pagination: am,
  selectionActions: lm,
  extra: cm
}, dm = "DROP_SEARCH_INPUT";
class $r extends me {
  listRef;
  searchRef;
  static getDerivedStateFromProps(e, t) {
    const { dropdownOpen: n } = e, o = { ...t };
    return n || (o.searchValue = "", o.activeItemIndex = 0), o;
  }
  constructor(e) {
    super(e), this.state = {
      searchValue: "",
      activeItemIndex: 0
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.handleItemKeyDown = this.handleItemKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = O(), this.searchRef = O();
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(e) {
    const { dropdownOpen: t } = this.props;
    !e.dropdownOpen && t && this.onOpen();
  }
  getInput() {
    const { searchValue: e } = this.state;
    return {
      name: dm,
      value: e,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(e) {
    const { key: t } = e, { searchValue: n, activeItemIndex: o } = this.state, { triggerClose: r, items: a, disabledItems: l = [] } = this.props, c = a.map((h, u) => ({ item: h, index: u })).filter(({ item: h }) => !l.includes(h.id)).map(({ index: h }) => h), d = c.indexOf(o);
    if (t === "Escape")
      n === "" ? r() : this.clearSearch();
    else if (t === "ArrowDown") {
      if (e.preventDefault(), c.length > 0) {
        const h = d < c.length - 1 ? d + 1 : 0;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "ArrowUp") {
      if (e.preventDefault(), c.length > 0) {
        const h = d > 0 ? d - 1 : c.length - 1;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "Home")
      e.preventDefault(), c.length > 0 && this.setState(
        { activeItemIndex: c[0] },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (t === "End")
      e.preventDefault(), c.length > 0 && this.setState(
        {
          activeItemIndex: c[c.length - 1]
        },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (t === "Enter") {
      e.preventDefault();
      const h = a[o];
      if (h && !l.includes(h.id)) {
        const { onChange: u, selectedItems: p = [] } = this.props;
        if (u) {
          const m = p.some((g) => (typeof g == "object" ? g.id : g) === h.id);
          this.onChange(h, !m);
        } else
          this.onSelect(h);
      }
    }
  }
  handleItemKeyDown(e) {
    const { key: t } = e, { activeItemIndex: n } = this.state, { triggerClose: o, items: r, disabledItems: a = [] } = this.props, l = r.map((d, h) => ({ item: d, index: h })).filter(({ item: d }) => !a.includes(d.id)).map(({ index: d }) => d), c = l.indexOf(n);
    if (t === "Escape")
      o();
    else if (t === "ArrowDown") {
      if (e.preventDefault(), l.length > 0) {
        const d = c < l.length - 1 ? c + 1 : 0;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "ArrowUp") {
      if (e.preventDefault(), l.length > 0) {
        const d = c > 0 ? c - 1 : l.length - 1;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else t === "Home" ? (e.preventDefault(), l.length > 0 && this.setState(
      { activeItemIndex: l[0] },
      () => this.listRef.current?.focusActiveItem()
    )) : t === "End" && (e.preventDefault(), l.length > 0 && this.setState(
      {
        activeItemIndex: l[l.length - 1]
      },
      () => this.listRef.current?.focusActiveItem()
    ));
  }
  search(e) {
    const { onSearch: t } = this.props, { value: n } = e.target;
    typeof t == "function" && t(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n,
      activeItemIndex: 0
    });
  }
  onSelect(e) {
    const { onSelect: t, keepOpen: n, triggerClose: o } = this.props;
    typeof t == "function" && t(e), n && this.focusSearch(), !n && typeof o == "function" && o();
  }
  onChange(e, t) {
    const { onChange: n, keepOpen: o, triggerClose: r } = this.props;
    typeof n == "function" && n(e, t), o && this.focusSearch(), !o && typeof r == "function" && r();
  }
  onOpen() {
    const { hasSearch: e } = this.props;
    e ? this.focusSearch() : setTimeout(() => {
      this.listRef.current?.focusActiveItem();
    }, 0);
  }
  focusSearch() {
    const { hasSearch: e } = this.props;
    if (e && this.searchRef.current) {
      const t = this.searchRef.current.querySelector("input");
      t && t.focus();
    }
  }
  clearSearch = () => {
    const { onSearch: e } = this.props, { searchValue: t } = this.state;
    t && (typeof e == "function" && e(""), this.setState({ searchValue: "" }));
  };
  render() {
    const {
      className: e,
      itemComponent: t,
      emptyComponent: n,
      suggestionComponent: o,
      optionComponent: r,
      items: a,
      hasSearch: l,
      searchPlaceholder: c,
      pagination: d,
      keepOpen: h,
      onSelect: u,
      onSearch: p,
      onSuggest: m,
      onChange: g,
      onClear: b,
      onClearText: y,
      triggerClose: _,
      dropdownOpen: v,
      emptyMessage: S,
      selectedItems: C,
      disabledItems: x,
      tooltipItems: w,
      activeItem: I,
      itemsDisplayCount: T,
      itemHeight: N,
      renderSuggestion: H,
      searchSuggestion: D,
      ...R
    } = this.props;
    if (!v)
      return null;
    const { searchValue: A, activeItemIndex: K } = this.state, oe = a.length === 0, ne = a[K] ?? I ?? a[0] ?? null, E = f(e);
    return /* @__PURE__ */ s.jsxs("div", { ...R, className: E, children: [
      l && /* @__PURE__ */ s.jsx("div", { className: xn.search, ref: this.searchRef, children: /* @__PURE__ */ s.jsx(
        Ds,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: c
        }
      ) }),
      !!(l && o || r) && /* @__PURE__ */ s.jsxs("div", { className: xn.extra, children: [
        r,
        l && typeof o == "function" && /* @__PURE__ */ s.jsx(
          o,
          {
            searched: A,
            onSuggest: m,
            triggerClose: h ? void 0 : _,
            clearSearch: this.clearSearch,
            items: a,
            searchSuggestion: D,
            renderSuggestion: H
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        !oe && /* @__PURE__ */ s.jsx(
          Vs,
          {
            ref: this.listRef,
            pagination: d,
            items: a,
            onSelect: this.onSelect,
            onChange: this.onChange,
            onKeyDown: this.handleItemKeyDown,
            clearSearch: this.clearSearch,
            selectedItems: C,
            disabledItems: x,
            itemComponent: t,
            tooltipItems: w,
            itemsDisplayCount: T,
            itemHeight: N,
            activeItem: ne
          }
        ),
        oe && typeof n == "function" && /* @__PURE__ */ s.jsx(n, { label: S || "" })
      ] }),
      typeof b == "function" && /* @__PURE__ */ s.jsx("div", { className: xn.selectionActions, children: /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "secondary",
          disabled: C?.length === 0,
          onClick: b,
          children: y || "Clear"
        }
      ) }),
      !!d && !d.infinite && /* @__PURE__ */ s.jsxs("div", { className: xn.pagination, children: [
        /* @__PURE__ */ s.jsx(
          te,
          {
            variant: "secondary",
            disabled: !d.previousEnable,
            onClick: d.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ s.jsx(
          te,
          {
            variant: "secondary",
            disabled: !d.nextEnable,
            onClick: d.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class Gs extends k {
  static defaultProps = {
    className: "",
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    pagination: !1,
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    onToggle: () => {
    },
    onKeyDown: () => {
    },
    emptyComponent: cn,
    emptyMessage: "No items found",
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  render() {
    const {
      className: e,
      items: t,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      children: b,
      buttonProps: y,
      dropdownProps: _,
      containerProps: v,
      pagination: S,
      emptyComponent: C,
      emptyMessage: x,
      selectedItems: w,
      disabledItems: I,
      tooltipItems: T,
      activeItem: N,
      itemsDisplayCount: H,
      itemHeight: D,
      optionComponent: R,
      renderSuggestion: A,
      searchSuggestion: K,
      ...oe
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      ct,
      {
        ...oe,
        className: e,
        buttonProps: { variant: "secondary", ...y },
        dropdownProps: _,
        dropdown: /* @__PURE__ */ s.jsx(ln.Consumer, { children: ({ toggleDropdown: ne, dropdownOpen: E }) => /* @__PURE__ */ s.jsx(
          $r,
          {
            ...v,
            items: t,
            itemComponent: m,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: g,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: n,
            onChange: o,
            onClear: a,
            onClearText: l,
            onKeyDown: c,
            triggerClose: ne,
            dropdownOpen: E,
            pagination: S,
            emptyComponent: C,
            emptyMessage: x,
            selectedItems: w,
            disabledItems: I,
            tooltipItems: T,
            activeItem: N,
            itemsDisplayCount: H,
            itemHeight: D,
            optionComponent: R,
            renderSuggestion: A,
            searchSuggestion: K
          }
        ) }),
        children: b
      }
    );
  }
}
const hm = "h-dropdownSelectMultiple--dropdownSelectMultiple__items", um = "h-dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown", pm = "h-dropdownSelectMultiple--dropdownSelectMultiple__tagName", cs = {
  items: hm,
  moreItemsDropdown: um,
  tagName: pm
};
class mm extends me {
  static defaultProps = {
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    emptyComponent: cn,
    emptyMessage: "No items found",
    buttonText: "+Select item",
    selectedItems: []
  };
  getItems() {
    const { items: e } = this.props;
    return e;
  }
  render() {
    const {
      items: e,
      itemComponent: t,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      hasSearch: l,
      searchPlaceholder: c,
      onSuggest: d,
      suggestionComponent: h,
      emptyComponent: u,
      emptyMessage: p,
      keepOpen: m,
      containerProps: g,
      buttonText: b,
      selectedItems: y,
      optionComponent: _,
      ...v
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Gs,
      {
        ...v,
        containerProps: g,
        items: this.getItems(),
        itemComponent: t,
        hasSearch: l,
        searchPlaceholder: c,
        suggestionComponent: h,
        onSuggest: d,
        keepOpen: m,
        onSearch: r,
        onSelect: n,
        onChange: o,
        onClear: a,
        emptyComponent: u,
        emptyMessage: p,
        selectedItems: y,
        optionComponent: _,
        children: b
      }
    );
  }
}
class Yk extends me {
  static defaultProps = {
    MoreItemsItemComponent: ku,
    hideSelectedItems: !1,
    disabledItems: [],
    tooltipItems: {}
  };
  constructor(e) {
    super(e), this.getListItem = this.getListItem.bind(this), this.getListMoreItem = this.getListMoreItem.bind(this);
  }
  resolveItem(e) {
    if (typeof e == "object")
      return e;
    const t = this.props.items.find((n) => n.id === e);
    return t || { id: pr(), name: "Unknown" };
  }
  getItemName(e) {
    return e.name.toString().trim();
  }
  isItemDisabled(e) {
    return this.props.disabledItems ? this.props.disabledItems.indexOf(e.id) >= 0 : !1;
  }
  getTooltip(e) {
    const { tooltipItems: t } = this.props;
    return !t || Ls(t[e.id]) ? null : t[e.id];
  }
  getListItem(e, t) {
    const { onRemove: n } = this.props, o = this.resolveItem(e), r = this.getItemName(o), a = this.getTooltip(o), l = /* @__PURE__ */ s.jsx(
      kt,
      {
        className: cs.tagName,
        onDelete: () => n(o),
        color: o.color,
        disabled: this.isItemDisabled(o),
        children: r
      },
      o.id
    );
    return a ? /* @__PURE__ */ s.jsx(se, { ...a, children: l }, t) : l;
  }
  getListMoreItem(e) {
    const { MoreItemsItemComponent: t, onRemove: n } = this.props, o = this.resolveItem(e), r = this.getTooltip(o), a = /* @__PURE__ */ s.jsx(
      t,
      {
        item: o,
        onSelect: n,
        disabled: this.isItemDisabled(o),
        clearSearch: L,
        isLoading: !1,
        checked: !1
      },
      o.id
    );
    return r ? /* @__PURE__ */ s.jsx(se, { ...r, children: a }, o.id) : a;
  }
  getPreviewItems() {
    const {
      selectedItems: e,
      previewItemsNumber: t,
      moreItemsDropdownProps: n = {}
    } = this.props;
    let o = [], r = [], a = "";
    if (t && e) {
      if (e.length > 0 && e.length < t)
        o = e.map(this.getListItem);
      else if (e.length >= t) {
        const h = e.slice(0, t), u = e.slice(
          t,
          e.length
        );
        o = h.map(this.getListItem), r = u.map(this.getListMoreItem), a = u.length.toString();
      }
    } else
      o = e.map(this.getListItem);
    const { className: l, ...c } = n, d = /* @__PURE__ */ s.jsx(
      "div",
      {
        ...c,
        className: f(cs.moreItemsDropdown, l),
        children: r
      }
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      t && e.length > t ? /* @__PURE__ */ s.jsxs(
        ct,
        {
          noArrow: !0,
          buttonProps: { variant: "tertiary" },
          dropdown: d,
          children: [
            "+ ",
            a,
            /* @__PURE__ */ s.jsx("span", { children: " selected" })
          ]
        }
      ) : null
    ] });
  }
  render() {
    const {
      items: e,
      selectedItems: t,
      previewItemsNumber: n,
      className: o,
      onSelect: r,
      onChange: a,
      onSearch: l,
      hasSearch: c,
      searchPlaceholder: d,
      onSuggest: h,
      onRemove: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      pagination: b,
      emptyComponent: y,
      emptyMessage: _,
      containerProps: v,
      moreItemsDropdownProps: S,
      MoreItemsItemComponent: C,
      hideSelectedItems: x,
      disabledItems: w,
      tooltipItems: I,
      optionComponent: T,
      ...N
    } = this.props, H = f(
      {
        [cs.items]: !0
      },
      o
    );
    return /* @__PURE__ */ s.jsxs("div", { className: H, children: [
      /* @__PURE__ */ s.jsx(
        mm,
        {
          items: e,
          itemComponent: m,
          hasSearch: c,
          searchPlaceholder: d,
          suggestionComponent: g,
          onSuggest: h,
          keepOpen: p,
          onSearch: l,
          onSelect: r,
          onChange: a,
          pagination: b,
          emptyComponent: y,
          emptyMessage: _,
          containerProps: v,
          selectedItems: t,
          disabledItems: w,
          tooltipItems: I,
          optionComponent: T,
          ...N
        }
      ),
      !x && this.getPreviewItems()
    ] });
  }
}
const gm = "h-fieldButton--fieldButton__button", fm = {
  button: gm
}, Qk = W(
  function({
    className: e,
    buttonClassName: t,
    label: n,
    meta: o,
    disabled: r,
    helpIcon: a,
    description: l,
    noAlert: c,
    noLabel: d,
    children: h,
    ...u
  }, p) {
    const m = f(t, fm.button);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        meta: o,
        disabled: r,
        helpIcon: a,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ s.jsx(
          te,
          {
            ref: p,
            disabled: r,
            ...u,
            className: m,
            children: h
          }
        )
      }
    );
  }
), bm = "h-inputDatePicker--inputDatePicker__root", ym = "h-inputDatePicker--inputDatePicker__inputContainer", xm = "h-inputDatePicker--inputDatePicker__input", _m = "h-inputDatePicker--inputDatePicker__rootReadOnly", Cm = "h-inputDatePicker--inputDatePicker__iconsContainer", vm = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", wm = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", Sm = "h-inputDatePicker--inputDatePicker__calendarIcon", Im = "h-inputDatePicker--inputDatePicker__clearIcon", Le = {
  root: bm,
  inputContainer: ym,
  input: xm,
  rootReadOnly: _m,
  iconsContainer: Cm,
  rootHasClearIcon: vm,
  rootHasWrapperIcon: wm,
  calendarIcon: Sm,
  clearIcon: Im
}, km = "inputDatePickerTestId";
class Dm extends k {
  inputRef;
  rootRef;
  datePickerContainerRef;
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    name: Math.floor(Math.random() * 1e8).toString()
  };
  constructor(e) {
    super(e), this.inputRef = O(), this.rootRef = O(), this.datePickerContainerRef = O(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(e, t) {
    const { isDropdownOpen: n } = this.state;
    n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    this.datePickerContainerRef.current?.querySelector('input[type="text"]')?.focus();
  }
  handleWindowClick(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleWindowKeyDown(e) {
    Nt(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(e) {
    const { onChange: t, value: n } = this.props;
    typeof t == "function" && t(e), (n ?? e !== null) && this.inputRef.current?.focus();
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: e } = this.props;
    e || this.showDropdown();
  }
  handleInputBlur(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleInputClick(e) {
    const { readOnly: t } = this.props;
    t || (e.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: e }) {
    Kn(e) && this.showDropdown();
  }
  handleCalendarIconClick(e) {
    const { readOnly: t } = this.props;
    t || (e.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: e,
      name: t,
      value: n,
      onChange: o,
      dateFormat: r,
      dropdownProps: a,
      prefix: l,
      suffix: c,
      icon: d,
      status: h,
      placeholder: u,
      disabled: p,
      datePickerProps: m,
      clearable: g,
      minDate: b,
      maxDate: y,
      readOnly: _,
      ...v
    } = this.props, { isDropdownOpen: S } = this.state;
    return /* @__PURE__ */ s.jsx(
      Be,
      {
        prefix: l,
        suffix: c,
        disabled: p,
        icon: d,
        active: S,
        status: h,
        children: /* @__PURE__ */ s.jsxs("div", { className: Le.inputContainer, children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ...v,
              id: t,
              name: t,
              className: Le.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: p,
              placeholder: u || r?.toLowerCase(),
              autoComplete: "off",
              value: An(n) ? void 0 : n?.format(r) ?? "",
              onChange: An(n) ? void 0 : L,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: Le.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      U,
      {
        className: Le.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon() {
    const { clearable: e, value: t, disabled: n } = this.props;
    return !e || !t ? null : /* @__PURE__ */ s.jsx(
      U,
      {
        className: Le.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: e,
      minDate: t,
      maxDate: n,
      timezone: o,
      datePickerProps: r,
      disabled: a,
      dropdownProps: l,
      dateFormat: c
    } = this.props, { isDropdownOpen: d, shouldRerenderDatePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(Je, { ...l, isOpen: d, children: /* @__PURE__ */ s.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Yp,
      {
        disabled: a,
        ...r,
        dateFormat: c,
        date: e ?? null,
        timezone: o,
        onChange: this.handleDateChange,
        minDate: t,
        maxDate: n
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: e, value: t, clearable: n, readOnly: o, icon: r } = this.props, a = f(Le.root, e, {
      [Le.rootHasClearIcon]: n && t,
      [Le.rootHasWrapperIcon]: !!r,
      [Le.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": km,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class Xk extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const {
      input: { onChange: t }
    } = this.props;
    t?.({
      date: e?.date ? e.date.toISOString() : "",
      localDate: e?.localDate ? e.localDate.toISOString() : "",
      timezone: e?.timezone || "",
      localTimezone: e?.localTimezone || ""
    });
  }
  render() {
    const {
      className: e,
      input: { value: t, name: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: a,
        labelFor: n,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          Dm,
          {
            name: n,
            value: ks(t?.localDate) ? j(t.localDate, j.ISO_8601) : null,
            timezone: t?.timezone,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Tm = "h-inputDateRangePicker--inputDateRangePicker__root", jm = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", Nm = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", Fm = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", Pm = "h-inputDateRangePicker--inputDateRangePicker__input", Rm = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", Em = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", Lm = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", Am = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", $m = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", Om = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", Bm = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", Hm = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", Wm = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", he = {
  root: Tm,
  inputsContainer: jm,
  arrowContainer: Nm,
  inputContainer: Fm,
  input: Pm,
  rootReadOnly: Rm,
  iconsContainer: Em,
  rootStartDateHasClearIcon: Lm,
  startDateIconsContainer: Am,
  rootEndDateHasClearIcon: $m,
  endDateIconsContainer: Om,
  rootHasWrapperIcon: Bm,
  calendarIcon: Hm,
  clearIcon: Wm
}, Mm = "inputDateRangePickerTestId";
class nn extends k {
  inputsRef;
  rootRef;
  dateRangePickerContainerRef;
  static getInputName(e, t) {
    return e[t] || `${e}__${t}`;
  }
  static defaultProps = {
    name: {
      startDate: Math.floor(Math.random() * 1e8).toString(),
      endDate: Math.floor(Math.random() * 1e8).toString()
    }
  };
  constructor(e) {
    super(e), this.inputsRef = {
      startDate: O(),
      endDate: O()
    }, this.rootRef = O(), this.dateRangePickerContainerRef = O(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(e, t) {
    const { isDropdownOpen: n, focusedInput: o } = this.state;
    n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== t.isDropdownOpen || o !== t.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    const { focusedInput: e } = this.state, t = this.dateRangePickerContainerRef.current?.querySelectorAll(
      'input[type="text"]'
    );
    e === "startDate" ? t?.[0]?.focus() : t?.[1]?.focus();
  }
  handleWindowClick(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleWindowKeyDown(e) {
    Nt(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(e) {
    const { onChange: t, value: n } = this.props, { focusedInput: o } = this.state;
    typeof t == "function" && t(e), (n?.[o] ?? e[o] !== null) && this.inputsRef[o].current?.focus();
  }
  handleClearIconClick(e, t) {
    const { value: n, timezone: o, localTimezone: r } = this.props, a = {
      startDate: t === "startDate" ? null : n?.startDate ?? null,
      localStartDate: t === "startDate" ? null : n?.localStartDate ?? null,
      endDate: t === "endDate" ? null : n?.endDate ?? null,
      localEndDate: t === "endDate" ? null : n?.localEndDate ?? null,
      timezone: o || null,
      localTimezone: r || null
    };
    this.handleDatesChange(a);
  }
  showDropdown(e) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: e,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(e, t) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(t);
  }
  handleInputBlur(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: e }, t) {
    Kn(e) && this.showDropdown(t);
  }
  handleInputClick(e, t) {
    const { readOnly: n } = this.props;
    n || (e.stopPropagation(), this.showDropdown(t));
  }
  handleCalendarIconClick(e, t) {
    const { readOnly: n } = this.props;
    n || (e.stopPropagation(), this.showDropdown(t));
  }
  get dateFormat() {
    const { dateFormat: e } = this.props;
    return e || j.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: e, suffix: t, icon: n, status: o, disabled: r } = this.props, { isDropdownOpen: a } = this.state;
    return /* @__PURE__ */ s.jsx(
      Be,
      {
        prefix: e,
        suffix: t,
        disabled: r,
        icon: n,
        active: a,
        status: o,
        children: /* @__PURE__ */ s.jsxs("div", { className: he.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ s.jsx("div", { className: he.arrowContainer, children: /* @__PURE__ */ s.jsx(P, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(e, t) {
    const {
      className: n,
      clearable: o,
      dateFormat: r,
      dateRangePickerProps: a,
      disabled: l,
      dropdownProps: c,
      icon: d,
      localTimezone: h,
      maxDate: u,
      minDate: p,
      name: m,
      onChange: g,
      placeholder: b,
      prefix: y,
      readOnly: _,
      status: v,
      suffix: S,
      tabIndex: C,
      timezone: x,
      value: w,
      ...I
    } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: he.inputContainer, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...I,
          id: nn.getInputName(m, e),
          name: nn.getInputName(m, e),
          className: he.input,
          ref: this.inputsRef[e],
          onClick: (T) => this.handleInputClick(T, e),
          onFocus: (T) => this.handleInputFocus(T, e),
          onBlur: (T) => this.handleInputBlur(T),
          onKeyDown: (T) => this.handleInputKeydown(T, e),
          disabled: l,
          placeholder: b?.[e] || b || this.dateFormat?.toLowerCase(),
          autoComplete: "off",
          value: w && j(w[e]).isValid() ? j(w[e]).format(this.dateFormat) : "",
          onChange: An(w) ? void 0 : L,
          tabIndex: t ?? C,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: f(he.iconsContainer, {
            [he.startDateIconsContainer]: e === "startDate",
            [he.endDateIconsContainer]: e === "endDate"
          }),
          children: [
            this.renderClearIcon(e),
            this.renderCalendarIcon(e)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(e) {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ s.jsx(
      U,
      {
        className: he.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, e),
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon(e) {
    const { clearable: t, value: n, disabled: o } = this.props;
    return !t || !n?.[e] ? null : /* @__PURE__ */ s.jsx(
      U,
      {
        className: he.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: o,
        onClick: (r) => this.handleClearIconClick(r, e)
      }
    );
  }
  renderDropdown() {
    const {
      value: e,
      minDate: t,
      maxDate: n,
      timezone: o,
      dateRangePickerProps: r,
      disabled: a,
      dropdownProps: l
    } = this.props, { isDropdownOpen: c, focusedInput: d, shouldRerenderDateRangePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(Je, { ...l, isOpen: c, children: /* @__PURE__ */ s.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Wp,
      {
        disabled: a,
        ...r,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: e?.startDate ?? null,
        endDate: e?.endDate ?? null,
        timezone: o ?? null,
        minDate: t,
        maxDate: n,
        focusedInput: d
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: e, value: t, clearable: n, readOnly: o, icon: r } = this.props, a = f(he.root, e, {
      [he.rootStartDateHasClearIcon]: n && t?.startDate,
      [he.rootEndDateHasClearIcon]: n && t?.endDate,
      [he.rootHasWrapperIcon]: !!r,
      [he.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Mm,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class Zk extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const {
      input: { onChange: t }
    } = this.props;
    t?.({
      startDate: e?.startDate ? e.startDate.toISOString() : "",
      localStartDate: e?.localStartDate ? e.localStartDate.toISOString() : "",
      endDate: e?.endDate ? e.endDate.toISOString() : "",
      localEndDate: e?.localEndDate ? e.localEndDate.toISOString() : "",
      timezone: e?.timezone ?? "",
      localTimezone: e?.localTimezone ?? ""
    });
  }
  getDateRange({
    localStartDate: e,
    localEndDate: t
  }) {
    const n = ks(e) ? j(e, j.ISO_8601) : null, o = ks(t) ? j(t, j.ISO_8601) : null;
    return {
      startDate: n,
      endDate: o
    };
  }
  render() {
    const {
      className: e,
      input: { name: t, value: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props, { timezone: b, localTimezone: y } = n;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: a,
        labelFor: nn.getInputName(t, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          nn,
          {
            name: t,
            value: this.getDateRange(n),
            timezone: b,
            localTimezone: y,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const zm = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format",
  "inlineCode",
  "blockquote"
], lt = (i) => Di(i), Ys = (i, e = window) => e.getComputedStyle(i).display === "block", Ye = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
);
function ds(i, e) {
  const t = {
    ctrlKey: [
      "Control",
      ...Ye ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...Ye ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...Ye ? ["$metaOrCtrl"] : []]
  };
  return i.some((n) => {
    if (e.code !== n[1])
      return !1;
    const o = n[0] ?? [];
    return Object.entries(t).every(
      ([r, a]) => {
        const l = Ti(
          a,
          o
        ).length;
        return e[r] ? l > 0 : l === 0;
      }
    );
  });
}
const Vm = (i, e, t) => {
  if (!i || e < 0 || t < 0) return !1;
  const n = i?.textContent?.length ?? 0;
  return !(e > n || t > n);
}, Km = (i, e) => i.document.queryCommandState(e), Um = (i) => i.document.queryCommandValue("formatBlock"), qm = (i) => i.type.indexOf("image/") === 0, Ro = (i, e) => {
  const t = en();
  return {
    src: (i.URL || i.webkitURL).createObjectURL(e),
    uid: t
  };
}, Gm = (i) => {
  i && i.querySelectorAll("td").forEach((e) => {
    e.style.border = "1px solid currentColor";
  });
}, Ts = (i) => {
  i.setAttribute("dir", "auto");
  const e = window.getComputedStyle(i).direction;
  i.setAttribute("dir", e);
}, Eo = (i) => {
  i && i.childNodes.forEach((e) => {
    e.nodeType !== Node.ELEMENT_NODE && e.nodeType !== Node.TEXT_NODE || lt(e) && Ys(e) && Ts(e);
  });
}, Qs = (i, e = !0) => {
  const t = document.createElement("div");
  return t.style.display = "none", t.innerHTML = i, document.body.appendChild(t), t.childNodes.forEach((n) => {
    if (!(n.nodeType !== Node.ELEMENT_NODE && n.nodeType !== Node.TEXT_NODE)) {
      if (lt(n) && Ys(n))
        n.innerHTML = Qs(n.innerHTML, !1), Ts(n);
      else if (e) {
        const o = document.createElement("div");
        o.appendChild(n.cloneNode(!0)), n.replaceWith(o), Ts(o);
      }
    }
  }), document.body.removeChild(t), t.innerHTML;
}, Lo = (i, e = { side: "both" }) => {
  const { side: t } = e, n = i.split(""), o = " ", r = "&nbsp;";
  let a = 0, l = n.length - 1;
  if (t === "both" || t === "start")
    for (; n[a] === o; )
      n[a++] = r;
  if (t === "both" || t === "end")
    for (; n[l] === o; )
      n[l--] = r;
  return n.join("");
}, Hn = (i, e) => i.split(/\r\n|\r|\n/g).map((t, n) => t ? e.inline && n === 0 ? Lo(t, { side: "end" }) : `<div>${Lo(t)}</div>` : "<br />").join("");
function Ym(i) {
  const e = "&nbsp;", o = Qm(i.anchorNode), r = Xm(i.anchorNode);
  if (i.anchorNode?.nodeType === Node.TEXT_NODE && o.endsWith(e)) {
    const { focusOffset: a, anchorOffset: l } = i, c = Array.prototype.indexOf.call(
      i.anchorNode.parentElement?.childNodes,
      i.anchorNode
    ), d = r.replaceAll(e, " ").replace(/.$/, " "), h = document.createTextNode(d);
    if (i.anchorNode.parentElement?.childNodes[c].replaceWith(h), i?.rangeCount && i?.rangeCount > 0 && Vm(h, a, l)) {
      const u = i.getRangeAt(0);
      u.setStart(h, a), u.setEnd(h, l);
    }
  }
}
function Qm(i) {
  if (!i)
    return "";
  if (i instanceof Element)
    return i.innerHTML;
  const e = document.createElement("span");
  return e.appendChild(i.cloneNode()), e.innerHTML;
}
function Xm(i) {
  return !i || !i.textContent ? "" : i.textContent;
}
const Zm = "h-inputRichText-addonTrigger--addonTrigger__root", Jm = {
  root: Zm
};
function eg(i) {
  if (!i)
    return null;
  const { focusOffset: e, anchorOffset: t, anchorNode: n } = i;
  return e !== t || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, e) || null;
}
const _n = (i, e) => {
  const t = Or(i, e);
  return t && i.triggers.isAddonTrigger(t.matchedTrigger) ? t.matchedTrigger : null;
}, Cn = (i, e) => {
  const t = Or(i, e);
  return t ? t.match : null;
}, Or = (i, e) => e ? i.triggers.test(e) : null, Ao = "input-rich-text-addon-trigger", tg = (i, e) => {
  const t = i.selection.recreate({ focus: !1 });
  if (!t || !e) return null;
  const n = t.getRangeAt(0).getBoundingClientRect();
  return i.ref.current && n && t?.rangeCount && t?.rangeCount > 0 ? t.getRangeAt(0).getBoundingClientRect() : null;
}, ng = (i, e) => {
  if (i.ref.current && e) {
    const t = i.ref.current.getBoundingClientRect();
    return {
      left: `${e.x - t.x}px`,
      top: `${e.y - t.y}px`,
      height: "0",
      width: `${e.width}px`,
      position: "absolute"
    };
  }
  return {};
}, Ke = (i) => eg(i.selection.recreate({ focus: !1 })) || "", hs = (i, e) => !!e && i.triggers.isAddonTrigger(e), us = (i) => i?.nodeType === Node.ELEMENT_NODE, js = (i, e) => i.dataset.testid === e ? i : i.parentElement ? js(i.parentElement, e) : null, ft = {};
class sg extends EventTarget {
  /**
   * A map of event listeners for each event type.
   *
   * Since it can be tricky to register/unregister event listeners as data
   * changes in the consumer, we store the event listeners in a map to be able
   * to clear them easily, in order to avoid memory leaks.
   */
  callbacks = {
    focus: [],
    insert: [],
    up: [],
    down: []
  };
  addEventListener(e, t, n) {
    super.addEventListener(e, t, n), t && this.callbacks[e].push(t);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(e) {
    this.callbacks[e].forEach((t) => {
      this.removeEventListener(e, t);
    }), this.callbacks[e] = [];
  }
}
const vt = new sg(), og = ke({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: vt
});
var rg = /* @__PURE__ */ ((i) => (i.FOCUS = "focus", i.INSERT = "insert", i.UP = "up", i.DOWN = "down", i))(rg || {});
const ig = (i) => {
  const { editor: e } = i, [t, n] = V(null), [o, r] = V(null), [a, l] = V(null), [c, d] = V(!1), h = ng(e, a), [u] = V(en()), { dismissText: p } = ft[u] ?? { dismissText: "" }, m = t?.[0] ?? "", g = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  m?.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " ")) || !1, b = F(() => {
    const w = _n(e, Ke(e)), I = Cn(e, Ke(e)), T = tg(e, w);
    hs(e, w) && w?.shouldHandleSelectionChange?.() !== !1 ? (r(w), n(I), l(T)) : (r(null), n(null), l(null)), d(!0);
  }, [e]), y = F(() => {
    const w = _n(e, Ke(e)), I = Cn(e, Ke(e))?.[0];
    return hs(e, w) && !!I;
  }, [e]), _ = F(() => {
    const w = _n(e, Ke(e)), I = Cn(e, Ke(e))?.[0], T = ft[u]?.dismissText || "", N = T ? I?.startsWith(T) : !1;
    return hs(e, w) && !!I && !N;
  }, [e, u]), v = F(() => {
    e.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: _,
        callback: () => {
          vt.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: _,
        callback: () => {
          vt.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: _,
        callback: () => {
          vt.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: _,
        callback: () => {
          vt.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: _,
        callback: (w, I) => {
          const T = Cn(e, Ke(e))?.[0];
          if (!T) {
            ft[u] = {
              dismissText: ""
            };
            return;
          }
          _n(e, Ke(e))?.persistOnEsc === !1 && (I.stopPropagation(), r(null), n(null), l(null)), ft[u] = {
            dismissText: (T.trim().length === 1 ? "" : T) ?? ""
          };
        }
      }
    ]);
  }, [e, _, u]);
  X(() => {
    y() && p !== m && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (g && o?.persistOnEsc !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !g && o?.persistOnEsc === !1) && (ft[u] = {
      dismissText: ""
    });
  }, [p, g, y, m, u, o]);
  const S = F((w) => {
    const I = w.nativeEvent.relatedTarget, T = us(I) && js(I, qr), N = us(I) && js(I, Ao);
    (!us(I) || !T && !N) && d(!1);
  }, []), C = F(
    (w, { inline: I } = {}) => {
      const T = e.selection.recreate();
      if (!T || !o)
        return;
      const H = !!T.anchorNode?.textContent?.match(
        `^${o?.trigger.source}`
      ) && !I ? (
        // Adjust each lines direction if it's been added to a new line
        Qs(
          Hn(w, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        Hn(w, { inline: !0 })
      );
      T?.rangeCount && T?.rangeCount > 0 && e.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        T.getRangeAt(0).createContextualFragment(H),
        {
          getSelection: () => {
            const D = e.selection.recreate();
            if (!D)
              return null;
            const { focusOffset: R } = D, oe = o.trigger.exec(m)?.[1]?.length ?? 0, ne = m.length - oe, E = R - ne;
            if (D?.anchorNode && E >= 0)
              try {
                D.extend(D.anchorNode, E);
              } catch {
              }
            return D;
          }
        }
      );
    },
    [e, m, o]
  );
  if (Tt(() => {
    v(), e.selection.onUpdate(b), e.events.onBlur(S);
  }), Ze(() => {
    delete ft[u];
  }), !o || !c || !m || g)
    return null;
  const x = o.customContainer?.current || e.ref.current?.ownerDocument?.body || window.document.body;
  return /* @__PURE__ */ s.jsx("div", { style: h, children: /* @__PURE__ */ s.jsxs(ji, { open: !0, children: [
    /* @__PURE__ */ s.jsx(Ni, {}),
    /* @__PURE__ */ s.jsx(Fi, { container: x, children: /* @__PURE__ */ s.jsx(
      Pi,
      {
        onOpenAutoFocus: (w) => w.preventDefault(),
        "data-testid": Ao,
        className: Jm.root,
        side: o.popoverContent?.side ?? "top",
        align: o.popoverContent?.align ?? "start",
        children: /* @__PURE__ */ s.jsx(
          og.Provider,
          {
            value: { matchText: m, insertContent: C, eventEmitter: vt },
            children: o.component
          }
        )
      }
    ) })
  ] }) });
}, ag = "h-inputRichText-toolbarButton--toolbarButton__root", lg = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", cg = "h-inputRichText-toolbarButton--toolbarButton__rootActive", dg = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", hg = "h-inputRichText-toolbarButton--toolbarButton__rootWithText", bt = {
  root: ag,
  rootDisabled: lg,
  rootActive: cg,
  rootWithBadge: dg,
  rootWithText: hg
};
function Pe({
  className: i,
  isActive: e,
  icon: t,
  disabled: n,
  showBadge: o,
  text: r,
  tooltip: a,
  tabIndex: l = -1,
  ...c
}) {
  const d = f(
    {
      [bt.root]: bt.root,
      [bt.rootActive]: e,
      [bt.rootDisabled]: n,
      [bt.rootWithBadge]: o,
      [bt.rootWithText]: r
    },
    i
  ), h = /* @__PURE__ */ s.jsx(
    "button",
    {
      tabIndex: l,
      type: "button",
      ...c,
      className: d,
      disabled: n,
      children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(P, { name: t }) }),
        r && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx($.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: r }) })
      ] })
    }
  );
  return a ? /* @__PURE__ */ s.jsx(se, { content: a, side: "top", wrap: "none", children: h }) : h;
}
const ug = "h-inputRichText-attachmentButton--attachmentButton__dropzone", pg = "h-inputRichText-attachmentButton--attachmentButton__fileInput", mg = "h-inputRichText-attachmentButton--attachmentButton__dropdown", gg = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", vn = {
  dropzone: ug,
  fileInput: pg,
  dropdown: mg,
  dropzoneIcon: gg
};
let fg = class extends k {
  static displayName = "AttachmentButtonDropzone";
  constructor(e) {
    super(e), this.state = {
      fileHover: !1
    };
  }
  handleDragEnter = (e) => {
    e.preventDefault();
    const { allowAttachments: t } = this.props;
    !t || !e.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (e) => {
    e.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleAttachmentDrop = (e) => {
    e.preventDefault();
    const { onAddAttachment: t } = this.props;
    e.dataTransfer && t(e.dataTransfer.files), this.setState({
      fileHover: !1
    });
  };
  render() {
    const {
      className: e,
      children: t,
      isAttachmentsUploading: n,
      allowAttachments: o,
      allowInline: r,
      onAddAttachment: a,
      ...l
    } = this.props, { fileHover: c } = this.state, d = f(e), h = c || n;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...l,
        className: d,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          t,
          h && /* @__PURE__ */ s.jsx(Xe, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !h && "Drop the file or click to upload"
        ]
      }
    );
  }
};
const bg = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class yg extends k {
  unsubscribeAddAttachment;
  fileInputRef;
  constructor(e) {
    super(e), this.fileInputRef = O(), this.unsubscribeAddAttachment = Ki;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        this.props.disabled || this.fileInputRef.current?.click();
      }
    );
  }
  componentWillUnmount() {
    this.unsubscribeAddAttachment?.();
  }
  openFileBrowser = (e) => {
    e.preventDefault();
    const { current: t } = this.fileInputRef;
    t && t.click();
  };
  handleFileChanged = (e) => {
    const { onAttachFiles: t, editorWindow: n } = this.props, o = e.target;
    o !== null && o instanceof n.HTMLInputElement && (t(o.files), o.value = "");
  };
  renderDropdown() {
    const { isAttachmentsUploading: e, attachments: t, onAttachFiles: n, children: o } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: vn.dropdown, children: [
      /* @__PURE__ */ s.jsx(
        fg,
        {
          className: vn.dropzone,
          onAddAttachment: n,
          attachments: t,
          isAttachmentsUploading: e,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ s.jsx(P, { name: "paperclip", className: vn.dropzoneIcon })
        }
      ),
      o
    ] });
  }
  preventDefault = (e) => {
    e.preventDefault();
  };
  render() {
    const {
      className: e,
      attachments: t,
      onAttachFiles: n,
      onDetachFile: o,
      isAttachmentsUploading: r,
      dropdownRef: a,
      editorWindow: l,
      disabled: c,
      disabledTooltip: d,
      fixed: h,
      ...u
    } = this.props, p = /* @__PURE__ */ s.jsx(
      Pe,
      {
        onMouseDown: this.preventDefault,
        icon: "paperclip",
        showBadge: t.length > 0,
        disabled: c,
        tooltip: "Insert attachment"
      }
    );
    return c ? /* @__PURE__ */ s.jsx(se, { content: d, disabled: !d, children: p }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: vn.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ s.jsx(
        ct,
        {
          ...u,
          className: e,
          noStyle: !0,
          fixed: h,
          ref: a,
          dropdown: this.renderDropdown(),
          children: p
        }
      )
    ] });
  }
}
const xg = "h-inputRichText-dropzone--dropzone__root", _g = "h-inputRichText-dropzone--dropzone__inlineDropzone", Cg = "h-inputRichText-dropzone--dropzone__attachmentDropzone", vg = "h-inputRichText-dropzone--dropzone__rootDual", wg = "h-inputRichText-dropzone--dropzone__icon", yt = {
  root: xg,
  inlineDropzone: _g,
  attachmentDropzone: Cg,
  rootDual: vg,
  icon: wg
};
class Sg extends k {
  static displayName = "InputRichTextDropzone";
  internalDrag = !1;
  constructor(e) {
    super(e), this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  handleDragStart = () => {
    this.internalDrag = !0;
  };
  handleDragEnd = () => {
    this.internalDrag = !1;
  };
  handleDragEnter = (e) => {
    e.preventDefault();
    const { allowInlineAttachments: t, allowAttachments: n } = this.props;
    if (!t && !n || this.internalDrag) return;
    const o = e.dataTransfer?.types, r = o?.includes("Files"), a = o?.includes("text/uri-list");
    !r && !a || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (e) => {
    e.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleEnterDropzone = (e) => {
    e.preventDefault(), this.setState({
      overDropzone: !0
    });
  };
  handleLeaveDropzone = (e) => {
    e.preventDefault(), this.setState({
      overDropzone: !1
    });
  };
  async fetchDroppedUrl(e, t) {
    if (e.files.length > 0) {
      t(e.files);
      return;
    }
    const n = e.getData("text/uri-list");
    if (n) {
      try {
        const o = new URL(n);
        if (o.protocol !== "http:" && o.protocol !== "https:") return;
      } catch {
        return;
      }
      try {
        const o = await fetch(n);
        if (!o.ok) return;
        const r = await o.blob(), a = n.split("/").pop()?.split("?")[0] || "dropped-image", l = new File([r], a, { type: r.type }), c = new DataTransfer();
        c.items.add(l), t(c.files);
      } catch {
      }
    }
  }
  handleInlineDrop = (e) => {
    e.preventDefault();
    const { onAddInline: t } = this.props;
    e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  handleAttachmentDrop = (e) => {
    e.preventDefault();
    const { onAddAttachment: t } = this.props;
    e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  render() {
    const {
      className: e,
      children: t,
      allowInlineAttachments: n,
      allowAttachments: o,
      onAddInline: r,
      onMouseDown: a,
      attachments: l,
      onAddAttachment: c,
      ...d
    } = this.props, { fileHover: h, overDropzone: u } = this.state, p = f(
      {
        [yt.root]: !0,
        [yt.rootDual]: n && o
      },
      e
    ), m = n || o, g = {};
    return a && (g.onClick = a), m && (g.onDragStart = this.handleDragStart, g.onDragEnd = this.handleDragEnd, g.onDragEnter = this.handleDragEnter, g.onDragOver = this.handleDragEnter, g.onDragLeave = this.handleDragLeave), /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...d,
        tabIndex: -1,
        className: p,
        ...g,
        children: [
          t,
          (h || u) && /* @__PURE__ */ s.jsxs(Xe, { children: [
            n && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: yt.inlineDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(P, { name: "upload", size: 24, className: yt.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            o && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: yt.attachmentDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(P, { name: "paperclip", size: 24, className: yt.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
const Br = (i, e) => i.split(new RegExp(`(${As(e)})`, "gi")).map(
  (t, n) => t.toLowerCase() === e.toLowerCase() ? /* @__PURE__ */ s.jsx("span", { children: t }, n) : t
), Ig = "h-inputRichText-emoji--emoji__root", kg = "h-inputRichText-emoji--emoji__decorator", Dg = "h-inputRichText-emoji--emoji__suggestion", Tg = "h-inputRichText-emoji--emoji__suggestionActive", jg = "h-inputRichText-emoji--emoji__suggestionName", Xt = {
  root: Ig,
  decorator: kg,
  suggestion: Dg,
  suggestionActive: Tg,
  suggestionName: jg
}, Ng = Bi(
  () => import("./emoji-r0LV8WWJ.js").then((i) => i.k).then((i) => ({
    default: i.EmojiPicker
  }))
), Wn = {};
Li.emojis.forEach((i) => {
  i.forEach(
    (e) => {
      e.shortNames && e.shortNames.forEach((t) => {
        Wn[t.replace(/:/g, "")] = e.emoji;
      });
    }
  );
});
const Fg = (i) => {
  const { active: e, item: t, match: n, onSelect: o } = i, r = n ? Br(t, n) : t;
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: () => o(t),
      type: "button",
      "aria-current": e,
      className: f(Xt.suggestion, {
        [Xt.suggestionActive]: e
      }),
      children: [
        Wn[t],
        /* @__PURE__ */ s.jsx("span", { className: Xt.suggestionName, children: r })
      ]
    }
  );
};
class Pg extends k {
  constructor(e) {
    super(e), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: Fg,
      insertContent: this.insertContent
    });
  }
  insertContent(e, t = "", n) {
    this.insertEmoji(Wn[e], t, n);
  }
  insertEmoji(e, t, n) {
    const { editor: o } = this.props, r = document.createElement("span");
    r.classList.add(Xt.decorator), r.innerHTML = e, o.content.insert(r, {
      getSelection: () => {
        const a = o.selection.recreate();
        return t && a?.anchorNode && a.extend(a.anchorNode, n), a;
      }
    });
  }
  getSuggestions = (e) => Object.keys(Wn).filter((n) => n.indexOf(e) !== -1);
  // eslint-disable-next-line no-undef
  preventDefault = (e) => {
    e.preventDefault();
  };
  renderDropdown = () => /* @__PURE__ */ s.jsx(Hi, { fallback: /* @__PURE__ */ s.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ s.jsx(ln.Consumer, { children: ({ toggleDropdown: e }) => /* @__PURE__ */ s.jsx(
    Ng,
    {
      onSelect: (t) => {
        this.insertEmoji(t), e();
      }
    }
  ) }) });
  render() {
    const { className: e, fixed: t } = this.props, n = f(
      {
        [Xt.root]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { className: n, children: /* @__PURE__ */ s.jsx(
      ct,
      {
        icon: "smile",
        dropdown: this.renderDropdown(),
        noStyle: !0,
        fixed: t,
        children: /* @__PURE__ */ s.jsx(
          Pe,
          {
            icon: "smile",
            tooltip: "Emojis",
            onMouseDown: this.preventDefault
          }
        )
      }
    ) });
  }
}
const Rg = "h-inputRichText--inputRichText__inputWrapper", Eg = "h-inputRichText--inputRichText__root", Lg = "h-inputRichText--inputRichText__toolbar", Ag = "h-inputRichText--inputRichText__toolbarHint", $g = "h-inputRichText--inputRichText__toolbarHintVisible", Og = "h-inputRichText--inputRichText__toolbarHintHidden", Bg = "h-inputRichText--inputRichText__editorWrap", Hg = "h-inputRichText--inputRichText__placeholder", Wg = "h-inputRichText--inputRichText__editor", Mg = "h-inputRichText--inputRichText__editorDisabled", zg = "h-inputRichText--inputRichText__fileInput", Vg = "h-inputRichText--inputRichText__uiBlocker", ge = {
  inputWrapper: Rg,
  root: Eg,
  toolbar: Lg,
  toolbarHint: Ag,
  toolbarHintVisible: $g,
  toolbarHintHidden: Og,
  editorWrap: Bg,
  placeholder: Hg,
  editor: Wg,
  editorDisabled: Mg,
  fileInput: zg,
  uiBlocker: Vg
};
function Hr(i, e) {
  const t = (n) => n.replace(/&/g, "&amp;");
  return `<a href="${t(i)}">${t(e)}</a>`;
}
function Xs(i) {
  if (!i || i.length === 0)
    return "";
  const [e = [], t = ""] = i[0];
  if (!t)
    return "";
  const n = e.map((r) => Kg(r)).filter(Boolean), o = Ug(t);
  return Ye ? [...n, o].join("") : [...n, o].join("+");
}
function Kg(i) {
  if (Ye)
    switch (i) {
      case "$metaOrCtrl":
      case "Meta":
        return "⌘";
      case "Control":
      case "$controlOrAlt":
        return "⌃";
      case "Shift":
        return "⇧";
      case "Alt":
        return "⌥";
      default:
        return i;
    }
  switch (i) {
    case "$metaOrCtrl":
    case "Control":
      return "Ctrl";
    case "$controlOrAlt":
    case "Alt":
      return "Alt";
    case "Shift":
      return "Shift";
    case "Meta":
      return "Win";
    default:
      return i;
  }
}
function Ug(i) {
  if (i.startsWith("Key"))
    return i.slice(3);
  if (i.startsWith("Digit"))
    return i.slice(5);
  switch (i) {
    case "Backslash":
      return "\\";
    case "Slash":
      return "/";
    case "Enter":
      return Ye ? "↵" : "Enter";
    case "Escape":
      return "Esc";
    case "Space":
      return "Space";
    case "Backspace":
      return Ye ? "⌫" : "Backspace";
    case "Delete":
      return Ye ? "⌦" : "Del";
    case "ArrowUp":
      return "↑";
    case "ArrowDown":
      return "↓";
    case "ArrowLeft":
      return "←";
    case "ArrowRight":
      return "→";
    default:
      return i;
  }
}
const qg = "h-inputRichText-linkButton--linkButton__linkOpener", Gg = "h-inputRichText-linkButton--linkButton__dropdownContainer", $o = {
  linkOpener: qg,
  dropdownContainer: Gg
}, Yg = "h-inputRichText-linkButton--linkMenu__root", Qg = "h-inputRichText-linkButton--linkMenu__field", ps = {
  root: Yg,
  field: Qg
};
class Xg extends k {
  constructor(e) {
    super(e);
    const { initialText: t, initialUrl: n } = e;
    this.state = {
      textValue: t,
      urlValue: n
    };
  }
  componentDidUpdate(e) {
    const { initialText: t, initialUrl: n } = this.props;
    (t !== e.initialText || n !== e.initialUrl) && this.setState({
      textValue: t,
      urlValue: n
    });
  }
  handleTextChange = (e) => {
    e && this.setState({
      textValue: e.target.value
    });
  };
  handleUrlChange = (e) => {
    e && this.setState({
      urlValue: e.target.value
    });
  };
  handleAddLink = (e) => {
    e?.preventDefault();
    const { onAddLink: t, toggleDropdown: n } = this.props, { textValue: o, urlValue: r } = this.state;
    r && (t(o || void 0, r), n());
  };
  handleUnlink = (e) => {
    e.preventDefault();
    const { onUnlink: t, toggleDropdown: n } = this.props;
    t(), n();
  };
  handleKeyDown = (e) => {
    e.key === "Enter" && (e.preventDefault(), this.handleAddLink());
  };
  render() {
    const {
      className: e,
      initialText: t,
      initialUrl: n,
      onAddLink: o,
      toggleDropdown: r,
      onUnlink: a,
      ...l
    } = this.props, { textValue: c, urlValue: d } = this.state, h = f({ [ps.root]: !0 }, e);
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsx(
        Ds,
        {
          label: "Link title",
          noAlert: !0,
          className: ps.field,
          input: {
            value: c,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ s.jsx(
        Ds,
        {
          label: "Link URL",
          noAlert: !0,
          className: ps.field,
          input: {
            value: d,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(B, { gap: "200", children: [
        /* @__PURE__ */ s.jsx(te, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!d && /* @__PURE__ */ s.jsx(te, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const Wr = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: [[["$metaOrCtrl", "Shift"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (i) => i.command.run("unlink")
  }
], Zg = ({ editor: i }) => {
  const [e, t] = Wi((v) => v + 1, 0), [n, o] = Mi(!1), r = Y(null), a = Y(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = zi({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  Tt(() => {
    i.events.onMouseOver((v) => {
      m(v);
    }), a.current = i.events.subscribe("hyperlink", () => {
      o(!0);
    }), i.selection.onUpdate(() => {
      p();
    });
  }), Ze(() => {
    a.current?.();
  });
  const p = () => {
    const v = i.selection.recreate();
    if (!v)
      return;
    const { anchorNode: S, focusNode: C } = v;
    if (S && C === S && S.parentElement?.nodeName === "A") {
      const { href: x, innerText: w } = S.parentElement;
      u({
        selectedLink: x,
        selectedText: w
      });
    } else
      u({
        selectedLink: "",
        selectedText: v.toString()
      });
  }, m = F(
    (v) => {
      const { target: S } = v, { current: C } = i.ref;
      if (C && S && S instanceof HTMLAnchorElement) {
        const x = C.getBoundingClientRect(), w = S.getBoundingClientRect();
        u({
          hoverLinkHref: S.getAttribute("href"),
          hoverLinkBounds: {
            top: w.top - x.top,
            left: w.left - x.left,
            width: w.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [i.ref, u]
  ), g = F(() => {
    const v = i.selection.recreate();
    if (!v)
      return;
    const { anchorNode: S, focusNode: C } = v;
    if (S && S === C && S.parentElement?.nodeName === "A") {
      const x = document.createRange();
      x.selectNodeContents(S.parentElement), v.removeAllRanges(), v.addRange(x);
    }
  }, [i.selection]), b = F(
    (v, S) => {
      S && (g(), i.command.run("insertHTML", Hr(S, v || S)), t());
    },
    [i.command, g]
  ), y = F(() => {
    g(), i.command.run("unlink");
  }, [i.command, g]), _ = F((v) => {
    v.preventDefault();
  }, []);
  return xr(r, () => {
    o(!1);
  }), yr("Escape", () => {
    o(!1), g();
  }), /* @__PURE__ */ s.jsxs(Xe, { children: [
    /* @__PURE__ */ s.jsxs("div", { ref: r, className: $o.dropdownContainer, children: [
      /* @__PURE__ */ s.jsx(
        Pe,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: _,
          onClick: () => o(),
          tooltip: `Insert link (${Xs(Wr[0].keybindings)})`
        }
      ),
      n && /* @__PURE__ */ s.jsx(Je, { isOpen: n, children: /* @__PURE__ */ s.jsx(
        Xg,
        {
          onAddLink: b,
          toggleDropdown: o,
          initialUrl: d,
          initialText: h,
          onUnlink: y
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ s.jsx(
      "a",
      {
        className: $o.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ s.jsx(P, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, Jg = "h-tabs--tabs__root", ef = "h-tabs--tabs__tabs", tf = "h-tabs--tabs__tab", nf = "h-tabs--tabs__tabTop", sf = "h-tabs--tabs__tabTopActive", of = "h-tabs--tabs__tabTopSelected", rf = "h-tabs--tabs__tabLeft", af = "h-tabs--tabs__tabLeftActive", lf = "h-tabs--tabs__tabLeftSelected", cf = "h-tabs--tabs__tabBottom", df = "h-tabs--tabs__tabBottomActive", hf = "h-tabs--tabs__tabBottomSelected", uf = "h-tabs--tabs__tabRight", pf = "h-tabs--tabs__tabRightActive", mf = "h-tabs--tabs__tabRightSelected", gf = "h-tabs--tabs__tabDisabled", re = {
  root: Jg,
  tabs: ef,
  tab: tf,
  tabTop: nf,
  tabTopActive: sf,
  tabTopSelected: of,
  tabLeft: rf,
  tabLeftActive: af,
  tabLeftSelected: lf,
  tabBottom: cf,
  tabBottomActive: df,
  tabBottomSelected: hf,
  tabRight: uf,
  tabRightActive: pf,
  tabRightSelected: mf,
  tabDisabled: gf
}, ff = 13;
class bf extends k {
  constructor(e) {
    super(e), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: e, onChange: t, disabled: n } = this.props;
    n || t(e);
  }
  handleOnKeyDown(e) {
    e.keyCode === ff && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: e,
      placement: t,
      className: n,
      disabled: o,
      active: r,
      selectedClassName: a
    } = this.props;
    let l = f(re.tab, n, {
      [re.tabDisabled]: o,
      [re.tabTop]: t === "top",
      [re.tabRight]: t === "right",
      [re.tabLeft]: t === "left",
      [re.tabBottom]: t === "bottom",
      [re.tabTopSelected]: t === "top" && e,
      [re.tabRightSelected]: t === "right" && e,
      [re.tabLeftSelected]: t === "left" && e,
      [re.tabBottomSelected]: t === "bottom" && e,
      [re.tabTopActive]: t === "top" && r,
      [re.tabRightActive]: t === "right" && r,
      [re.tabLeftActive]: t === "left" && r,
      [re.tabBottomActive]: t === "bottom" && r
    });
    return a && (l = f(l, { [a]: e })), l;
  }
  render() {
    const { id: e, label: t, icon: n, disabled: o, slotEnd: r, slotStart: a } = this.props;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: o ? -1 : 0,
        children: [
          a || !!n && /* @__PURE__ */ s.jsx(P, { name: n, className: "icon-vertical-fix" }),
          t,
          r
        ]
      },
      e
    );
  }
}
class Zs extends k {
  containerRef;
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(e) {
    super(e), this.containerRef = O(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: e,
    label: t,
    icon: n,
    disabled: o,
    slotEnd: r,
    slotStart: a
  }) {
    const {
      selectedId: l,
      activeId: c,
      onChange: d,
      tabsPlacement: h,
      tabClassName: u,
      tabSelectedClassName: p
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      bf,
      {
        selected: e === l,
        className: u,
        selectedClassName: p,
        id: e,
        label: t,
        icon: n,
        onChange: d,
        placement: h,
        disabled: o,
        active: e === c,
        slotEnd: r,
        slotStart: a
      },
      e
    );
  }
  renderTabs() {
    const { tabs: e } = this.props;
    return e.map(this.renderTab);
  }
  render() {
    const {
      className: e,
      tabClassName: t,
      tabSelectedClassName: n,
      tabs: o,
      selectedId: r,
      onChange: a,
      tabsPlacement: l,
      activeId: c,
      ...d
    } = this.props, h = f(re.root, e);
    return /* @__PURE__ */ s.jsx("div", { ref: this.containerRef, ...d, className: h, children: /* @__PURE__ */ s.jsx("div", { className: re.tabs, children: this.renderTabs() }) });
  }
}
const yf = rn(Zs, {
  fallback: null
}), xf = "h-inputRichText-quickResponseSelector--quickResponseItem__root", _f = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", Cf = "h-inputRichText-quickResponseSelector--quickResponseItem__name", Mt = {
  root: xf,
  rootActive: _f,
  name: Cf
};
class ms extends k {
  constructor(e) {
    super(e), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: e, onSelect: t, item: n } = this.props;
    e || t(n);
  }
  render() {
    const {
      className: e,
      item: t,
      isLoading: n,
      onSelect: o,
      active: r,
      searchValue: a,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !n && t ? t : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = f(
      {
        [Mt.root]: Mt.root,
        [Mt.rootActive]: r
      },
      e
    ), m = u ? Br(d, u) : d;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ s.jsx($.Heading, { variant: "heading-3", className: Mt.name, children: m }),
          /* @__PURE__ */ s.jsx($.Paragraph, { variant: "4", className: Mt.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const vf = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", wf = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", Sf = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", If = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", kf = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", Df = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", xt = {
  container: vf,
  dropdownButtonContainer: wf,
  tabbedDropdown: Sf,
  tabbedDropdownTabs: If,
  tabbedDropdownTabsContent: kf,
  regularDropdown: Df
}, Oo = /(^|\s)=/, gs = "Quick replies";
class Tf extends me {
  constructor(e) {
    super(e), this.state = {
      searchTerm: "",
      selectedTab: e.languages[0]?.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.triggers.add({
      trigger: Oo,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: ms,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(e) {
    const { quickResponsesApi: t } = this.props;
    return {
      id: e.name,
      matched: t.params.search ?? "",
      ...e
    };
  }
  getTabDefinitions() {
    const { languages: e } = this.props;
    return e.map((t) => ({
      id: t.code,
      label: t.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: e } = this.props;
    return new Promise((t) => e.getItemsAsyncStatus === "loading" ? t(e.items.map(this.normalizeSuggestion)) : t(
      e.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  preventDefault = (e) => {
    e.preventDefault();
  };
  handleSelect = (e, t) => {
    this.insertContent(e)?.then(() => {
      t && t();
    });
  };
  insertContent = (e, t, n) => {
    const { renderQuickResponse: o, sanitize: r, editor: a } = this.props;
    return o(e).then((l) => {
      const c = a.selection.recreate();
      if (!c)
        return;
      const d = !!t, h = d && !!c.anchorNode?.textContent?.match(
        `^${Oo.source}`
      ) || !d && !c.anchorNode?.textContent;
      let u;
      h ? u = Qs(
        Hn(r(l), { inline: !1 })
      ) : u = Hn(r(l), { inline: !0 }), c?.rangeCount && c?.rangeCount > 0 && a.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        c.getRangeAt(0).createContextualFragment(u),
        {
          getSelection: () => {
            const p = a.selection.recreate();
            return d && p?.anchorNode && p.extend(p.anchorNode, n), p;
          }
        }
      );
    });
  };
  handleToggle(e) {
    const { quickResponsesApi: t, languages: n } = this.props;
    e && (t.params.search !== "" || t.params.locale !== n[0]?.code) && this.setState({ searchTerm: "", selectedTab: n[0]?.code }, () => {
      const { searchTerm: o, selectedTab: r } = this.state;
      this.handleSearchChange(o, r, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: e } = this.props;
    return {
      nextEnable: e.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(e, t, n) {
    const { quickResponsesApi: o } = this.props;
    return o.paramsChange({ search: e, locale: t }, n).then((r) => r.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(e) {
    this.setState({ searchTerm: e }, () => {
      const { searchTerm: t, selectedTab: n } = this.state;
      this.handleSearchChange(t, n);
    });
  }
  handleTabChange(e) {
    this.setState({ selectedTab: e }, () => {
      const { searchTerm: t, selectedTab: n } = this.state;
      this.handleSearchChange(t, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ s.jsx(
      Pe,
      {
        icon: this.props.iconName ?? "bolt",
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: e, quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ s.jsx(se, { content: `${gs} (=)`, children: /* @__PURE__ */ s.jsx(
      Gs,
      {
        className: e,
        dropdownProps: {
          className: xt.regularDropdown
        },
        containerProps: { className: xt.container },
        items: t.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: ms,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    ) });
  }
  renderItemsWithTabs() {
    const { className: e } = this.props, { selectedTab: t } = this.state;
    return /* @__PURE__ */ s.jsx("div", { className: xt.dropdownButtonContainer, children: /* @__PURE__ */ s.jsx(se, { content: `${gs} (=)`, children: /* @__PURE__ */ s.jsx(
      ct,
      {
        className: e,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: gs },
        dropdown: /* @__PURE__ */ s.jsxs("div", { className: xt.tabbedDropdown, children: [
          /* @__PURE__ */ s.jsx(
            Zs,
            {
              className: xt.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: t,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: xt.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) }) });
  }
  renderTabItems() {
    const { quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ s.jsx(ln.Consumer, { children: ({ dropdownOpen: t, closeDropdown: n }) => /* @__PURE__ */ s.jsx(
      $r,
      {
        dropdownOpen: t,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: e.items.map(this.normalizeSuggestion),
        itemComponent: ms,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (o) => this.handleSelect(o, n),
        emptyComponent: cn,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: e } = this.props;
    return e?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const jf = "h-inputRichText-formatSelector--formatSelector__root", Nf = "h-inputRichText-formatSelector--formatSelector__list", Ff = "h-inputRichText-formatSelector--formatSelector__selector", Pf = "h-inputRichText-formatSelector--formatSelector__option", Rf = "h-inputRichText-formatSelector--formatSelector__optionActive", Ef = "h-inputRichText-formatSelector--formatSelector__button", _t = {
  root: jf,
  list: Nf,
  selector: Ff,
  option: Pf,
  optionActive: Rf,
  button: Ef
}, Ns = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "div"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H1>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H2>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H3>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H4>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H5>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (i) => i.allowFormatting.includes("format")
  }
], Bo = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class Lf extends k {
  preventDefault = (e) => {
    e.preventDefault();
  };
  renderDropdown() {
    const { editor: e } = this.props;
    return /* @__PURE__ */ s.jsx(ln.Consumer, { children: ({ closeDropdown: t }) => /* @__PURE__ */ s.jsx("ul", { className: _t.list, children: Ns.map((n) => {
      const o = "condition" in n;
      if (!(!o || o && n.condition(e)))
        return;
      const a = Bo[n.name];
      return /* @__PURE__ */ s.jsx(
        "li",
        {
          className: f(_t.option, {
            [_t.optionActive]: this.isActiveFormat(a)
          }),
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: _t.button,
              onClick: () => {
                n.callback?.(e), t();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(e) {
    const { formatBlock: t } = this.props;
    return !!(!t && e.default || e.tag === t || e.tag === `<${t.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    return Ns.find(
      (e) => this.isActiveFormat(Bo[e.name])
    )?.label ?? "Normal";
  }
  render() {
    const { className: e, editor: t, formatBlock: n, ...o } = this.props, r = f(_t.root, e);
    return /* @__PURE__ */ s.jsx(
      ct,
      {
        className: r,
        ...o,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ s.jsxs("div", { className: _t.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ s.jsx(P, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const Af = "h-inputRichText-stylingMenu--stylingMenu__menu", $f = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", Ho = {
  menu: Af,
  buttonsContainer: $f
}, Mr = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (i) => i.command.run("bold"),
    condition: (i) => i.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (i) => i.command.run("italic"),
    condition: (i) => i.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: [[["Control", "$controlOrAlt"], "Digit7"]],
    callback: (i) => i.command.run("insertOrderedList"),
    condition: (i) => i.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: [[["Control", "$controlOrAlt"], "Digit8"]],
    callback: (i) => i.command.run("insertUnorderedList"),
    condition: (i) => i.allowFormatting.includes("unorderedList")
  },
  {
    name: "inlineCode",
    label: "Inline code",
    icon: "code",
    keybindings: [[["$metaOrCtrl"], "KeyE"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyE"]],
    callback: (i) => i.command.run("inlineCode"),
    condition: (i) => i.allowFormatting.includes("inlineCode")
  },
  {
    name: "blockquote",
    label: "Quote text",
    icon: "quote",
    keybindings: [[["Control", "$controlOrAlt"], "Digit9"]],
    callback: (i) => {
      const e = i.window.getSelection();
      if (!e) return;
      const t = e.anchorNode, o = !!(lt(t) ? t : t?.parentElement)?.closest("blockquote");
      i.command.run("formatBlock", o ? "div" : "<BLOCKQUOTE>");
    },
    condition: (i) => i.allowFormatting.includes("blockquote")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [[["$metaOrCtrl"], "Backslash"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "Backslash"]],
    callback: (i) => i.command.run("removeFormat")
  }
], zr = [...Ns, ...Mr];
class Of extends k {
  domRef;
  constructor(e) {
    super(e), this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = O(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(e, t) {
    const { isOpen: n } = this.state, { editorWindow: o } = this.props;
    n !== t.isOpen && o[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: e } = this.state, { editorWindow: t } = this.props;
    e && t.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: e } = this.props;
    this.setState({
      currentFormat: Um(e)
    });
  }
  handleClickOutside = (e) => {
    const { current: t } = this.domRef;
    t && e.target instanceof Element && e.target !== t && !t.contains(e.target) && this.setState({
      isOpen: !1
    });
  };
  handleClick = (e) => {
    e.preventDefault();
    const { isOpen: t } = this.state;
    this.setState({
      isOpen: !t
    });
  };
  handleToolbarButtonClick(e) {
    return (t) => {
      const { editor: n } = this.props;
      t.preventDefault(), e && (zr.find(
        (r) => r.name === e
      )?.callback(n), this.forceUpdate());
    };
  }
  styleActive(e) {
    const { editor: t } = this.props;
    if (e === "blockquote") {
      const n = t.window.getSelection();
      if (!n) return !1;
      const o = n.anchorNode;
      return !!(lt(o) ? o : o?.parentElement)?.closest("blockquote");
    }
    return t.command.active(e);
  }
  render() {
    const { className: e, isActive: t, editor: n, editorWindow: o, ...r } = this.props, { isOpen: a, currentFormat: l } = this.state, c = f(e);
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: c, ref: this.domRef, children: [
      a && /* @__PURE__ */ s.jsxs("div", { className: Ho.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ s.jsx(
          Lf,
          {
            formatBlock: l,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: Ho.buttonsContainer, children: Mr.map((d) => {
          const h = "condition" in d;
          if (!(!h || h && d.condition(n)))
            return;
          const p = Xs(d.keybindings), m = p ? `${d.label} (${p})` : d.label;
          return /* @__PURE__ */ s.jsx(
            Pe,
            {
              isActive: this.styleActive(d.name),
              onMouseDown: this.handleToolbarButtonClick(d.name),
              icon: d.icon,
              tooltip: m
            },
            d.name
          );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ s.jsx(
        Pe,
        {
          isActive: t,
          icon: "format",
          onClick: this.handleClick,
          tooltip: "Formatting"
        }
      )
    ] });
  }
}
const Bf = "h-inputRichText-suggestions--suggestions__dropdown", Hf = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", Wf = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", Mf = "h-inputRichText-suggestions--suggestions__dropdownTabs", zf = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", zt = {
  dropdown: Bf,
  dropdownWithTabs: Hf,
  dropdownWithoutTabs: Wf,
  dropdownTabs: Mf,
  dropdownTabsContent: zf
};
function Vf(i) {
  if (!i)
    return null;
  const { focusOffset: e, anchorOffset: t, anchorNode: n } = i;
  return e !== t || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, e);
}
class Kf extends k {
  dropdownRef;
  tabsRef;
  constructor(e) {
    super(e), this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = O(), this.tabsRef = O(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.selection.onUpdate(this.handleSelectionChange), e.events.onBlur(this.handleBlur), e.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (t, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(e, t) {
    const { suggestionIndex: n, tabIndex: o } = this.state;
    n !== t.suggestionIndex && this.updateSuggestionScroll(), o !== t.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: e } = this.state;
    return e === "suggestion" && this.hasSuggestions() || e === "tab" && this.hasTabs();
  }
  handleArrowKey(e) {
    const { selectionMode: t } = this.state;
    t === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(e) : t === "tab" && this.hasTabs() && this.tabsNavigate(e);
  }
  handleEscapeKey(e) {
    const { selectionMode: t } = this.state;
    this.shouldRenderDropdown() && e.stopPropagation(), t === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    const { selectionMode: e, tabIndex: t, suggestionTrigger: n } = this.state;
    if (e === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (e === "tab" && this.hasTabs()) {
      const o = n?.getTabs?.()[t];
      o && this.handleTabChange(o.id);
    }
  }
  handleBlur(e) {
    const {
      nativeEvent: { relatedTarget: t }
    } = e;
    t === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: e } = this.state;
    return !!e?.length;
  }
  hasTabs() {
    return !!this.state.suggestionTrigger?.getTabs?.().length;
  }
  getSelectedTabIndex() {
    const { suggestionTrigger: e, selectedTab: t } = this.state;
    return this.hasTabs() ? e?.getTabs?.().findIndex((n) => n.id === t) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(e) {
    this.setState(({ suggestionIndex: t, suggestions: n }) => {
      if (n && n.length) {
        let o;
        return e < 0 ? o = t > 0 ? t - 1 : n.length - 1 : o = (t + 1) % n.length, {
          suggestionIndex: o
        };
      }
      return null;
    });
  }
  tabsNavigate(e) {
    this.setState(({ tabIndex: t, suggestionTrigger: n }) => {
      const o = n?.getTabs?.();
      if (o?.length) {
        let r;
        return e < 0 ? r = t > 0 ? t - 1 : o.length - 1 : r = (t + 1) % o.length, {
          tabIndex: r
        };
      }
      return null;
    });
  }
  lookForTriggers(e, t) {
    const { editor: n } = this.props, { selectedTab: o, selectionMode: r } = this.state, a = Vf(n.selection.recreate({ focus: !1 }));
    if (a) {
      const l = n.triggers.test(a);
      if (l && n.triggers.isSuggestionTrigger(l.matchedTrigger)) {
        const { match: c, matchedTrigger: d } = l, h = d?.getTabs?.();
        if (h?.length) {
          let p = null;
          if (e ? p = {
            selectionMode: "suggestion",
            selectedTab: e,
            tabIndex: -1
          } : o ? e = o : p = {
            selectionMode: "tab",
            selectedTab: h[0].id,
            tabIndex: 0
          }, p && this.setState(p, () => {
            e || this.lookForTriggers();
          }), !e)
            return;
        } else r !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          d.getSuggestions(c[1], e, t)
        ).then((p) => {
          this.updateSuggestions(c, d, p);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(e, t) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: o } = this.props, r = o.selection.recreate();
        if (r) {
          const { focusOffset: a, anchorNode: l } = r;
          if (l) {
            if (a - e >= 0)
              try {
                r.extend(l, a - e);
              } catch (c) {
                n?.(c);
              }
            if (r?.rangeCount && r?.rangeCount > 0) {
              const c = r.getRangeAt(0).getBoundingClientRect();
              r.collapseToEnd(), setTimeout(() => {
                t(c), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(e, t, n) {
    const { editor: o } = this.props;
    this.findTriggerPosition(e[0].length, (r) => {
      const a = o.selection.recreate();
      if (!a)
        return;
      const { focusOffset: l } = a, h = new RegExp(t.trigger).exec(e[0])?.[1]?.length ?? 0, u = e[0].length - h;
      this.setState({
        suggestions: n,
        suggestionTrigger: t,
        suggestionPosition: r,
        suggestionIndex: 0,
        suggestionMatchedString: e[1],
        suggestionExtendBy: l - u,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: e } = this.state, { current: t } = this.dropdownRef;
    if (t) {
      if (t.infiniteListRef.current)
        t.infiniteListRef.current.scrollToItem(e);
      else if (t.listRef.current) {
        const n = t.listRef.current, r = t.listRef.current.children[e].getBoundingClientRect(), a = n.getBoundingClientRect();
        a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: e } = this.state, { current: t } = this.tabsRef;
    if (!(e < 0 || !t) && t.containerRef.current) {
      const n = t.containerRef.current, r = t.containerRef.current.children[0].children[e].getBoundingClientRect(), a = n.getBoundingClientRect();
      a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: e,
      suggestionIndex: t,
      suggestionExtendBy: n,
      suggestionTrigger: o
    } = this.state;
    if (!(!e || !e[t] || !o))
      return o.insertContent(
        e[t],
        o.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: e } = this.state;
    e && this.lookForTriggers();
  }
  handleSuggestionClick(e) {
    this.setState(
      (t) => ({
        suggestionIndex: t.suggestions ? t.suggestions.indexOf(e) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: e } = this.state, { editor: t } = this.props;
    if (t.ref.current && e) {
      const n = t.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - e.bottom + e.height,
        left: e.x - n.x + e.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: e } = this.state, { editor: t } = this.props;
    if (t.ref.current && e) {
      const n = t.ref.current.getBoundingClientRect();
      return {
        left: `${e.x - n.x}px`,
        top: `${e.y - n.y + e.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: e.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: e } = this.state;
    if (!e || !e.getPagination)
      return !1;
    const t = e.getPagination();
    return !t || !t.onNext ? !1 : {
      ...t,
      onNext: () => t.onNext?.().then((n) => {
        this.setState({ suggestions: n });
      }) ?? Promise.resolve(void 0)
    };
  }
  handleTabChange(e) {
    this.lookForTriggers(e, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ s.jsx(cn, { label: "No suggestions found" });
  }
  renderTabs() {
    const { suggestions: e, suggestionTrigger: t, selectedTab: n, tabIndex: o } = this.state, r = t?.getTabs?.() ?? [], a = !!e?.length;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        Zs,
        {
          ref: this.tabsRef,
          className: zt.dropdownTabs,
          tabs: r,
          tabsPlacement: "left",
          selectedId: n,
          activeId: r?.[o]?.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: zt.dropdownTabsContent, children: a ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: e, suggestionIndex: t, suggestionTrigger: n, selectionMode: o } = this.state, r = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ s.jsx(
      Vs,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: e || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: r,
        activeItem: o === "suggestion" ? e?.[t] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: e, selectedTab: t, suggestions: n } = this.state;
    return !(!e || !this.hasTabs() && !n?.length || this.hasTabs() && !t);
  }
  render() {
    const { editor: e, onError: t, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const o = f(zt.dropdown, {
      [zt.dropdownWithTabs]: this.hasTabs(),
      [zt.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ s.jsx("div", { ...n, children: /* @__PURE__ */ s.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ s.jsx(Je, { className: o, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function Uf({ children: i, className: e }) {
  const t = Y(null), [n, o] = V(0), r = () => t.current ? Array.from(
    t.current.querySelectorAll("button:not([disabled])")
  ).filter((l) => l.closest('[role="toolbar"]') === t.current) : [];
  X(() => {
    const l = r();
    l.length !== 0 && l.forEach((c, d) => {
      d === 0 ? c.setAttribute("tabindex", "0") : c.setAttribute("tabindex", n === d ? "0" : "-1");
    });
  }, [n]);
  const a = (l) => {
    const c = r();
    if (c.length === 0) return;
    const d = document.activeElement;
    if (!t.current?.contains(d)) return;
    let h = n;
    switch (l.key) {
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), l.stopPropagation(), h = h <= 0 ? c.length - 1 : h - 1, o(h), c[h]?.focus();
        break;
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), l.stopPropagation(), h = h >= c.length - 1 ? 0 : h + 1, o(h), c[h]?.focus();
        break;
      case "Home":
        l.preventDefault(), l.stopPropagation(), o(0), c[0]?.focus();
        break;
      case "End":
        l.preventDefault(), l.stopPropagation();
        const u = c.length - 1;
        o(u), c[u]?.focus();
        break;
    }
  };
  return X(() => {
    const l = t.current;
    if (!l) return;
    const c = (h) => {
      const u = r(), p = h.target, m = u.indexOf(p);
      m !== -1 && o(m);
    }, d = (h) => {
      l.contains(h.relatedTarget) || o(0);
    };
    return l.addEventListener("focusin", c), l.addEventListener("focusout", d), () => {
      l.removeEventListener("focusin", c), l.removeEventListener("focusout", d);
    };
  }, []), /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: t,
      className: e,
      role: "toolbar",
      "aria-label": "Text formatting",
      onKeyDown: a,
      children: i
    }
  );
}
function Wo(i) {
  return i instanceof RegExp ? i.source : i;
}
function qf(i) {
  return i.replace(/\(/g, "(?:");
}
class Vr {
  storedTriggers;
  constructor() {
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (e) => `(?!${Wo(e.trigger)})`
    ).join("");
  }
  add(e) {
    this.storedTriggers.push(e);
  }
  update(e) {
    const t = this.storedTriggers.findIndex(
      (n) => this.isAddonTrigger(n) && n.id === e.id
    );
    t !== -1 && (this.storedTriggers[t] = e);
  }
  test(e) {
    let t;
    for (let n = 0; n < this.storedTriggers.length; n += 1) {
      const o = this.storedTriggers[n], { trigger: r, allowSpaces: a, minChars: l } = o, c = qf(
        Wo(r)
      ), d = this.excludeTriggersRegex, h = a ? "." : "\\S";
      if (t = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(e), t && (!l || t[1].length >= l))
        return {
          match: t,
          matchedTrigger: o
        };
    }
    return null;
  }
  isSuggestionTrigger(e) {
    return "getSuggestions" in e;
  }
  isAddonTrigger(e) {
    return !this.isSuggestionTrigger(e);
  }
}
function Kr(i, e) {
  const t = i.getSelection();
  if (!t || t.rangeCount === 0) return !1;
  let n = t.anchorNode;
  const o = "CODE";
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE && n.tagName === o)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function Gf(i, e) {
  e?.();
  const t = i.getSelection();
  if (!t || t.rangeCount === 0) return;
  const n = t.getRangeAt(0);
  if (Kr(i)) {
    Yf(i, "CODE");
    return;
  }
  const o = n.collapsed, r = i.document.createElement("code");
  if (o) {
    const a = i.document.createTextNode("​");
    r.appendChild(a), n.insertNode(r), n.setStart(r.firstChild, 1), n.setEnd(r.firstChild, 1);
  } else {
    const a = n.extractContents();
    r.appendChild(a), n.insertNode(r), n.setStartAfter(r), n.setEndAfter(r);
  }
  t.removeAllRanges(), t.addRange(n);
}
function Yf(i, e) {
  const t = i.getSelection();
  if (!t || t.rangeCount === 0) return;
  let n = t.anchorNode;
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      const o = n;
      if (o.tagName === e) {
        const r = o.parentNode;
        if (r) {
          const a = i.document.createDocumentFragment();
          for (; o.firstChild; )
            a.appendChild(o.firstChild);
          r.replaceChild(a, o);
          const l = i.document.createRange();
          l.selectNodeContents(r), l.collapse(!1), t.removeAllRanges(), t.addRange(l);
        }
        return;
      }
    }
    n = n.parentNode;
  }
}
const wn = 25;
let Se = null, at = null;
function Qf(i, e) {
  const t = e.document.createElement("div");
  return t.className = `image-resize-handle image-resize-handle-${i}`, t.dataset.handle = i, t;
}
function Xf(i, e) {
  const t = e.document.createElement("div");
  return t.className = "image-resize-wrapper", t.contentEditable = "false", i.parentNode?.insertBefore(t, i), t.appendChild(i), ["nw", "ne", "se", "sw"].forEach((o) => {
    const r = Qf(o, e);
    t.appendChild(r);
  }), t;
}
function Ur(i) {
  const e = i.querySelector("img");
  e && i.parentNode && (i.parentNode.insertBefore(e, i), i.remove());
}
function Zf(i, e, t) {
  const { startX: n, startWidth: o, handle: r, aspectRatio: a } = i, l = e - n;
  let c = o;
  switch (r) {
    case "se":
    case "ne":
      c = o + l;
      break;
    case "sw":
    case "nw":
      c = o - l;
      break;
  }
  let d = c / a;
  c < wn && (c = wn, d = wn / a);
  const h = wn / a;
  return d < h && (d = h, c = h * a), { width: c, height: d };
}
function Js(i) {
  if (!Se) return;
  i.preventDefault(), i.stopPropagation();
  const { width: e } = Zf(
    Se,
    i.clientX,
    i.clientY
  );
  Se.img.style.width = `${e}px`, Se.img.style.height = "auto";
}
function eo(i) {
  if (!Se) return;
  i.preventDefault(), i.stopPropagation();
  const { img: e } = Se, t = e.ownerDocument.defaultView;
  t.document.removeEventListener("mousemove", Js), t.document.removeEventListener("mouseup", eo), Se = null;
  const n = new Event("input", { bubbles: !0 });
  e.closest('[contenteditable="true"]')?.dispatchEvent(n);
}
function Jf(i, e, t) {
  i.preventDefault(), i.stopPropagation();
  const n = e.ownerDocument.defaultView, o = e.closest(".image-resize-wrapper");
  if (!o) return;
  const r = e.naturalWidth, a = e.naturalHeight, l = r / a, c = e.getBoundingClientRect(), d = c.width, h = c.height;
  Se = {
    img: e,
    originalWidth: r,
    originalHeight: a,
    aspectRatio: l,
    startX: i.clientX,
    startY: i.clientY,
    startWidth: d,
    startHeight: h,
    handle: t,
    wrapper: o
  }, n.document.addEventListener("mousemove", Js), n.document.addEventListener("mouseup", eo);
}
function eb(i, e) {
  at && (Ur(at), at = null);
  const t = Xf(i, e);
  at = t, t.querySelectorAll(".image-resize-handle").forEach((o) => {
    const r = o.dataset.handle;
    o.addEventListener(
      "mousedown",
      (a) => Jf(a, i, r)
    );
  });
}
function fs() {
  if (at && (Ur(at), at = null), Se) {
    const i = Se.img.ownerDocument.defaultView;
    i.document.removeEventListener("mousemove", Js), i.document.removeEventListener("mouseup", eo), Se = null;
  }
}
function tb(i) {
  return i ? i.classList.contains("image-resize-wrapper") || i.classList.contains("image-resize-handle") || i.closest(".image-resize-wrapper") !== null : !1;
}
function Mo(i) {
  if (!i) return i;
  const n = new DOMParser().parseFromString(`<div>${i}</div>`, "text/html").body.firstChild;
  return n ? (n.querySelectorAll(".image-resize-wrapper").forEach((r) => {
    const a = r.querySelector("img");
    a && r.parentNode && (r.parentNode.insertBefore(a, r), r.remove());
  }), n.innerHTML) : i;
}
const qr = "input-rich-text-editor", Gr = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: [[["$metaOrCtrl"], "KeyM"]]
  }
], zo = [
  ...Gr,
  ...zr,
  ...Wr,
  ...bg
], nb = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, sb = ke({
  command: {
    run: L,
    active: () => !1
  },
  content: {
    insert: L,
    setUiBlocker: L
  },
  hotkeys: {
    add: L,
    updateKeybindings: L
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: L
  },
  events: {
    subscribe: () => L,
    publish: L,
    onMouseOver: L,
    onBlur: L
  },
  allowFormatting: [],
  triggers: new Vr(),
  ref: O(),
  window,
  history: {
    canUndo: () => !1,
    undo: L,
    takeSnapshot: L,
    reset: L
  }
});
class to extends k {
  editor;
  editorRef;
  currentSuggestionRef;
  fileInputRef;
  attachmentDropdownButtonRef;
  unsubscribeInlineAttachment;
  isInserting;
  contentInsertionQueue;
  /**
   * Button that can be used in `toolbarAddons` to have same styles as the
   * buitlin buttons.
   */
  static ToolbarButton = Pe;
  /** Context containing props and methods to interact with the editor. */
  static Context = sb;
  static contextType = Mn;
  get effectiveWindow() {
    return this.context ?? window;
  }
  static defaultProps = {
    allowAttachments: !1,
    allowInlineAttachments: !1,
    allowEmoji: !0,
    languages: [],
    onTriggerSend() {
      console.warn("InputRichText: onTriggerSend callback missing in props");
    },
    onToggleSendOnEnter: L,
    sendOnEnter: !1,
    onMount: L,
    onUnmount: L,
    disabled: !1,
    hasAutocompleteSuggestionsFeature: !1
  };
  constructor(e) {
    super(e), this.editorRef = O(), this.currentSuggestionRef = O(), this.fileInputRef = O(), this.attachmentDropdownButtonRef = O(), this.unsubscribeInlineAttachment = L, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: zo,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: e.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new Vr(),
      ref: this.editorRef,
      window: this.effectiveWindow,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const e = this.effectiveWindow, { onMount: t } = this.props;
    e.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), t(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(e) {
    this.editor.window !== this.effectiveWindow && (this.editor.window = this.effectiveWindow);
    const { fileUploadStatuses: t, autocomplete: n, keybindings: o, uiBlocker: r } = this.props, { current: a } = this.editorRef;
    t && t !== e.fileUploadStatuses && a && (Object.keys(t).forEach((l) => {
      this.updateFileLoader(l, t[l]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== e.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), mr(e.keybindings, o) || this.updateKeyCommandsKeybindings(o), e.uiBlocker !== r && this.setUiBlocker(r);
  }
  componentWillUnmount() {
    const { onUnmount: e } = this.props;
    this.unsubscribeInlineAttachment?.(), fs(), e(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: e } = this.props;
    return zo.map((t) => ({
      ...t,
      keybindings: e && t.name ? e[t.name] ?? [] : t.keybindings
    }));
  }
  subscribe(e, t) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [e]: [...n.pubsub[e] ?? [], t]
      }
    })), () => {
      this.setState((n) => fr(n, e));
    };
  }
  publish(e) {
    this.state.pubsub[e]?.forEach((t) => t(this.editor));
  }
  /**
   * The core update function, that triggers every time the selection is
   * changed, which will also trigger when the contents change.
   *
   * This method handles calling onChange prop.
   *
   * @returns {void | undefined} Description
   * @todo Test if onInput would be a better way of triggering onChange
   */
  handleSelectionChange = () => {
    const { onChange: e, onSelectionChange: t } = this.props, { htmlOld: n, selectionUpdateListeners: o } = this.state, { current: r } = this.editorRef;
    if (r) {
      this.forceUpdate();
      const a = this.extractEditorContent();
      a !== n && (this.setState({
        htmlOld: a
      }), e(a));
    }
    o.forEach((a) => {
      a();
    }), t && t();
  };
  /** Handle any mouse over events on the editor */
  handleMouseOver = (e) => {
    const { mouseOverListeners: t } = this.state;
    t.forEach((n) => {
      n(e);
    });
  };
  /** Handle click events on the editor to select images */
  handleEditorClick = (e) => {
    const t = e.target, n = this.effectiveWindow;
    if (lt(t) && t.tagName === "IMG") {
      e.preventDefault();
      const o = n.getSelection();
      if (o) {
        const r = n.document.createRange();
        r.selectNode(t), o.removeAllRanges(), o.addRange(r), this.handleSelectionChange();
      }
      eb(t, n);
    } else tb(t) || fs();
  };
  /** Handle blur events on the editor */
  handleBlurListeners = (e) => {
    const { blurListeners: t } = this.state;
    t.forEach(
      (n) => {
        n(e);
      }
    );
  };
  handleKeyDown = (e) => {
    if (e.getModifierState(e.key))
      return;
    const { keyCommands: t } = this.state, { sendOnEnter: n, onKeyDown: o } = this.props;
    if (o?.(e), t.some(
      ({ preventDefaultKeybinding: a }) => a && ds(a, e)
    ) && e.preventDefault(), t.some(
      ({ name: a, keybindings: l, condition: c, callback: d }) => {
        if (ds(l, e) && (c === void 0 || c(this.editor)))
          return d?.(this.editor, e), a && this.editor.events.publish(a), !0;
      }
    )) {
      this.setKeyDownHandled(e), e.stopPropagation();
      return;
    }
    if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey && this.editor.allowFormatting.includes("blockquote")) {
      const a = this.effectiveWindow, l = a.getSelection();
      if (!l) return;
      const c = l.anchorNode, h = (lt(c) ? c : c?.parentElement)?.closest("blockquote");
      if (h && this.editorRef.current?.contains(h)) {
        const u = a.document, p = u.createElement("div");
        p.appendChild(u.createElement("br")), h.after(p);
        const m = u.createRange();
        m.setStart(p, 0), m.collapse(!0), l.removeAllRanges(), l.addRange(m), this.setKeyDownHandled(e), this.handleSelectionChange();
        return;
      }
    }
    if (ds([[["$metaOrCtrl"], "Enter"]], e)) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(e), a();
    } else if (e.key === "Enter" && n && !e.shiftKey) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(e), a();
    }
    return null;
  };
  getBlockLevelParent = (e) => {
    const t = this.effectiveWindow;
    let n = lt(e) ? e : e.parentElement;
    for (; !Ys(n, t); )
      n = n.parentElement;
    return n;
  };
  // Insert actual text direction into the html
  onInput = (e) => {
    const { current: t } = this.editorRef, n = e?.nativeEvent;
    if (!n)
      return;
    this.resetUndoStack();
    const { inputType: o } = n;
    if (o === "insertFromPaste" || !o) {
      Eo(t), Gm(t);
      return;
    }
    const a = document.getSelection()?.anchorNode;
    if (o === "insertText" && a && a.textContent?.length === 1) {
      const l = this.getBlockLevelParent(a);
      if (
        // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (l.tagName === "UL" || l.tagName === "OL") && l.hasAttribute("dir")
      )
        return;
      l.setAttribute("dir", "auto");
      const c = window.getComputedStyle(l).direction;
      l.setAttribute("dir", c), l.style.textAlign = "";
    }
  };
  handleKeyUp = () => {
    const { keyDownHandled: e } = this.state;
    e || this.handleSelectionChange(), this.setState({
      keyDownHandled: !1
    });
  };
  setKeyDownHandled = (e) => {
    e.preventDefault(), this.setState({
      keyDownHandled: !0
    });
  };
  addKeyCommands = (e) => {
    this.setState(({ keyCommands: t }) => ({
      keyCommands: [...t, ...e]
    }));
  };
  updateKeyCommandsKeybindings = (e) => {
    if (!e)
      return;
    const { keyCommands: t } = this.state;
    Object.entries(e).forEach(([n, o]) => {
      const r = t.findIndex(
        ({ name: a }) => a === n
      );
      r > -1 && o && (t[r].keybindings = o);
    });
  };
  addSelectionUpdateListener(e) {
    this.setState(({ selectionUpdateListeners: t }) => ({
      selectionUpdateListeners: [...t, e]
    }));
  }
  addMouseOverListener(e) {
    this.setState(({ mouseOverListeners: t }) => ({
      mouseOverListeners: [...t, e]
    }));
  }
  addBlurListener(e) {
    this.setState(({ blurListeners: t }) => ({
      blurListeners: [...t, e]
    }));
  }
  handlePaste = (e) => {
    const { onFileDropped: t, allowInlineAttachments: n, sanitize: o } = this.props, r = this.effectiveWindow, { clipboardData: a } = e;
    if (!a)
      return;
    let l = a.getData("text/html");
    const c = a.getData("text/plain"), d = a.files.item(0);
    if (l) {
      e.preventDefault(), this.commandRun("insertHTML", o?.(l));
      return;
    }
    if (c && nb.test(c)) {
      e.preventDefault();
      const h = r.getSelection(), u = h && !h.isCollapsed ? h.toString() : "", p = u && this.editor.allowFormatting.includes("link") ? u : c;
      l = Hr(c, p), this.commandRun("insertHTML", l);
      return;
    }
    if (d) {
      if (n && t) {
        const { src: h, uid: u } = Ro(r, d);
        this.insertImageLoader(h, u), t(d, u);
      }
      e.preventDefault();
    }
  };
  commandRun(e, t = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: o } = this.editorRef, r = this.effectiveWindow;
      if (o) {
        if (n || this.recreateSelection(), e === "inlineCode") {
          Gf(r, this.addCurrentContentToUndoStack), this.handleSelectionChange();
          return;
        }
        r.document.execCommand(
          e,
          !1,
          // execCommand 3rd expects string | null, TS thinks it needs string | undefined
          t
        );
      }
    });
  }
  commandActive(e) {
    const { hasFocus: t } = this.state, n = this.effectiveWindow;
    return e === "inlineCode" ? !!(t && Kr(n)) : !!(t && Km(n, e));
  }
  getText = () => {
    const { current: e } = this.editorRef;
    return e && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
  };
  getSanitizedHtml = () => this.props.sanitize?.(this.getText());
  getPlainText = () => {
    const { current: e } = this.editorRef, t = (
      // innerHTML of <div></div> should count as empty
      e && this.hasContent(this.extractEditorContent()) ? e.innerText : ""
    );
    return t ? t.replace(/\n\n/g, `
`).trim() : "";
  };
  setHtml(e) {
    const { current: t } = this.editorRef, n = this.props.sanitize?.(e);
    t && (t.innerHTML = n || "", Eo(t)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  handleInlineUpload = (e) => {
    if (e === null) return;
    const { onFileDropped: t } = this.props, n = this.effectiveWindow;
    e && t && Array.from(e).forEach((r) => {
      if (qm(r)) {
        const { src: a, uid: l } = Ro(n, r);
        this.insertImageLoader(a, l), t(r, l);
      } else {
        const a = en();
        this.insertFileLoader(r.name, a), t(r, a);
      }
    });
  };
  handleAttachmentUpload = (e) => {
    const { onAttachmentsFile: t } = this.props, { current: n } = this.attachmentDropdownButtonRef;
    n && n.open(), e && typeof t == "function" && Array.from(e).forEach((r) => {
      const a = en();
      t(r, a);
    });
  };
  handleDetachAttachmentFile = (e) => {
    const { onDetachAttacmentFile: t } = this.props;
    typeof t == "function" && t(e);
  };
  handleFileSelect = (e) => {
    const t = e.target;
    t?.ownerDocument?.defaultView && t instanceof t.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(t.files), t.value = "");
  };
  openFileBrowser = (e) => {
    e?.preventDefault();
    const { current: t } = this.fileInputRef;
    t && t.click();
  };
  insertImageLoader(e, t) {
    const o = this.effectiveWindow.document.createElement("img");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", t), o.setAttribute("src", e), this.insertContent(o);
  }
  insertFileLoader(e, t) {
    const o = this.effectiveWindow.document.createElement("a");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", t), o.setAttribute("href", "#"), o.innerText = e, this.insertContent(o);
  }
  updateFileLoader(e, { link: t, status: n, filename: o }) {
    const { current: r } = this.editorRef;
    if (r) {
      const a = r.querySelector(`[data-uid="${e}"]`);
      a && (n === "failed" && a.parentElement ? a.parentElement.removeChild(a) : (a.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), a.classList.add(`async-${n}`), t && a.tagName === "IMG" && (a.src = t, o && (a.title = o)), t && a.tagName === "A" && (a.href = t)));
    }
  }
  handleToggleSendOnEnter = (e) => {
    e.preventDefault();
    const { onToggleSendOnEnter: t } = this.props;
    t();
  };
  handleToggleAutocompleteSuggestions = (e) => {
    e.preventDefault();
    const { autocomplete: t } = this.props;
    t && t.onToggleShowAutocompleteSuggestions();
  };
  isSelectionWithinEditor(e) {
    const { anchorNode: t } = e;
    let { parentElement: n = null } = t || {};
    const o = `.${ge.editor}`;
    let r = t !== null && t.nodeType === Node.ELEMENT_NODE ? t.matches(o) : !1;
    for (; !r && n !== null; ) {
      if (n.matches(o)) {
        r = !0;
        break;
      }
      n = n.parentElement;
    }
    return r;
  }
  insertContent = (e, t) => {
    this.contentInsertionQueue.push(e), t?.getSelection ? this.processContentInsertionQueue(t.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
      this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
    }));
  };
  processContentInsertionQueue = (e) => {
    if (!e || !this.isSelectionWithinEditor(e)) {
      this.contentInsertionQueue = [];
      return;
    }
    if (Ym(e), e?.rangeCount && e?.rangeCount > 0) {
      const t = e.getRangeAt(0);
      if (e.isCollapsed || t.deleteContents(), this.contentInsertionQueue.length === 1)
        t.insertNode(this.contentInsertionQueue[0]);
      else if (this.contentInsertionQueue.length > 1) {
        const n = document.createElement("span");
        this.contentInsertionQueue.forEach((o) => {
          n.appendChild(o);
        }), t.insertNode(n);
      }
    }
    this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
      e.collapseToEnd();
    }), this.handleSelectionChange();
  };
  setUiBlocker(e) {
    this.setState({ uiBlocker: e });
  }
  getSelectionRange() {
    const e = this.effectiveWindow;
    if (e.document.activeElement === this.editorRef.current) {
      const t = e.document.getSelection();
      return t?.rangeCount && t?.rangeCount > 0 ? t.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection(e) {
    const { current: t } = this.editorRef, { lastSelection: n } = this.state, r = this.effectiveWindow.getSelection();
    return t && (!r || !this.isSelectionWithinEditor(r)) && e?.focus !== !1 && (t.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
  }
  handleFocus = () => {
    const e = this.effectiveWindow;
    this.setState({
      hasFocus: !0
    }), e.document.addEventListener(
      "selectionchange",
      this.handleSelectionChange
    );
  };
  handleBlur = (e) => {
    const t = this.effectiveWindow, n = t.getSelection(), o = () => n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null;
    fs(), this.setState({
      lastSelection: o(),
      hasFocus: !1
    }), t.document.removeEventListener(
      "selectionchange",
      this.handleSelectionChange
    ), this.handleBlurListeners(e);
  };
  focus = () => {
    const { current: e } = this.editorRef, { hasFocus: t } = this.state;
    e && (t || e.focus());
  };
  moveCursorToEnd = () => {
    const { current: e } = this.editorRef, t = this.effectiveWindow;
    if (!e) return;
    const n = t.getSelection();
    if (n) {
      const o = t.document.createRange();
      o.selectNodeContents(e), o.collapse(!1), n.removeAllRanges(), n.addRange(o);
    }
  };
  hasContent(e) {
    return e?.length ? !e.match(/^\s*<br>\s*$|^<div[^>]*>\s*(<br>\s*)?<\/div>$/) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList") || this.commandActive("inlineCode");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: e } = this.props;
    return Array.isArray(e) ? e : e ? zm : [];
  }
  lastExtractedContent = O();
  extractEditorContent() {
    const { editorContentExtractor: e, sanitize: t } = this.props, { current: n } = this.editorRef, o = n?.innerHTML ?? "";
    if (!e)
      return Mo(o);
    if (o === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const r = e(n);
    return this.lastExtractedContent.current = Mo(
      t?.(r) ?? r
    ), this.lastExtractedContent.current;
  }
  canUndo = () => this.state.undoStack.length > 0;
  undo = () => {
    const { undoStack: e } = this.state;
    if (e.length > 0) {
      const t = e[e.length - 1];
      this.setHtml(t), this.setState({
        undoStack: e.slice(0, -1)
      });
    }
  };
  resetUndoStack = () => {
    this.setState({
      undoStack: []
    });
  };
  addCurrentContentToUndoStack = () => {
    this.setState({
      // To prevent undo stack from growing indefinitely, we only keep a finite amount
      undoStack: [...this.state.undoStack.slice(-50), this.getText()]
    });
  };
  render() {
    const {
      className: e,
      wrapperClassName: t,
      renderQuickResponse: n,
      quickResponsesApi: o,
      sendOnEnter: r,
      placeholder: a,
      allowInlineAttachments: l,
      allowAttachments: c,
      attachmentsDisabled: d,
      attachmentsDisabledTooltip: h,
      textInputDisabled: u,
      allowEmoji: p,
      attachmentsFields: m,
      attachments: g,
      isAttachmentsUploading: b,
      hideSendOnEnterToggle: y,
      languages: _,
      disabled: v,
      status: S,
      onError: C,
      icon: x,
      prefix: w,
      suffix: I,
      id: T,
      autocomplete: N,
      toolbarAddons: H
    } = this.props, { htmlOld: D, uiBlocker: R } = this.state, A = this.effectiveWindow, K = f(ge.root, e);
    return /* @__PURE__ */ s.jsx(to.Context.Provider, { value: this.editor, children: /* @__PURE__ */ s.jsx(
      Be,
      {
        status: S,
        icon: x,
        prefix: w,
        suffix: I,
        disabled: v,
        className: f(ge.inputWrapper, t),
        children: /* @__PURE__ */ s.jsxs("div", { className: K, children: [
          /* @__PURE__ */ s.jsxs(
            Sg,
            {
              className: ge.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(g) ? g : [],
              allowInlineAttachments: l,
              allowAttachments: c,
              children: [
                /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    id: T,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    onClick: this.handleEditorClick,
                    className: f(ge.editor, {
                      [ge.editorDisabled]: u
                    }),
                    "data-testid": qr,
                    contentEditable: !u
                  }
                ),
                !this.hasContent(D) && !!a && /* @__PURE__ */ s.jsx("span", { role: "presentation", className: ge.placeholder, children: a })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(Uf, { className: ge.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                Of,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: A
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ s.jsx(Zg, { editor: this.editor })
            ] }),
            l && /* @__PURE__ */ s.jsx(
              Pe,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser,
                tooltip: `Insert inline image (${Xs(Gr[0].keybindings)})`
              }
            ),
            c && /* @__PURE__ */ s.jsx(
              yg,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(g) ? g : [],
                isAttachmentsUploading: b,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: A,
                editor: this.editor,
                disabled: d,
                disabledTooltip: h,
                fixed: !0,
                children: m
              }
            ),
            p && /* @__PURE__ */ s.jsx(Pg, { "data-tip": "Emojis", editor: this.editor, fixed: !0 }),
            !!o && !!n && /* @__PURE__ */ s.jsx(
              Tf,
              {
                languages: _,
                renderQuickResponse: n,
                quickResponsesApi: o,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            N && N.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ s.jsx(
              Pe,
              {
                isActive: N.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete",
                tooltip: "Autocomplete suggestions"
              }
            ),
            H,
            !y && /* @__PURE__ */ s.jsx(
              Pe,
              {
                isActive: r,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter",
                tooltip: "Send on Enter"
              }
            ),
            N ? /* @__PURE__ */ s.jsxs(
              "span",
              {
                className: f(ge.toolbarHint, {
                  [ge.toolbarHintVisible]: this.state.showHint,
                  [ge.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  N.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null
          ] }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: ge.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ s.jsx(Kf, { editor: this.editor, onError: C }),
          /* @__PURE__ */ s.jsx(ig, { editor: this.editor }),
          R && /* @__PURE__ */ s.jsx("div", { className: ge.uiBlocker, children: R })
        ] })
      }
    ) });
  }
}
const ob = "h-textarea--textarea__inputWrapper", rb = "h-textarea--textarea__input", Vo = {
  inputWrapper: ob,
  input: rb
}, ib = "textarea", Yr = W(function(e, t) {
  const n = Y(null), {
    className: o,
    disabled: r,
    readOnly: a,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p = 0,
    style: m,
    autoGrow: g,
    ...b
  } = e, [y, _] = V(p), v = {
    ...m,
    height: y ? `${y}px` : void 0
  }, S = F(() => {
    if (!n.current)
      return;
    const C = n.current.clientHeight, x = window.getComputedStyle(n.current), w = parseInt(x.lineHeight || "16");
    n.current.style.height = "auto";
    const I = n.current.scrollHeight + w, T = Math.max(
      p,
      Math.min(C, I)
    ), N = I > T ? I : T;
    n.current.style.height = `${N}px`, _(N);
  }, [p]);
  return X(() => {
    if (g)
      return S(), window.addEventListener("resize", S), () => {
        window.removeEventListener("resize", S);
      };
  }, [g, S]), /* @__PURE__ */ s.jsx(
    Be,
    {
      className: Vo.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ s.jsx(
        "textarea",
        {
          "data-testid": ib,
          className: Vo.input,
          dir: "auto",
          id: l,
          ...b,
          onChange: (C) => {
            b?.onChange?.(C), g && S();
          },
          ref: n,
          style: v,
          name: l,
          disabled: r,
          readOnly: a
        }
      )
    }
  );
}), ab = "h-fieldRichText--fieldRichText__editorContainer", lb = "h-fieldRichText--fieldRichText__fallbackTextArea", Ko = {
  editorContainer: ab,
  fallbackTextArea: lb
};
class eD extends k {
  static defaultProps = {
    allowFormatting: !0
  };
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        helpIcon: l,
        disabled: a,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          jt,
          {
            fallback: /* @__PURE__ */ s.jsx(
              Yr,
              {
                ...t,
                className: Ko.fallbackTextArea,
                disabled: a,
                value: t.value,
                onChange: (p) => t.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ s.jsx("div", { className: Ko.editorContainer, children: /* @__PURE__ */ s.jsx(
              to,
              {
                disabled: a,
                status: z.getStatus(o),
                ...t,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: L
              }
            ) })
          }
        )
      }
    );
  }
}
class tD extends k {
  constructor(e) {
    super(e), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: e },
      items: t
    } = this.props;
    return typeof e == "string" && t?.some((n) => n.id === e) ? [e] : Array.isArray(e) && e.length && t?.some((n) => e.some((o) => o === n.id)) ? e : [];
  }
  handleSelect(e) {
    const {
      input: { onChange: t }
    } = this.props;
    typeof t == "function" && t(e === null ? "" : e.id.toString());
  }
  handleClear() {
    const {
      input: { value: e },
      onClear: t
    } = this.props;
    typeof e == "string" && this.handleSelect(null), typeof t == "function" && t();
  }
  render() {
    const {
      className: e,
      input: t,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: o,
        labelFor: t.name,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Dt,
          {
            ...u,
            id: t.name,
            disabled: a,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: z.getStatus(n)
          }
        )
      }
    );
  }
}
function dn(i, e) {
  const t = Os(), n = Y(e);
  n.current = e, X(() => {
    function o(r) {
      n.current?.(r);
    }
    return t.addEventListener(i, o), () => t.removeEventListener(i, o);
  }, [t, i]);
}
function Qr(i, e = "") {
  return Re.toArray(i).reduce((t, n) => Ie(n) ? n.type === Xe ? [
    ...t,
    ...Qr(n.props.children, n.key)
  ] : [...t, { ...n, key: `${e}${n.key}` }] : t, []);
}
const Yn = (i) => q(() => Qr(i), [i]), cb = "h-selectionList--selectionList__root", db = "h-selectionList--selectionList__disabled", Uo = {
  root: cb,
  disabled: db
}, Pt = Ri(
  () => ke({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: L,
      register: L,
      isSelected: () => !1,
      onSelect: L,
      isOnlyVisibleItem: !1
    }
  })
), no = ({ defaultActiveItemIndex: i = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [e, t] = V(!1), [n, o] = V(-1), [r, a] = V([]), [l, c] = V({}), d = F(
    ({
      isActivatable: g,
      isLastChild: b,
      isOnlyVisibleItem: y,
      keysTakenOverHandlingFromParent: _
    }, v) => {
      g !== void 0 && a((S) => {
        const C = g ? [...S, v].sort((x, w) => x - w) : S.filter((x) => x !== v);
        return b && o((x) => (C.includes(v) && !S.includes(v) || v !== x) && C.includes(x) && v !== C[i] ? x : C[i] ?? C[0] ?? x), C;
      }), y !== void 0 && t(y), _ !== void 0 && c((S) => ({
        ...S,
        [v]: _
      }));
    },
    [i]
  ), h = F(
    (g) => "index" in g ? g.index : g.step === "first" ? r[0] : g.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (b) => b === n
    ) + g.step + r.length) % r.length],
    [r, n]
  ), u = F(
    (g) => {
      o(h(g));
    },
    [h]
  );
  X(() => {
    (n < 0 || n === void 0) && o(r[i]);
  }, [n, r, i]);
  const p = q(
    () => l[n] ?? [],
    [n, l]
  );
  return q(
    () => ({
      activeItemIndex: n,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: e,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      n,
      h,
      d,
      e,
      p,
      u
    ]
  );
}, qo = ({
  className: i,
  selectedValues: e = [],
  isActive: t,
  isDisabled: n,
  isMultiple: o = !1,
  onChange: r = L,
  equalityFn: a = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, m] = V(!1), [g, b] = V({ isActive: !!t, source: "parent" }), y = Pt(), {
    activeItemIndex: _,
    setActiveItem: v,
    handleItemRegister: S,
    isOnlyActiveItemVisible: C,
    keysDelegatedHandlingToItem: x
  } = no({ defaultActiveItemIndex: c }), w = Yn(d), I = F(
    (D) => D !== void 0 && (e || []).some(
      (R) => a(R, D)
    ),
    [a, e]
  ), T = F(
    ({ value: D, meta: R }, A) => {
      v({ index: A }), D !== void 0 && r(o ? {
        selectedValues: I(D) ? e.filter(
          (K) => !a(K, D)
        ) : [...e, D],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !I(D),
          value: D
        },
        event: R?.event
      } : {
        selectedValues: [D],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !0,
          value: D
        },
        event: R?.event
      });
    },
    [
      a,
      I,
      o,
      r,
      e,
      v
    ]
  ), N = q(
    () => !n && (g.isActive || p),
    [n, g.isActive, p]
  ), H = (D) => {
    !N || x.includes(D.key) || (D.key === "Enter" ? D.preventDefault() : D.key === "Home" ? (v({ step: "first" }), D.preventDefault()) : D.key === "End" ? (v({ step: "last" }), D.preventDefault()) : D.key === "ArrowDown" ? (v({ step: 1 }), D.preventDefault()) : D.key === "ArrowUp" && (v({ step: -1 }), D.preventDefault()));
  };
  return X(() => {
    b({ isActive: !!t, source: "parent" });
  }, [t]), dn("keydown", H), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: n || t ? -1 : l,
      ...h,
      className: f(i, Uo.root, {
        [Uo.disabled]: n
      }),
      onFocus: () => m(!0),
      onBlur: () => m(!1),
      onMouseLeave: () => {
        g.source === "child" && b({ isActive: !1, source: "self" });
      },
      children: w.map(
        (D, R) => Ie(D) && (!C || R === _) && /* @__PURE__ */ s.jsx(
          y.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: o,
                isActive: g.isActive,
                isDisabled: n
              },
              item: {
                isActive: N && R === _,
                setActive: () => {
                  b({ isActive: !0, source: "child" }), v({ index: R });
                },
                register: (A) => S(A, R),
                isSelected: I,
                onSelect: (A) => T(A, R),
                isOnlyVisibleItem: C,
                isLastChild: R === w.length - 1
              }
            },
            children: D
          },
          R
        )
      )
    }
  );
}, Go = ({ className: i, label: e, ...t }, n) => {
  const {
    item: { register: o, isLastChild: r }
  } = Oe(Pt());
  return Tt(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), Ze(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ s.jsx(
    zn,
    {
      ref: n,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...t,
      children: /* @__PURE__ */ s.jsx($.Paragraph, { as: "span", variant: "4", color: "secondary", children: e })
    }
  );
}, Xr = Object.assign(W(Go), {
  name: Go.name
}), hb = "h-selectionList-subComponents-item--selectionListItem__root", ub = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", pb = "h-selectionList-subComponents-item--selectionListItem__rootActive", mb = "h-selectionList-subComponents-item--selectionListItem__selectionState", gb = "h-selectionList-subComponents-item--selectionListItem__fixedSize", fb = "h-selectionList-subComponents-item--selectionListItem__content", bb = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", rt = {
  root: hb,
  rootDisabled: ub,
  rootActive: pb,
  selectionState: mb,
  fixedSize: gb,
  content: fb,
  contentDisabled: bb
}, Yo = ({
  value: i,
  isDisabled: e = !1,
  isIndeterminate: t = !1,
  className: n,
  contentClassName: o,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: a,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: m,
      isActive: g,
      isFocused: b
    },
    item: {
      register: y,
      isSelected: _,
      onSelect: v,
      isActive: S,
      isNode: C = !1,
      isLastChild: x = !1,
      setActive: w
    }
  } = Oe(Pt()), I = _(i), T = q(
    () => !m && (g || b),
    [g, m, b]
  ), N = q(
    () => !e && S && T,
    [S, e, T]
  ), H = Y(null);
  on(
    u,
    () => H.current
  );
  const D = F(
    (E) => {
      !e && !m && (c?.({ value: i, meta: { target: E?.target } }), v({
        value: i,
        meta: {
          target: E?.target,
          event: E || void 0
        }
      }));
    },
    [e, m, c, v, i]
  ), R = F(
    (E) => {
      N && E.key === "Enter" && !e && !m && (c?.({
        value: i,
        meta: { target: E.target ?? void 0 }
      }), v({
        value: i,
        meta: { target: E.target ?? void 0, event: E }
      }));
    },
    [N, e, m, c, v, i]
  );
  X(() => {
    S && T && H.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [S]);
  const A = F(
    () => ({
      isActive: S,
      isSelected: I,
      isLastChild: x,
      isNode: C,
      value: i
    }),
    [S, x, C, I, i]
  ), K = Jt(S), oe = Jt(I);
  Qe(() => {
    S !== K && a?.(A()), I !== oe && l?.(A());
  }, [
    A,
    S,
    I,
    a,
    l,
    K,
    oe
  ]), dn("keydown", R), X(() => (y({ isActivatable: !e, isLastChild: x }), () => y({ isActivatable: !1, isLastChild: x })), [e]);
  const ne = !p && I || p && i !== void 0 || !r;
  return /* @__PURE__ */ s.jsxs(
    "li",
    {
      ref: H,
      role: "option",
      "aria-selected": I,
      "aria-disabled": e,
      onClick: D,
      onMouseMove: w,
      className: f(rt.root, n, {
        [rt.rootActive]: N,
        [rt.rootDisabled]: e
      }),
      ...h,
      children: [
        ne && /* @__PURE__ */ s.jsxs(
          B,
          {
            className: f(rt.selectionState, {
              [rt.fixedSize]: !r
            }),
            children: [
              !p && I && /* @__PURE__ */ s.jsx(P, { name: "done" }),
              p && i !== void 0 && /* @__PURE__ */ s.jsx(
                an,
                {
                  checked: I,
                  indeterminate: !I && t,
                  disabled: e,
                  onChange: L,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          ie,
          {
            className: f(rt.content, o, {
              [rt.contentDisabled]: e
            }),
            children: d
          }
        ),
        C && /* @__PURE__ */ s.jsx(P, { name: "angle-right" })
      ]
    }
  );
}, yb = Object.assign(W(Yo), {
  name: Yo.name
}), xb = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", _b = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", Qo = {
  root: xb,
  rootActive: _b
}, Xo = ({
  className: i,
  content: e,
  onActiveStateChange: t,
  onSelected: n,
  ...o
}, r) => {
  const {
    list: {
      isDisabled: a,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = Oe(Pt()), m = q(
    () => !a && (l || c),
    [l, a, c]
  ), g = q(
    () => h && m,
    [h, m]
  ), b = Y(null);
  on(
    r,
    () => b.current
  );
  const y = F(() => {
    u({}), n?.();
  }, [u, n]), _ = F(
    (S) => {
      !g || a || S.key === "Enter" && y();
    },
    [y, g, a]
  );
  X(() => {
    h && m && b.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [h]);
  const v = Jt(h);
  return Qe(() => {
    h !== v && t?.({ isActive: h });
  }, [h, t, v]), dn("keydown", _), Tt(() => {
    d({ isActivatable: !0 });
  }), Ze(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ s.jsx(
    "li",
    {
      ref: b,
      role: "navigation",
      className: f(Qo.root, i, {
        [Qo.rootActive]: g
      }),
      onClick: y,
      onMouseMove: p,
      ...o,
      children: e || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(P, { name: "angle-left" }),
        /* @__PURE__ */ s.jsx($.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, Zr = Object.assign(
  W(Xo),
  {
    name: Xo.name
  }
), Cb = "h-selectionList-subComponents-list--selectionListList__list", vb = {
  list: Cb
}, Zo = ({
  parentItem: i,
  children: e,
  backItemProps: t = {},
  listProps: { className: n, ...o } = {},
  onActiveStateChange: r,
  ...a
}, l) => {
  const c = Pt(), d = Oe(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: m,
      onSelect: g,
      isOnlyVisibleItem: b,
      register: y,
      setActive: _,
      isLastChild: v = !1
    }
  } = d, S = q(
    () => !p && (u || h),
    [u, p, h]
  ), C = Yn(e), {
    activeItemIndex: x,
    setActiveItem: w,
    handleItemRegister: I,
    isOnlyActiveItemVisible: T,
    keysDelegatedHandlingToItem: N
  } = no({ defaultActiveItemIndex: 1 }), H = F(
    (E, ye) => {
      w({ index: ye }), g(E);
    },
    [g, w]
  ), D = (E) => {
    !S || !b || N.includes(E.key) || (E.key === "Home" ? (w({ step: "first" }), E.preventDefault()) : E.key === "End" ? (w({ step: "last" }), E.preventDefault()) : E.key === "ArrowDown" ? (w({ step: 1 }), E.preventDefault()) : E.key === "ArrowUp" && (w({ step: -1 }), E.preventDefault()));
  }, R = Jt(
    b
  );
  Qe(() => {
    b !== R && r?.({
      isActive: b,
      isLastChild: v
    });
  }, [
    b,
    r,
    R
  ]), X(() => {
    y(b ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [b]), dn("keydown", D);
  const A = F(
    ({ value: E, meta: ye }) => {
      ye?.target instanceof HTMLInputElement && ye.target.type === "checkbox" ? g({ value: E, meta: { isNode: !0 } }) : y({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), K = F(() => {
    y({ isOnlyVisibleItem: !1 });
  }, []);
  X(() => {
    b || w({ index: -1 });
  }, [b, w]);
  const oe = q(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: A,
        isNode: !0
      }
    }),
    [A, d]
  ), ne = q(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: K,
        isActive: x === 0,
        setActive: () => {
          _(), w({ index: 0 });
        },
        register: (E) => I(E, 0)
      }
    }),
    [
      x,
      K,
      I,
      d,
      _,
      w
    ]
  );
  return b ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !T && /* @__PURE__ */ s.jsx(c.Provider, { value: ne, children: /* @__PURE__ */ s.jsx(Zr, { ...t }) }),
    /* @__PURE__ */ s.jsx("li", { ref: l, ...a, children: /* @__PURE__ */ s.jsx(
      "ul",
      {
        role: "listbox",
        className: f(vb.list, n),
        ...o,
        children: C.map((E, ye) => {
          const ce = ye + 1;
          return Ie(E) && (!T || ce === x) && /* @__PURE__ */ s.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: m && ce === x,
                  setActive: () => {
                    _(), w({ index: ce });
                  },
                  register: (et) => I(et, ce),
                  onSelect: (et) => H(et, ce),
                  isOnlyVisibleItem: T,
                  isLastChild: ye === C.length - 1
                }
              },
              children: E
            },
            ye
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ s.jsx(c.Provider, { value: oe, children: i });
}, wb = Object.assign(W(Zo), {
  name: Zo.name
}), Sb = "h-selectionList-subComponents-section--selectionListSection__section", Ib = {
  section: Sb
}, Jo = ({
  title: i,
  children: e,
  listProps: { className: t, ...n } = {},
  onActiveStateChange: o,
  ...r
}, a) => {
  const l = Pt(), c = Oe(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: m,
      onSelect: g,
      register: b,
      isLastChild: y = !1
    }
  } = c, _ = q(
    () => !u && (h || d),
    [h, u, d]
  ), v = Yn(e), {
    activatableItemIndices: S,
    activeItemIndex: C,
    setActiveItem: x,
    handleItemRegister: w,
    keysDelegatedHandlingToItem: I
  } = no(), T = F(
    (D, R) => {
      x({ index: R }), g(D);
    },
    [g, x]
  ), N = (D) => {
    !_ || I.includes(D.key) || (D.key === "Home" ? x({ step: "first" }) : D.key === "End" && x({ step: "last" }), p ? D.key === "ArrowDown" && C !== S[S.length - 1] ? (x({ step: 1 }), D.preventDefault()) : D.key === "ArrowUp" && C !== S[0] && (x({ step: -1 }), D.preventDefault()) : D.key === "ArrowDown" ? x({ step: "first" }) : D.key === "ArrowUp" && x({ step: "last" }));
  }, H = Jt(p);
  return Qe(() => {
    p !== H && o?.({
      isActive: p,
      isLastChild: y
    });
  }, [p, o, H]), X(() => {
    const D = [];
    p && (C !== S[S.length - 1] && D.push("ArrowDown"), C !== S[0] && D.push("ArrowUp")), b({ keysTakenOverHandlingFromParent: D });
  }, [S, C, p]), Tt(() => b({ isActivatable: !0 })), Ze(() => b({ isActivatable: !1 })), dn("keydown", N), /* @__PURE__ */ s.jsx("li", { ref: a, ...r, children: /* @__PURE__ */ s.jsxs(
    "ul",
    {
      role: "group",
      className: f(Ib.section, t),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(Xr, { label: i }),
        v.map(
          (D, R) => Ie(D) && /* @__PURE__ */ s.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && R === C,
                  setActive: () => {
                    m(), x({ index: R });
                  },
                  register: (A) => w(A, R),
                  onSelect: (A) => T(A, R),
                  isLastChild: y && R === v.length - 1
                }
              },
              children: D
            },
            R
          )
        )
      ]
    }
  ) });
}, kb = Object.assign(W(Jo), {
  name: Jo.name
}), Db = Object.assign(W(qo), {
  name: qo.name,
  Item: yb,
  BackItem: Zr,
  Divider: Xr,
  Section: kb,
  List: wb
}), Tb = "h-inputSelectionList-chip--inputSelectionListChip__root", jb = "h-inputSelectionList-chip--inputSelectionListChip__name", er = {
  root: Tb,
  name: jb
}, bs = ({
  onDelete: i,
  className: e,
  disabled: t,
  readOnly: n,
  ...o
}) => {
  const r = q(() => {
    if (!(!i || t || n))
      return (a) => {
        a.stopPropagation(), i();
      };
  }, [t, i, n]);
  return /* @__PURE__ */ s.jsx(
    kt,
    {
      ...o,
      onDelete: r,
      className: f(er.root, e),
      tagNameClassName: er.name
    }
  );
}, Nb = "h-inputSelectionList--inputSelectionList__root", Fb = "h-inputSelectionList--inputSelectionList__inputWrapper", Pb = "h-inputSelectionList--inputSelectionList__inputWrapperChild", Rb = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", Eb = "h-inputSelectionList--inputSelectionList__rootReadOnly", Lb = "h-inputSelectionList--inputSelectionList__titleContainer", Ab = "h-inputSelectionList--inputSelectionList__filterInput", $b = "h-inputSelectionList--inputSelectionList__placeholder", Ob = "h-inputSelectionList--inputSelectionList__titleBox", Bb = "h-inputSelectionList--inputSelectionList__iconContainer", Hb = "h-inputSelectionList--inputSelectionList__iconButton", Wb = "h-inputSelectionList--inputSelectionList__dropdown", Mb = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", zb = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", ae = {
  root: Nb,
  inputWrapper: Fb,
  inputWrapperChild: Pb,
  rootHasWrapperIcon: Rb,
  rootReadOnly: Eb,
  titleContainer: Lb,
  filterInput: Ab,
  placeholder: $b,
  titleBox: Ob,
  iconContainer: Bb,
  iconButton: Hb,
  dropdown: Wb,
  hiddenItemsTooltip: Mb,
  hiddenItemsChip: zb
}, Vb = "inputSelectionListTestId", tr = ({
  className: i,
  name: e,
  value: t,
  onChange: n,
  prefix: o,
  suffix: r,
  icon: a,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: m,
  getItemTitleByValue: g,
  tabIndex: b,
  keepOpen: y,
  onToggleDropdown: _,
  onClick: v,
  onBlur: S,
  onKeyDown: C,
  limit: x = Number.POSITIVE_INFINITY,
  clearable: w = !1,
  equalityFn: I = Object.is,
  defaultActiveItemIndex: T,
  valueArrayToStringFn: N = JSON.stringify,
  rootClassName: H,
  dropdownProps: D,
  selectionListProps: R,
  slotBeforeList: A,
  slotAfterList: K,
  ...oe
}, ne) => {
  const E = Os(), ye = Y(null), ce = Y(null), et = Y(null), so = Y(null), [Z, ei] = V(!1);
  on(
    ne,
    () => ce.current
  );
  const Xn = q(
    () => p?.value !== void 0 && p.onChange !== void 0 && Z,
    [p, Z]
  ), ti = q(() => {
    if (!t?.length)
      return c;
    if (!m) {
      const M = g(t[0]);
      return typeof M == "object" ? "" : M?.toString();
    }
    return "";
  }, [m, c, g, t]), ni = q(() => Xn ? m && !!t?.length : !0, [m, Xn, t?.length]), Zn = F(
    (M) => {
      !h && !d && n?.({
        selectedItem: {
          isSelected: !1,
          value: M
        },
        selectedValues: t?.filter((Lt) => !I(Lt, M)) ?? []
      });
    },
    [d, I, n, h, t]
  ), si = q(() => {
    if (!t?.length)
      return /* @__PURE__ */ s.jsx(B, { alignItems: "center", className: ae.placeholder, children: c });
    if (m) {
      const M = x < t.length ? t.slice(0, x) : t, Lt = x < t.length ? t.slice(x) : [];
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        M?.map((At, Jn) => /* @__PURE__ */ s.jsx(
          bs,
          {
            onDelete: () => {
              Zn(At);
            },
            disabled: d,
            readOnly: h,
            children: g(At)
          },
          Jn
        )),
        !!Lt.length && /* @__PURE__ */ s.jsx(
          se,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ s.jsx(
              B,
              {
                className: ae.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: Lt?.map((At, Jn) => /* @__PURE__ */ s.jsx(
                  bs,
                  {
                    onDelete: () => {
                      Zn(At);
                    },
                    disabled: d,
                    readOnly: h,
                    children: g(At)
                  },
                  Jn
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ s.jsxs(
              bs,
              {
                className: ae.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  Lt.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ s.jsx(ie, { className: ae.titleBox, children: g(t[0]) });
  }, [
    t,
    m,
    g,
    c,
    x,
    d,
    h,
    Zn
  ]), de = F(
    (M) => {
      (h || d) && M || (M !== Z && _?.(M), ei(M));
    },
    [d, Z, _, h]
  ), Rt = F(
    ({ target: M }) => {
      so.current?.contains(M) || (ye.current?.contains(M) && ce.current?.focus(), de(!1));
    },
    [de]
  ), Et = F(
    (M) => {
      Nt(M.key) && Z && (de(!1), ce.current?.focus());
    },
    [Z, de]
  ), oi = F(
    (M) => {
      M.relatedTarget && ye.current?.contains(M.relatedTarget) || (de(!1), S?.(M));
    },
    [S, de]
  ), ri = F(
    (M) => {
      Z || M.stopPropagation(), de(!0), v?.(M);
    },
    [Z, v, de]
  ), ii = F(
    (M) => {
      Kn(M.key) && de(!0), C?.(M);
    },
    [C, de]
  ), ai = F(
    (M) => {
      M.stopPropagation(), de(!Z), ce.current?.focus();
    },
    [Z, de]
  ), li = F(
    (M) => {
      M.stopPropagation(), ce.current?.focus(), !d && !h && n?.({ selectedValues: [] });
    },
    [d, n, h]
  ), ci = F(
    (M) => {
      n?.(M), ce.current?.focus(), !y && !m ? de(!1) : et.current?.focus();
    },
    [m, y, n, de]
  );
  return X(() => (Z ? (E.addEventListener("click", Rt), E.addEventListener("keydown", Et)) : (E.removeEventListener("click", Rt), E.removeEventListener("keydown", Et)), () => {
    E.removeEventListener("click", Rt), E.removeEventListener("keydown", Et);
  }), [Rt, Et, Z, E]), X(() => {
    Z && et.current?.focus();
  }, [Z]), Ze(() => {
    E.removeEventListener("click", Rt), E.removeEventListener("keydown", Et);
  }), /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Vb,
      ref: ye,
      className: f(ae.root, H, {
        [ae.rootHasWrapperIcon]: !!a,
        [ae.rootReadOnly]: h
      }),
      "aria-expanded": Z,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ s.jsx(
          Be,
          {
            ...oe,
            ref: ce,
            className: f(i, ae.inputWrapper),
            prefix: o,
            suffix: r,
            disabled: d,
            icon: a,
            active: Z,
            status: l,
            onClick: ri,
            onBlur: oi,
            onKeyDown: ii,
            tabIndex: d ? -1 : b ?? 0,
            children: /* @__PURE__ */ s.jsxs(B, { className: ae.inputWrapperChild, children: [
              /* @__PURE__ */ s.jsxs(B, { gap: "100", flexWrap: "wrap", className: ae.titleContainer, children: [
                ni && si,
                Xn && /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...p,
                    ref: et,
                    className: f(ae.filterInput, p?.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: ti,
                    disabled: d || p?.disabled
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(B, { alignItems: "center", className: ae.iconContainer, children: [
                w && !d && !h && !!t?.length && /* @__PURE__ */ s.jsx(
                  U,
                  {
                    className: ae.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: li,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  U,
                  {
                    className: ae.iconButton,
                    variant: "tertiary",
                    icon: Z ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: ai,
                    "aria-label": Z ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        e && /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: e,
            value: N(t)
          }
        ),
        /* @__PURE__ */ s.jsx(
          Je,
          {
            isOpen: Z,
            ...D,
            className: f(D?.className, ae.dropdown),
            children: /* @__PURE__ */ s.jsx("div", { ref: so, style: { width: "100%" }, children: Z && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              A,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ s.jsx(
                Db,
                {
                  ...R,
                  equalityFn: I,
                  defaultActiveItemIndex: T,
                  isActive: Z,
                  isMultiple: m,
                  selectedValues: t,
                  onChange: ci,
                  children: u
                }
              ),
              K
            ] }) })
          }
        )
      ]
    }
  );
}, Kb = Object.assign(W(tr), {
  name: tr.name
}), nD = ({
  className: i,
  input: { value: e, name: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: t,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Kb,
      {
        name: t,
        value: e || [],
        onChange: (g) => {
          n(g.selectedValues);
        },
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Ub = "h-slider--slider__rootWrapper", qb = "h-slider--slider__rootWrapperNoAnnotations", Gb = "h-slider--slider__root", Yb = "h-slider--slider__rootDark", Qb = "h-slider--slider__rootDisabled", Xb = "h-slider--slider__handle", Zb = "h-slider--slider__trackWrapper", Jb = "h-slider--slider__track", ey = "h-slider--slider__highlight", ty = "h-slider--slider__minValueIndicator", ny = "h-slider--slider__maxValueIndicator", fe = {
  rootWrapper: Ub,
  rootWrapperNoAnnotations: qb,
  root: Gb,
  rootDark: Yb,
  rootDisabled: Qb,
  handle: Xb,
  trackWrapper: Zb,
  track: Jb,
  highlight: ey,
  minValueIndicator: ty,
  maxValueIndicator: ny
};
var Ne = /* @__PURE__ */ ((i) => (i.LowBoundIndicator = "input-slider-low-indicator", i.HighBoundIndicator = "input-slider-high-indicator", i.Handle = "input-slider-handle", i.Value = "input-slider-value", i.TrackBackground = "input-slider-tack-background", i.Track = "input-slider-track", i.Highlight = "input-slider-highlight", i))(Ne || {});
const sy = (i) => {
  i.preventDefault();
}, oy = (i, e, t) => typeof i != "number" && !Array.isArray(i) ? "" : typeof i == "number" ? /* @__PURE__ */ s.jsxs($.Paragraph, { variant: "3", children: [
  e,
  i,
  t
] }) : /* @__PURE__ */ s.jsxs($.Paragraph, { variant: "3", children: [
  e,
  i[0],
  t,
  " - ",
  e,
  i[1],
  t
] });
class ry extends k {
  static defaultProps = {
    min: 0,
    max: 100,
    dark: !1,
    highlightRange: null,
    formatValue: oy,
    hideAnnotations: !1
  };
  constructor(e) {
    super(e), this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  sliderRef = O();
  isInterval(e) {
    return Array.isArray(e);
  }
  handleChange(e) {
    typeof e == "number" ? this.props.onChange?.(Math.round(e)) : this.props.onChange?.(
      e.map((t) => Math.round(t))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(e) {
    e.target instanceof Element && this.setState({
      currentIndex: parseInt(
        e.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(e) {
    e.preventDefault();
    const { startVal: t, startX: n, sliderWidth: o, currentIndex: r } = this.state, a = t + (e.clientX - n) / o, l = this.getAbsoluteValue(a, r);
    this.handleChange(l);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(e) {
    const { step: t = 1, value: n } = this.props;
    e.preventDefault();
    const o = this.isInterval(n) && e.target instanceof Element ? parseInt(e.target.getAttribute("data-index") || "", 10) : null;
    switch (e.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(t, o);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-t, o);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(e) {
    if (!this.sliderRef.current) return;
    const { value: t } = this.props, { currentIndex: n } = this.state, o = this.sliderRef.current.getBoundingClientRect(), r = (e.clientX - o.left) / o.width;
    this.setState({
      startX: e.clientX,
      // save the current mouse x
      startVal: r,
      // save the current percentage
      sliderWidth: o.width
      // save the slider width
    });
    let a;
    if (this.isInterval(t)) {
      const l = n ?? this.findTheNearestHandle(r, t);
      this.setState({
        currentIndex: l
      }), a = this.getAbsoluteValue(r, l);
    } else
      a = this.getAbsoluteValue(r);
    this.handleChange(a), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(e, t) {
    const [n, o] = t.map(
      this.absoluteValueToRelativeValue
    );
    return e > o && e > n ? 1 : e < o && e < n ? 0 : Math.abs(n - e) > Math.abs(o - e) ? 1 : 0;
  }
  getAdjustedStep(e) {
    const { min: t, max: n } = this.props;
    return e / (n - t);
  }
  getAbsoluteValue(e, t) {
    const { value: n, step: o } = this.props;
    let r = Fn(e, 0, 1);
    if (o) {
      const h = this.getAdjustedStep(o);
      r = Math.round(r / h) * h;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(r);
    const [a, l] = n;
    let c = this.relativeValueToAbsoluteValue(r);
    t === 0 && c > l ? c = l : t === 1 && c < a && (c = a);
    const d = [a, l];
    return typeof t == "number" && (d[t] = c), d;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(e) {
    const { min: t, max: n } = this.props, o = t + (n - t) * e;
    return Fn(o, t, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(e) {
    const { min: t, max: n } = this.props, o = (e - t) / (n - t);
    return Fn(o, 0, 1);
  }
  increment(e, t) {
    const { value: n } = this.props;
    let o;
    if (this.isInterval(n)) {
      const r = [...n];
      r[t ?? 0] = r[t ?? 0] + e, o = r;
    } else
      o = n + e;
    this.handleChange(o);
  }
  getTrackStyles() {
    const { value: e, min: t } = this.props, n = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[1]) - this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(e), o = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(t);
    return {
      width: `${n * 100}%`,
      left: `${o * 100}%`
    };
  }
  getHandleStyles(e) {
    const { value: t } = this.props;
    return {
      left: `${(this.isInterval(t) ? this.absoluteValueToRelativeValue(t[e ?? 0]) : this.absoluteValueToRelativeValue(t)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: e } = this.props;
    if (_e(e)) return {};
    const [t, n] = e.map(this.absoluteValueToRelativeValue);
    return {
      left: `${t * 100}%`,
      width: `${(n - t) * 100}%`
    };
  }
  render() {
    const {
      className: e,
      value: t,
      step: n,
      highlightRange: o,
      min: r,
      max: a,
      dark: l,
      disabled: c,
      onChange: d,
      formatValue: h,
      hideAnnotations: u,
      valuePrefix: p,
      valueSuffix: m,
      onBlur: g,
      onFocus: b,
      children: y,
      ..._
    } = this.props, v = f(
      fe.root,
      { [fe.rootDark]: l },
      { [fe.rootDisabled]: c },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: f(fe.rootWrapper, {
          [fe.rootWrapperNoAnnotations]: u
        }),
        children: [
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              ..._,
              className: v,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ s.jsxs(
                  "div",
                  {
                    className: fe.trackWrapper,
                    "data-testid": Ne.TrackBackground,
                    children: [
                      !_e(o) && /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: fe.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": Ne.Highlight
                        }
                      ),
                      /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: fe.track,
                          style: this.getTrackStyles(),
                          "data-testid": Ne.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(t) && /* @__PURE__ */ s.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": r,
                    "aria-valuemax": a,
                    "aria-valuenow": t,
                    className: fe.handle,
                    onClick: sy,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": Ne.Handle
                  }
                ),
                this.isInterval(t) && /* @__PURE__ */ s.jsxs(Xe, { children: [
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: fe.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Ne.Handle
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: fe.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Ne.Handle
                    }
                  )
                ] }),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    "data-testid": Ne.LowBoundIndicator,
                    className: fe.minValueIndicator,
                    children: /* @__PURE__ */ s.jsxs($.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      r,
                      m
                    ] })
                  }
                ),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: fe.maxValueIndicator,
                    "data-testid": Ne.HighBoundIndicator,
                    children: /* @__PURE__ */ s.jsxs($.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      a,
                      m
                    ] })
                  }
                )
              ]
            }
          ),
          !u && /* @__PURE__ */ s.jsx("div", { "data-testid": Ne.Value, children: h(t, p, m) })
        ]
      }
    );
  }
}
const Fs = rn(ry, {
  fallback: null
}), iy = "h-fieldSlider--fieldSlider__root", ay = {
  root: iy
};
class sD extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(e) {
    const t = new Event("change");
    Object.defineProperty(t, "target", {
      writable: !0,
      value: { value: e, name: this.props.input.name }
    }), this.props.input.onChange(t);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(e) {
    const { input: t } = this.props, n = new FocusEvent(
      "blur",
      e
    );
    Object.defineProperty(n, "target", {
      writable: !0,
      value: { value: t.value, name: t.name }
    }), t.onBlur?.(n);
  }
  render() {
    const {
      className: e,
      input: t,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = f(ay.root, e);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: p,
        label: o,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Fs,
          {
            ...t,
            onChange: this.handleChange,
            disabled: a,
            ...u
          }
        )
      }
    );
  }
}
const ly = "h-switch--switch__root", cy = "h-switch--switch__input", dy = "h-switch--switch__inner", hy = "h-switch--switch__pending", uy = "h-switch--switch__active", Vt = {
  root: ly,
  input: cy,
  inner: dy,
  pending: hy,
  active: uy
}, nr = {
  input: "Switch-input",
  label: "Switch-label"
};
class py extends k {
  render() {
    const { id: e, className: t, variant: n, ...o } = this.props, r = e || `switch_${Math.random()}`;
    return /* @__PURE__ */ s.jsxs("div", { className: f(t, Vt.root), "data-testid": e, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...o,
          id: r,
          type: "checkbox",
          className: Vt.input,
          "data-testid": nr.input
        }
      ),
      /* @__PURE__ */ s.jsx(
        "label",
        {
          htmlFor: r,
          className: f(Vt.inner, {
            [Vt.active]: n === "active",
            [Vt.pending]: n === "pending"
          }),
          "data-testid": nr.label
        }
      )
    ] });
  }
}
class oD extends k {
  render() {
    const { input: e, ...t } = this.props, { ref: n, ...o } = e;
    return /* @__PURE__ */ s.jsx(py, { ...o, ...t });
  }
}
class rD extends k {
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Yr,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const iD = ({
  className: i,
  input: { name: e, value: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = F(
    (b) => {
      n(b ?? "");
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: e,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        tn,
        {
          selectedItems: t ? [t] : [],
          ...o,
          ...m,
          disabled: c,
          id: e,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, aD = ({
  className: i,
  input: { name: e, value: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = F(
    (b) => {
      n({
        startTime: b.startTime ?? "",
        endTime: b.endTime ?? ""
      });
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: e,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        Pp,
        {
          endTime: t.endTime,
          startTime: t.startTime,
          ...o,
          ...m,
          disabled: c,
          id: e,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, my = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", gy = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", fy = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", by = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", Sn = {
  root: my,
  rootAlpha: gy,
  indicator: fy,
  indicatorNoColor: by
}, yy = ({
  color: i,
  alpha: e,
  className: t,
  ...n
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ...n,
    className: f(Sn.root, t, {
      [Sn.rootAlpha]: e
    }),
    children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(Sn.indicator, {
          [Sn.indicatorNoColor]: !i
        }),
        style: { backgroundColor: i }
      }
    )
  }
), xy = "h-inputColorPicker--inputColorPicker__root", _y = "h-inputColorPicker--inputColorPicker__inputContainer", Cy = "h-inputColorPicker--inputColorPicker__input", vy = "h-inputColorPicker--inputColorPicker__rootReadOnly", wy = "h-inputColorPicker--inputColorPicker__iconContainer", Sy = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", Iy = "h-inputColorPicker--inputColorPicker__clearIcon", ky = "h-inputColorPicker--inputColorPicker__colorIndicator", Ue = {
  root: xy,
  inputContainer: _y,
  input: Cy,
  rootReadOnly: vy,
  iconContainer: wy,
  rootHasWrapperIcon: Sy,
  clearIcon: Iy,
  colorIndicator: ky
}, Dy = "inputColorPickerTestId", Ty = W(function({
  className: e,
  name: t = Math.floor(Math.random() * 1e8).toString(),
  value: n,
  onChange: o,
  dropdownProps: r,
  prefix: a,
  suffix: l,
  icon: c,
  status: d,
  placeholder: h,
  disabled: u,
  colorPickerProps: p,
  clearable: m,
  readOnly: g,
  children: b,
  ...y
}, _) {
  const v = Y(null), S = Y(null), C = Y(null), [x, w] = V(!1);
  X(() => {
    x ? (window.addEventListener("click", T), window.addEventListener("keydown", N)) : (window.removeEventListener("click", T), window.removeEventListener("keydown", N)), x && I();
  }, [x]), Ze(() => {
    window.removeEventListener("click", T), window.removeEventListener("keydown", N);
  });
  const I = () => {
    C.current?.querySelector("input")?.focus();
  }, T = ({ target: K }) => {
    S.current?.contains(K) || w(!1);
  }, N = (K) => {
    Nt(K.key) && x && (K.stopPropagation(), w(!1));
  }, H = () => {
    g || w(!0);
  }, D = ({ target: K }) => {
    S.current?.contains(K) || w(!1);
  }, R = () => {
    g || w(!0);
  }, A = ({ key: K }) => {
    Kn(K) && w(!0);
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Dy,
      ref: S,
      className: f(Ue.root, e, {
        [Ue.rootHasWrapperIcon]: !!c,
        [Ue.rootReadOnly]: g
      }),
      children: [
        /* @__PURE__ */ s.jsx(
          Be,
          {
            prefix: a,
            suffix: l,
            disabled: u,
            icon: c,
            active: x,
            status: d,
            children: /* @__PURE__ */ s.jsxs("div", { className: Ue.inputContainer, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ...y,
                  id: t,
                  name: t,
                  className: Ue.input,
                  ref: v,
                  onClick: R,
                  onFocus: H,
                  onBlur: D,
                  onKeyDown: A,
                  disabled: u,
                  placeholder: h,
                  autoComplete: "off",
                  value: n,
                  onChange: An(n) ? void 0 : L,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: Ue.iconContainer, children: m && n && /* @__PURE__ */ s.jsx(
                U,
                {
                  className: Ue.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: u,
                  onClick: () => o?.("")
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                yy,
                {
                  className: Ue.colorIndicator,
                  onClick: R,
                  color: n,
                  alpha: p?.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s.jsx(Je, { ...r, isOpen: x, children: /* @__PURE__ */ s.jsx("div", { ref: C, children: /* @__PURE__ */ s.jsx(
          Un,
          {
            margin: "300",
            ...p,
            color: n,
            onChange: o ?? L,
            children: b
          }
        ) }) })
      ]
    }
  );
}), lD = ({
  className: i,
  input: { value: e, name: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: t,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Ty,
      {
        name: t,
        value: e,
        onChange: n,
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), jy = "h-fieldAddonDropdown--fieldAddonDropdown__root", Ny = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", Fy = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", Py = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", In = {
  root: jy,
  prefix: Ny,
  suffix: Fy,
  angleDown: Py
}, cD = ({
  className: i,
  noArrow: e,
  ...t
}) => Ls(t) ? null : /* @__PURE__ */ s.jsx(Ai.Consumer, { children: ({ position: n, disabled: o }) => /* @__PURE__ */ s.jsx(
  Gs,
  {
    ...fr(t, "meta"),
    noStyle: !0,
    itemComponent: Lr,
    children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: f(
          In.root,
          {
            [In.prefix]: n === "prefix",
            [In.suffix]: n === "suffix"
          },
          i
        ),
        disabled: o || t.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ s.jsx("span", { children: t.meta.selectedValue }),
          !e && /* @__PURE__ */ s.jsx(
            P,
            {
              name: "angle-down",
              className: f("icon-vertical-fix", In.angleDown)
            }
          )
        ]
      }
    )
  }
) }), Ry = "h-countryFlag--countryFlag__flag", Ey = "h-countryFlag--countryFlag__ad", Ly = "h-countryFlag--countryFlag__ae", Ay = "h-countryFlag--countryFlag__af", $y = "h-countryFlag--countryFlag__ag", Oy = "h-countryFlag--countryFlag__ai", By = "h-countryFlag--countryFlag__al", Hy = "h-countryFlag--countryFlag__am", Wy = "h-countryFlag--countryFlag__ao", My = "h-countryFlag--countryFlag__aq", zy = "h-countryFlag--countryFlag__ar", Vy = "h-countryFlag--countryFlag__as", Ky = "h-countryFlag--countryFlag__at", Uy = "h-countryFlag--countryFlag__au", qy = "h-countryFlag--countryFlag__aw", Gy = "h-countryFlag--countryFlag__ax", Yy = "h-countryFlag--countryFlag__az", Qy = "h-countryFlag--countryFlag__ba", Xy = "h-countryFlag--countryFlag__bb", Zy = "h-countryFlag--countryFlag__bd", Jy = "h-countryFlag--countryFlag__be", ex = "h-countryFlag--countryFlag__bf", tx = "h-countryFlag--countryFlag__bg", nx = "h-countryFlag--countryFlag__bh", sx = "h-countryFlag--countryFlag__bi", ox = "h-countryFlag--countryFlag__bj", rx = "h-countryFlag--countryFlag__bl", ix = "h-countryFlag--countryFlag__bm", ax = "h-countryFlag--countryFlag__bn", lx = "h-countryFlag--countryFlag__bo", cx = "h-countryFlag--countryFlag__bq", dx = "h-countryFlag--countryFlag__br", hx = "h-countryFlag--countryFlag__bs", ux = "h-countryFlag--countryFlag__bt", px = "h-countryFlag--countryFlag__bv", mx = "h-countryFlag--countryFlag__bw", gx = "h-countryFlag--countryFlag__by", fx = "h-countryFlag--countryFlag__bz", bx = "h-countryFlag--countryFlag__ca", yx = "h-countryFlag--countryFlag__cd", xx = "h-countryFlag--countryFlag__cf", _x = "h-countryFlag--countryFlag__cg", Cx = "h-countryFlag--countryFlag__ch", vx = "h-countryFlag--countryFlag__ci", wx = "h-countryFlag--countryFlag__ck", Sx = "h-countryFlag--countryFlag__cl", Ix = "h-countryFlag--countryFlag__cm", kx = "h-countryFlag--countryFlag__cn", Dx = "h-countryFlag--countryFlag__co", Tx = "h-countryFlag--countryFlag__cp", jx = "h-countryFlag--countryFlag__cr", Nx = "h-countryFlag--countryFlag__cu", Fx = "h-countryFlag--countryFlag__cv", Px = "h-countryFlag--countryFlag__cw", Rx = "h-countryFlag--countryFlag__cy", Ex = "h-countryFlag--countryFlag__cz", Lx = "h-countryFlag--countryFlag__de", Ax = "h-countryFlag--countryFlag__dj", $x = "h-countryFlag--countryFlag__dk", Ox = "h-countryFlag--countryFlag__dm", Bx = "h-countryFlag--countryFlag__dz", Hx = "h-countryFlag--countryFlag__ec", Wx = "h-countryFlag--countryFlag__ee", Mx = "h-countryFlag--countryFlag__eg", zx = "h-countryFlag--countryFlag__eh", Vx = "h-countryFlag--countryFlag__er", Kx = "h-countryFlag--countryFlag__es", Ux = "h-countryFlag--countryFlag__et", qx = "h-countryFlag--countryFlag__eu", Gx = "h-countryFlag--countryFlag__fi", Yx = "h-countryFlag--countryFlag__fj", Qx = "h-countryFlag--countryFlag__fm", Xx = "h-countryFlag--countryFlag__fo", Zx = "h-countryFlag--countryFlag__fr", Jx = "h-countryFlag--countryFlag__ga", e_ = "h-countryFlag--countryFlag__gb", t_ = "h-countryFlag--countryFlag__gd", n_ = "h-countryFlag--countryFlag__ge", s_ = "h-countryFlag--countryFlag__gg", o_ = "h-countryFlag--countryFlag__gh", r_ = "h-countryFlag--countryFlag__gi", i_ = "h-countryFlag--countryFlag__gl", a_ = "h-countryFlag--countryFlag__gm", l_ = "h-countryFlag--countryFlag__gn", c_ = "h-countryFlag--countryFlag__gp", d_ = "h-countryFlag--countryFlag__gq", h_ = "h-countryFlag--countryFlag__gr", u_ = "h-countryFlag--countryFlag__gt", p_ = "h-countryFlag--countryFlag__gu", m_ = "h-countryFlag--countryFlag__gw", g_ = "h-countryFlag--countryFlag__gy", f_ = "h-countryFlag--countryFlag__hk", b_ = "h-countryFlag--countryFlag__hn", y_ = "h-countryFlag--countryFlag__hr", x_ = "h-countryFlag--countryFlag__ht", __ = "h-countryFlag--countryFlag__hu", C_ = "h-countryFlag--countryFlag__id", v_ = "h-countryFlag--countryFlag__ie", w_ = "h-countryFlag--countryFlag__il", S_ = "h-countryFlag--countryFlag__im", I_ = "h-countryFlag--countryFlag__iq", k_ = "h-countryFlag--countryFlag__ir", D_ = "h-countryFlag--countryFlag__is", T_ = "h-countryFlag--countryFlag__it", j_ = "h-countryFlag--countryFlag__je", N_ = "h-countryFlag--countryFlag__jm", F_ = "h-countryFlag--countryFlag__jo", P_ = "h-countryFlag--countryFlag__jp", R_ = "h-countryFlag--countryFlag__ke", E_ = "h-countryFlag--countryFlag__kg", L_ = "h-countryFlag--countryFlag__kh", A_ = "h-countryFlag--countryFlag__ki", $_ = "h-countryFlag--countryFlag__km", O_ = "h-countryFlag--countryFlag__kn", B_ = "h-countryFlag--countryFlag__kp", H_ = "h-countryFlag--countryFlag__kr", W_ = "h-countryFlag--countryFlag__kw", M_ = "h-countryFlag--countryFlag__ky", z_ = "h-countryFlag--countryFlag__kz", V_ = "h-countryFlag--countryFlag__la", K_ = "h-countryFlag--countryFlag__lb", U_ = "h-countryFlag--countryFlag__lc", q_ = "h-countryFlag--countryFlag__li", G_ = "h-countryFlag--countryFlag__lk", Y_ = "h-countryFlag--countryFlag__lr", Q_ = "h-countryFlag--countryFlag__ls", X_ = "h-countryFlag--countryFlag__lt", Z_ = "h-countryFlag--countryFlag__lu", J_ = "h-countryFlag--countryFlag__lv", eC = "h-countryFlag--countryFlag__ly", tC = "h-countryFlag--countryFlag__ma", nC = "h-countryFlag--countryFlag__mc", sC = "h-countryFlag--countryFlag__md", oC = "h-countryFlag--countryFlag__me", rC = "h-countryFlag--countryFlag__mf", iC = "h-countryFlag--countryFlag__mg", aC = "h-countryFlag--countryFlag__mh", lC = "h-countryFlag--countryFlag__mk", cC = "h-countryFlag--countryFlag__ml", dC = "h-countryFlag--countryFlag__mm", hC = "h-countryFlag--countryFlag__mn", uC = "h-countryFlag--countryFlag__mo", pC = "h-countryFlag--countryFlag__mq", mC = "h-countryFlag--countryFlag__mr", gC = "h-countryFlag--countryFlag__ms", fC = "h-countryFlag--countryFlag__mt", bC = "h-countryFlag--countryFlag__mu", yC = "h-countryFlag--countryFlag__mv", xC = "h-countryFlag--countryFlag__mw", _C = "h-countryFlag--countryFlag__mx", CC = "h-countryFlag--countryFlag__my", vC = "h-countryFlag--countryFlag__mz", wC = "h-countryFlag--countryFlag__na", SC = "h-countryFlag--countryFlag__nc", IC = "h-countryFlag--countryFlag__ne", kC = "h-countryFlag--countryFlag__ng", DC = "h-countryFlag--countryFlag__ni", TC = "h-countryFlag--countryFlag__nl", jC = "h-countryFlag--countryFlag__no", NC = "h-countryFlag--countryFlag__np", FC = "h-countryFlag--countryFlag__nq", PC = "h-countryFlag--countryFlag__nr", RC = "h-countryFlag--countryFlag__nu", EC = "h-countryFlag--countryFlag__nz", LC = "h-countryFlag--countryFlag__om", AC = "h-countryFlag--countryFlag__pa", $C = "h-countryFlag--countryFlag__pe", OC = "h-countryFlag--countryFlag__pf", BC = "h-countryFlag--countryFlag__pg", HC = "h-countryFlag--countryFlag__ph", WC = "h-countryFlag--countryFlag__pk", MC = "h-countryFlag--countryFlag__pl", zC = "h-countryFlag--countryFlag__pr", VC = "h-countryFlag--countryFlag__ps", KC = "h-countryFlag--countryFlag__pt", UC = "h-countryFlag--countryFlag__pw", qC = "h-countryFlag--countryFlag__py", GC = "h-countryFlag--countryFlag__qa", YC = "h-countryFlag--countryFlag__re", QC = "h-countryFlag--countryFlag__ro", XC = "h-countryFlag--countryFlag__rs", ZC = "h-countryFlag--countryFlag__ru", JC = "h-countryFlag--countryFlag__rw", ev = "h-countryFlag--countryFlag__sa", tv = "h-countryFlag--countryFlag__sb", nv = "h-countryFlag--countryFlag__sc", sv = "h-countryFlag--countryFlag__sd", ov = "h-countryFlag--countryFlag__se", rv = "h-countryFlag--countryFlag__sg", iv = "h-countryFlag--countryFlag__sh", av = "h-countryFlag--countryFlag__si", lv = "h-countryFlag--countryFlag__sj", cv = "h-countryFlag--countryFlag__sk", dv = "h-countryFlag--countryFlag__sl", hv = "h-countryFlag--countryFlag__sm", uv = "h-countryFlag--countryFlag__sn", pv = "h-countryFlag--countryFlag__so", mv = "h-countryFlag--countryFlag__sr", gv = "h-countryFlag--countryFlag__ss", fv = "h-countryFlag--countryFlag__st", bv = "h-countryFlag--countryFlag__sv", yv = "h-countryFlag--countryFlag__sx", xv = "h-countryFlag--countryFlag__sy", _v = "h-countryFlag--countryFlag__sz", Cv = "h-countryFlag--countryFlag__tc", vv = "h-countryFlag--countryFlag__td", wv = "h-countryFlag--countryFlag__tg", Sv = "h-countryFlag--countryFlag__th", Iv = "h-countryFlag--countryFlag__tj", kv = "h-countryFlag--countryFlag__tl", Dv = "h-countryFlag--countryFlag__tm", Tv = "h-countryFlag--countryFlag__tn", jv = "h-countryFlag--countryFlag__to", Nv = "h-countryFlag--countryFlag__tr", Fv = "h-countryFlag--countryFlag__tt", Pv = "h-countryFlag--countryFlag__tv", Rv = "h-countryFlag--countryFlag__tw", Ev = "h-countryFlag--countryFlag__tz", Lv = "h-countryFlag--countryFlag__ua", Av = "h-countryFlag--countryFlag__ug", $v = "h-countryFlag--countryFlag__us", Ov = "h-countryFlag--countryFlag__uy", Bv = "h-countryFlag--countryFlag__uz", Hv = "h-countryFlag--countryFlag__va", Wv = "h-countryFlag--countryFlag__vc", Mv = "h-countryFlag--countryFlag__ve", zv = "h-countryFlag--countryFlag__vg", Vv = "h-countryFlag--countryFlag__vi", Kv = "h-countryFlag--countryFlag__vn", Uv = "h-countryFlag--countryFlag__vu", qv = "h-countryFlag--countryFlag__ws", Gv = "h-countryFlag--countryFlag__ye", Yv = "h-countryFlag--countryFlag__yt", Qv = "h-countryFlag--countryFlag__za", Xv = "h-countryFlag--countryFlag__zm", Zv = "h-countryFlag--countryFlag__zw", sr = {
  flag: Ry,
  ad: Ey,
  ae: Ly,
  af: Ay,
  ag: $y,
  ai: Oy,
  al: By,
  am: Hy,
  ao: Wy,
  aq: My,
  ar: zy,
  as: Vy,
  at: Ky,
  au: Uy,
  aw: qy,
  ax: Gy,
  az: Yy,
  ba: Qy,
  bb: Xy,
  bd: Zy,
  be: Jy,
  bf: ex,
  bg: tx,
  bh: nx,
  bi: sx,
  bj: ox,
  bl: rx,
  bm: ix,
  bn: ax,
  bo: lx,
  bq: cx,
  br: dx,
  bs: hx,
  bt: ux,
  bv: px,
  bw: mx,
  by: gx,
  bz: fx,
  ca: bx,
  cd: yx,
  cf: xx,
  cg: _x,
  ch: Cx,
  ci: vx,
  ck: wx,
  cl: Sx,
  cm: Ix,
  cn: kx,
  co: Dx,
  cp: Tx,
  cr: jx,
  cu: Nx,
  cv: Fx,
  cw: Px,
  cy: Rx,
  cz: Ex,
  de: Lx,
  dj: Ax,
  dk: $x,
  dm: Ox,
  do: "h-countryFlag--countryFlag__do",
  dz: Bx,
  ec: Hx,
  ee: Wx,
  eg: Mx,
  eh: zx,
  er: Vx,
  es: Kx,
  et: Ux,
  eu: qx,
  fi: Gx,
  fj: Yx,
  fm: Qx,
  fo: Xx,
  fr: Zx,
  ga: Jx,
  gb: e_,
  gd: t_,
  ge: n_,
  gg: s_,
  gh: o_,
  gi: r_,
  gl: i_,
  gm: a_,
  gn: l_,
  gp: c_,
  gq: d_,
  gr: h_,
  gt: u_,
  gu: p_,
  gw: m_,
  gy: g_,
  hk: f_,
  hn: b_,
  hr: y_,
  ht: x_,
  hu: __,
  id: C_,
  ie: v_,
  il: w_,
  im: S_,
  in: "h-countryFlag--countryFlag__in",
  iq: I_,
  ir: k_,
  is: D_,
  it: T_,
  je: j_,
  jm: N_,
  jo: F_,
  jp: P_,
  ke: R_,
  kg: E_,
  kh: L_,
  ki: A_,
  km: $_,
  kn: O_,
  kp: B_,
  kr: H_,
  kw: W_,
  ky: M_,
  kz: z_,
  la: V_,
  lb: K_,
  lc: U_,
  li: q_,
  lk: G_,
  lr: Y_,
  ls: Q_,
  lt: X_,
  lu: Z_,
  lv: J_,
  ly: eC,
  ma: tC,
  mc: nC,
  md: sC,
  me: oC,
  mf: rC,
  mg: iC,
  mh: aC,
  mk: lC,
  ml: cC,
  mm: dC,
  mn: hC,
  mo: uC,
  mq: pC,
  mr: mC,
  ms: gC,
  mt: fC,
  mu: bC,
  mv: yC,
  mw: xC,
  mx: _C,
  my: CC,
  mz: vC,
  na: wC,
  nc: SC,
  ne: IC,
  ng: kC,
  ni: DC,
  nl: TC,
  no: jC,
  np: NC,
  nq: FC,
  nr: PC,
  nu: RC,
  nz: EC,
  om: LC,
  pa: AC,
  pe: $C,
  pf: OC,
  pg: BC,
  ph: HC,
  pk: WC,
  pl: MC,
  pr: zC,
  ps: VC,
  pt: KC,
  pw: UC,
  py: qC,
  qa: GC,
  re: YC,
  ro: QC,
  rs: XC,
  ru: ZC,
  rw: JC,
  sa: ev,
  sb: tv,
  sc: nv,
  sd: sv,
  se: ov,
  sg: rv,
  sh: iv,
  si: av,
  sj: lv,
  sk: cv,
  sl: dv,
  sm: hv,
  sn: uv,
  so: pv,
  sr: mv,
  ss: gv,
  st: fv,
  sv: bv,
  sx: yv,
  sy: xv,
  sz: _v,
  tc: Cv,
  td: vv,
  tg: wv,
  th: Sv,
  tj: Iv,
  tl: kv,
  tm: Dv,
  tn: Tv,
  to: jv,
  tr: Nv,
  tt: Fv,
  tv: Pv,
  tw: Rv,
  tz: Ev,
  ua: Lv,
  ug: Av,
  us: $v,
  uy: Ov,
  uz: Bv,
  va: Hv,
  vc: Wv,
  ve: Mv,
  vg: zv,
  vi: Vv,
  vn: Kv,
  vu: Uv,
  ws: qv,
  ye: Gv,
  yt: Yv,
  za: Qv,
  zm: Xv,
  zw: Zv
}, Jv = 127365, ew = /^[a-z]{2}$/, tw = (i) => ew.test(i) ? String.fromCodePoint(
  ...i.split("").map((e) => Jv + e.charCodeAt(0))
) : "", dD = ({
  className: i,
  countryCode: e,
  size: t = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ s.jsx(ie, { style: { width: t, height: t }, children: /* @__PURE__ */ s.jsx(
  ie,
  {
    className: f(sr.flag, sr[e], i),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${t} / 32))`
    }
  }
) }) : /* @__PURE__ */ s.jsx("span", { className: i, style: { fontSize: t }, children: tw(e) }), hD = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], nw = "h-formGrid--formGrid__root", sw = {
  root: nw
}, ow = "formGridTestId", uD = W(function({ className: e, children: t, ...n }, o) {
  const r = f(sw.root, e);
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-testid": ow,
      className: r,
      ...n,
      ref: o,
      children: t
    }
  );
}), rw = "h-formGrid-field--formField__root", iw = "h-formGrid-field--formField__rootSpan5", aw = "h-formGrid-field--formField__rootSpan4", lw = "h-formGrid-field--formField__rootSpan3", cw = "h-formGrid-field--formField__rootSpan2", dw = "h-formGrid-field--formField__rootSpan1", wt = {
  root: rw,
  rootSpan5: iw,
  rootSpan4: aw,
  rootSpan3: lw,
  rootSpan2: cw,
  rootSpan1: dw
}, hw = "formFieldTestId", uw = {
  1: wt.rootSpan1,
  2: wt.rootSpan2,
  3: wt.rootSpan3,
  4: wt.rootSpan4,
  5: wt.rootSpan5,
  6: void 0
};
class pD extends k {
  static defaultProps = {
    span: 6
  };
  render() {
    const { span: e, className: t, children: n, ...o } = this.props, r = f(
      wt.root,
      t,
      uw[e]
    );
    return /* @__PURE__ */ s.jsx("div", { "data-testid": hw, className: r, ...o, children: n });
  }
}
const pw = "h-helperField--helperField__root", mw = "h-helperField--helperField__label", gw = "h-helperField--helperField__helpIcon", fw = "h-helperField--helperField__error", bw = "h-helperField--helperField__rootRequired", Kt = {
  root: pw,
  label: mw,
  helpIcon: gw,
  error: fw,
  rootRequired: bw
};
class mD extends k {
  render() {
    const {
      className: e,
      label: t,
      required: n,
      disabled: o,
      errorMessage: r,
      fieldId: a,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = f(
      {
        [Kt.root]: !0,
        [Kt.rootRequired]: n
      },
      e
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      !!t && /* @__PURE__ */ s.jsx(
        "label",
        {
          className: Kt.label,
          htmlFor: a,
          id: `${a}-label`,
          children: t
        }
      ),
      !!c?.text && /* @__PURE__ */ s.jsx(
        Ms,
        {
          ...c,
          className: f(Kt.helpIcon, c?.className ?? "")
        }
      ),
      !!r && /* @__PURE__ */ s.jsx("p", { className: Kt.error, children: r }),
      l
    ] });
  }
}
const yw = "h-inputDuration--inputDuration__root", xw = {
  root: yw
}, ys = (i, e = [
  "hours",
  "minutes",
  "seconds"
]) => {
  const t = Math.floor(i / 1e3), n = {};
  let o = t;
  return e.includes("days") && (n.days = Math.floor(t / (24 * 3600)), o = t % (24 * 3600)), e.includes("hours") && (n.hours = Math.floor(o / 3600), o %= 3600), e.includes("minutes") && (n.minutes = Math.floor(o / 60), o %= 60), e.includes("seconds") && (n.seconds = o), n;
}, xs = (i) => ((i.days ?? 0) * 86400 + (i.hours ?? 0) * 3600 + (i.minutes ?? 0) * 60 + (i.seconds ?? 0)) * 1e3, _w = [
  "hours",
  "minutes",
  "seconds"
], gD = W(
  function(e, t) {
    const n = Y(null);
    on(t, () => n.current);
    const {
      className: o,
      name: r = "input-duration",
      value: a = 0,
      required: l = !1,
      disabled: c = !1,
      readOnly: d = !1,
      inputParts: h = _w,
      status: u,
      onChange: p,
      onBlur: m
    } = e, [g, b] = V(
      () => ys(a, h)
    );
    X(() => {
      const C = xs(g);
      if (a !== C) {
        const x = ys(a, h);
        b(x);
      }
    }, [a, h]);
    const y = F(
      (C, x) => {
        const w = Math.max(0, parseInt(x) || 0);
        if ((C === "minutes" || C === "seconds") && w > 60)
          return;
        const I = { ...g, [C]: w };
        b(I);
        const T = xs(I);
        p?.(T);
      },
      [g, p]
    ), _ = F(() => {
      const C = xs(g), x = ys(
        C,
        h
      );
      b(x), m?.();
    }, [g, h, m]), v = (C) => {
      const x = g[C] ?? 0, w = x === 0;
      return {
        type: "number",
        id: `${r}-${C}`,
        name: `${r}-${C}`,
        value: w ? "" : x,
        placeholder: w ? "0" : void 0,
        suffix: {
          type: "custom",
          value: C.charAt(0).toUpperCase() + C.slice(1)
        },
        min: 0,
        step: 1,
        required: l,
        disabled: c,
        readOnly: d,
        status: u,
        "aria-required": l,
        "aria-disabled": c,
        "aria-readonly": d,
        onBlur: _,
        onChange: (I) => y(C, I.target.value)
      };
    }, S = f(o, xw.root);
    return /* @__PURE__ */ s.jsxs("div", { ref: n, className: S, children: [
      h.includes("days") && /* @__PURE__ */ s.jsx(Ge, { ...v("days") }),
      h.includes("hours") && /* @__PURE__ */ s.jsx(Ge, { ...v("hours") }),
      h.includes("minutes") && /* @__PURE__ */ s.jsx(Ge, { ...v("minutes"), max: 60 }),
      h.includes("seconds") && /* @__PURE__ */ s.jsx(Ge, { ...v("seconds"), max: 60 })
    ] });
  }
), Ut = /* @__PURE__ */ new Map();
function Cw({
  containerId: i,
  children: e
}) {
  const [t, n] = V(null), o = (a) => {
    const l = Ut.get(i);
    l !== void 0 && Ut.set(i, l + a);
  }, r = () => {
    const a = document.createElement("div");
    return a.id = i, a;
  };
  return X(() => {
    let a = document.getElementById(i);
    return a || (a = r(), document.body.appendChild(a), Ut.set(i, 0)), n(a), o(1), () => {
      o(-1), Ut.get(i) === 0 && a && (Ut.delete(i), a.remove());
    };
  }, [i]), t ? Ui.createPortal(e, t) : null;
}
const vw = "h-modal--modal__root", ww = "h-modal--modal__rootSkipAnimation", Sw = "h-modal--modal__modalContainer", Iw = "h-modal--modal__modalContent", kw = "h-modal--modal__rootDisplayed", Dw = "h-modal--modal__rootOpened", Tw = "h-modal--modal__modal", jw = "h-modal--modal__modalStacked", Nw = "h-modal--modal__ghostPanel", Fw = "h-modal--modal__ghostLabel", De = {
  root: vw,
  rootSkipAnimation: ww,
  modalContainer: Sw,
  modalContent: Iw,
  rootDisplayed: kw,
  rootOpened: Dw,
  modal: Tw,
  modalStacked: jw,
  ghostPanel: Nw,
  ghostLabel: Fw
}, Pw = ke(!1);
class Rw extends k {
  rootRef;
  haskeydownEventListner;
  closeTimer;
  static defaultProps = {
    allowEscClose: !0,
    restoreFocus: !0,
    bringInFocusOnTab: !0
  };
  constructor(e) {
    super(e), this.rootRef = O(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: e } = this.props;
    e && this.animateOpening();
  }
  componentDidUpdate(e) {
    const { isOpen: t, allowEscClose: n } = this.props, { isOpen: o } = e;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), t !== o && (t ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(e) {
    const { isOpen: t, onClose: n } = this.props;
    t && Nt(e.key) && (this.rootRef.current?.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (e.preventDefault(), e.stopPropagation(), this.animateClosing(), n(e)));
  }
  removeKeyDownEventListener = () => {
    window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
  };
  cancelAnimation() {
    const { current: e } = this.rootRef;
    e && e.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    const { skipAnimation: e } = this.props;
    e ? this.setState({ displayed: !0, opened: !0 }) : (this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 })));
  }
  animateClosing() {
    const { skipAnimation: e } = this.props;
    this.removeKeyDownEventListener(), e ? this.setState({ opened: !1, displayed: !1 }) : (this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred());
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: e,
      isOpen: t,
      children: n,
      onClose: o,
      allowClickOutside: r,
      allowEscClose: a,
      // Stops allowEscClose from being passed in with otherProps
      skipAnimation: l,
      wrapProps: c,
      autoFocus: d,
      restoreFocus: h,
      bringInFocusOnTab: u,
      ...p
    } = this.props, { displayed: m, opened: g } = this.state, b = f(De.root, c?.className, {
      [De.rootDisplayed]: m,
      [De.rootOpened]: g,
      [De.rootSkipAnimation]: l
    });
    return /* @__PURE__ */ s.jsx(Cw, { containerId: "modal-container", children: /* @__PURE__ */ s.jsx("div", { ...c, className: b, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: De.modalContainer,
        ref: this.rootRef,
        ...r ? { onClick: o } : {},
        ...p,
        children: g && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ s.jsx(
          Cr,
          {
            containerRef: this.rootRef,
            autoFocus: d,
            restoreFocus: h,
            bringInFocusOnTab: u,
            children: /* @__PURE__ */ s.jsx("div", { className: De.modalContent, children: /* @__PURE__ */ s.jsx(Pw.Consumer, { children: (y) => /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: f(De.modal, e, {
                  [De.modalStacked]: y
                }),
                onClick: (_) => r && _.stopPropagation(),
                children: [
                  y && /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      role: "button",
                      tabIndex: -1,
                      className: De.ghostPanel,
                      onClick: o,
                      children: /* @__PURE__ */ s.jsxs("span", { className: De.ghostLabel, children: [
                        /* @__PURE__ */ s.jsx(P, { name: "arrow-left", size: 12 }),
                        "Go back"
                      ] })
                    }
                  ),
                  n
                ]
              }
            ) }) })
          }
        )
      }
    ) }) });
  }
}
const Ew = "h-lightbox--lightbox__lightSource", Lw = "h-lightbox--lightbox__closeButton", Aw = "h-lightbox--lightbox__downloadButton", $w = "h-lightbox--lightbox__image", Ow = "h-lightbox--lightbox__loadingContainer", Bw = "h-lightbox--lightbox__navButton", Hw = "h-lightbox--lightbox__navButtonPrevious", Ww = "h-lightbox--lightbox__navButtonNext", Mw = "h-lightbox--lightbox__counter", Te = {
  lightSource: Ew,
  closeButton: Lw,
  downloadButton: Aw,
  image: $w,
  loadingContainer: Ow,
  navButton: Bw,
  navButtonPrevious: Hw,
  navButtonNext: Ww,
  counter: Mw
};
class fD extends k {
  render() {
    const {
      className: e,
      src: t,
      alt: n,
      isOpen: o,
      onClose: r,
      showNavigation: a = !1,
      currentIndex: l = 0,
      totalImages: c = 1,
      onPrevious: d,
      onNext: h,
      isLoading: u = !1
    } = this.props, p = c > 1;
    return /* @__PURE__ */ s.jsx(
      Rw,
      {
        className: e,
        isOpen: o,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ s.jsxs("div", { className: Te.lightSource, children: [
          u ? /* @__PURE__ */ s.jsx("div", { className: Te.loadingContainer, children: /* @__PURE__ */ s.jsx($s, { size: 64 }) }) : t && /* @__PURE__ */ s.jsx(Bs, { className: Te.image, alt: n, src: t }),
          r && /* @__PURE__ */ s.jsx(
            U,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: Te.closeButton
            }
          ),
          t && typeof t == "string" && /* @__PURE__ */ s.jsx(
            "a",
            {
              href: t,
              target: "_blank",
              download: !0,
              className: Te.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ s.jsx(
                P,
                {
                  name: "cloud-download",
                  className: f("icon-vertical-fix")
                }
              )
            }
          ),
          a && p && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              U,
              {
                icon: "arrow-left",
                variant: "primary",
                size: "large",
                onClick: d,
                className: `${Te.navButton} ${Te.navButtonPrevious}`
              }
            ),
            /* @__PURE__ */ s.jsx(
              U,
              {
                icon: "arrow-right",
                variant: "primary",
                size: "large",
                onClick: h,
                className: `${Te.navButton} ${Te.navButtonNext}`
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: Te.counter, children: [
              l + 1,
              " / ",
              c
            ] })
          ] })
        ] })
      }
    );
  }
}
const zw = "h-list-items--item__root", Vw = "h-list-items--item__rootWithHoverEffect", Kw = "h-list-items--item__rootDense", Uw = "h-list-items--item__rootLarge", qw = "h-list-items--item__contentLeft", Gw = "h-list-items--item__contentRight", Yw = "h-list-items--item__titles", Qw = "h-list-items--item__title", Xw = "h-list-items--item__titleSecondary", Zw = "h-list-items--item__arrow", je = {
  root: zw,
  rootWithHoverEffect: Vw,
  rootDense: Kw,
  rootLarge: Uw,
  contentLeft: qw,
  contentRight: Gw,
  titles: Yw,
  title: Qw,
  titleSecondary: Xw,
  arrow: Zw
};
class Qn extends k {
  static defaultProps = {
    variant: "dense",
    withHoverEffect: !0
  };
  renderTitle() {
    const { title: e, titleSecondary: t } = this.props;
    return e || t ? /* @__PURE__ */ s.jsxs("div", { className: je.titles, children: [
      !!e && /* @__PURE__ */ s.jsx($.Paragraph, { as: "div", variant: "2", className: je.title, children: e }),
      !!t && /* @__PURE__ */ s.jsx(
        $.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: je.titleSecondary,
          children: t
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: e } = this.props;
    return e ? /* @__PURE__ */ s.jsx("div", { className: je.contentLeft, children: e }) : null;
  }
  renderContentRight() {
    const { contentRight: e } = this.props;
    return e ? /* @__PURE__ */ s.jsx("div", { className: je.contentRight, children: e }) : null;
  }
  renderIcon() {
    const { isLink: e, contentRight: t } = this.props;
    return e && !t ? /* @__PURE__ */ s.jsx(
      P,
      {
        className: f(je.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ s.jsxs(Xe, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: e,
      children: t,
      contentLeft: n,
      contentRight: o,
      title: r,
      titleSecondary: a,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = f(je.root, e, {
      [je.rootDense]: d === "dense",
      [je.rootLarge]: d === "large",
      [je.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ s.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
const Jw = "h-list-items--keyValue__root", eS = {
  root: Jw
};
class tS extends k {
  static defaultProps = {
    hideIfValueIsEmpty: !0
  };
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: e, className: t, pair: n, ...o } = this.props, r = f(eS.root, t);
    return e && this.isValueEmpty() ? null : /* @__PURE__ */ s.jsx(
      Qn,
      {
        ...o,
        className: r,
        title: /* @__PURE__ */ s.jsx($.Paragraph, { as: "span", variant: "4", subdued: !0, children: n.key }),
        titleSecondary: /* @__PURE__ */ s.jsx($.Paragraph, { as: "span", variant: "2", children: n.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
const nS = "h-list-items--text__root", sS = {
  root: nS
};
class oS extends k {
  render() {
    const { children: e, className: t, ...n } = this.props, o = f(sS.root, t);
    return /* @__PURE__ */ s.jsx(
      Qn,
      {
        ...n,
        className: o,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: e })
      }
    );
  }
}
const rS = "h-list-items--user__root", iS = "h-list-items--user__avatarWrapper", or = {
  root: rS,
  avatarWrapper: iS
};
class aS extends k {
  getTitle() {
    const { user: e, title: t } = this.props;
    return t || e.display_name || e.name || e.phone_number || e.id;
  }
  getSubTitle() {
    const { user: e, titleSecondary: t } = this.props;
    return t || e.email;
  }
  render() {
    const { className: e, user: t, title: n, titleSecondary: o, ...r } = this.props, a = f(e, or.root);
    return /* @__PURE__ */ s.jsx(
      Qn,
      {
        className: a,
        contentLeft: /* @__PURE__ */ s.jsx("div", { className: or.avatarWrapper, children: /* @__PURE__ */ s.jsx(_r, { user: t }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const lS = "h-list--list__root", cS = {
  root: lS
};
class dS extends k {
  static Item = Qn;
  static Text = oS;
  static User = aS;
  static KeyValue = tS;
  render() {
    const { className: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx("ul", { ...t, className: f(cS.root, e) });
  }
}
const bD = rn(dS, {
  fallback: null
}), hS = () => {
  document.exitFullscreen && document.exitFullscreen();
}, uS = (i) => {
  i.requestFullscreen ? i.requestFullscreen() : i.mozRequestFullScreen ? i.mozRequestFullScreen() : i.webkitRequestFullscreen ? i.webkitRequestFullscreen() : i.msRequestFullscreen && i.msRequestFullscreen();
}, pS = (i) => document.fullscreenElement === i;
class mS extends Error {
  status;
  url;
  response;
  constructor(e) {
    super(`NetworkError ${e.status} ${e.url}`), this.status = e.status, this.url = e.url, this.response = e;
  }
}
const gS = {
  fetch: (i, ...e) => fetch(i, ...e).then((t) => {
    if (!(t.status >= 200 && t.status < 300))
      throw new mS(t);
    return t;
  })
}, fS = "h-mediaPlayer--mediaPlayer__root", bS = "h-mediaPlayer--mediaPlayer__controls", yS = "h-mediaPlayer--mediaPlayer__unstyled", xS = "h-mediaPlayer--mediaPlayer__rootFullScreen", _S = "h-mediaPlayer--mediaPlayer__rootHideControls", CS = "h-mediaPlayer--mediaPlayer__control", vS = "h-mediaPlayer--mediaPlayer__progress", wS = "h-mediaPlayer--mediaPlayer__progressSlider", SS = "h-mediaPlayer--mediaPlayer__volumeSlider", IS = "h-mediaPlayer--mediaPlayer__timestamp", kS = "h-mediaPlayer--mediaPlayer__videoWrapper", DS = "h-mediaPlayer--mediaPlayer__rootWaiting", TS = "h-mediaPlayer--mediaPlayer__rootAudio", jS = "h-mediaPlayer--mediaPlayer__video", NS = "h-mediaPlayer--mediaPlayer__volume", FS = "h-mediaPlayer--mediaPlayer__volumeMuteControl", PS = "h-mediaPlayer--mediaPlayer__downloadLink", J = {
  root: fS,
  controls: bS,
  unstyled: yS,
  rootFullScreen: xS,
  rootHideControls: _S,
  control: CS,
  progress: vS,
  progressSlider: wS,
  volumeSlider: SS,
  timestamp: IS,
  videoWrapper: kS,
  rootWaiting: DS,
  rootAudio: TS,
  video: jS,
  volume: NS,
  volumeMuteControl: FS,
  downloadLink: PS
};
function RS(i) {
  const e = i >= 3600 ? 8 : 5;
  return Number.isNaN(i) || !Number.isFinite(i) ? "00:00" : new Date(i * 1e3).toISOString().substr(19 - e, e);
}
class yD extends k {
  intersectionObserver;
  static defaultProps = {
    headers: {}
  };
  constructor(e) {
    super(e), this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: e } = this.props, { current: t } = this.playerRef;
    t && t.addEventListener("fullscreenchange", this.handleFullscreenChange), e ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(e, t) {
    const {
      mediaFile: { src: n }
    } = e, {
      lazy: o,
      mediaFile: { src: r }
    } = this.props;
    n !== r && (o ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(t);
  }
  componentWillUnmount() {
    const { current: e } = this.playerRef;
    e && e.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  videoRef = O();
  playerRef = O();
  hideControlsTimeout = void 0;
  controller = new AbortController();
  loadSrc() {
    const {
      mediaFile: { src: e },
      isPrivateFile: t
    } = this.props;
    this.tryStopPlayer(), t ? this.fetchFile() : this.setSrc(e);
  }
  setSrc(e) {
    this.setState({
      src: e
    });
  }
  handleIntersection([e]) {
    const { src: t, asyncStatus: n } = this.state;
    !t && !(n === "loading") && e.isIntersecting && (this.loadSrc(), this.intersectionObserver?.disconnect());
  }
  createIntersectionObserver() {
    const { current: e } = this.playerRef;
    e && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(e));
  }
  tryStopPlayer() {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    e.currentTime = 0;
    const { playing: t, actuallyPlaying: n } = this.state;
    t && n && (e.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(e) {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { src: n } = this.state;
    n !== e.src && t.load();
  }
  fetchFile(e) {
    const {
      mediaFile: { src: t },
      headers: n,
      filename: o
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const r = new Headers(n);
    gS.fetch(t, {
      headers: r,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((a) => a.blob()).then((a) => {
      const l = window.URL.createObjectURL(a);
      e ? Ei.saveAs(
        a,
        o || decodeURIComponent(t.split("/").pop())
      ) : this.setSrc(l), this.setState({ asyncStatus: "succeeded" });
    }).catch((a) => {
      a && a.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", a), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: e } = this.videoRef;
    e && this.setState({
      time: e.currentTime,
      duration: e.duration
    });
  }
  updateBuffer() {
    const { current: e } = this.videoRef, { time: t, duration: n } = this.state;
    if (e) {
      let o = null;
      const r = e.buffered;
      for (let a = 0; a < r.length; a += 1) {
        const l = r.start(a), c = r.end(a);
        l <= t && t <= c && (o = [l / n, c / n]);
      }
      this.setState({
        buffer: o
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: e, actuallyPlaying: t } = this.state, { current: n } = this.videoRef;
    n && (e && t ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : e || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: e } = this.playerRef, t = pS(e);
    this.setState({
      isFullScreen: t
    }), t ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: e } = this.playerRef, { isFullScreen: t } = this.state;
    e && (t ? hS() : uS(e));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(e) {
    const { current: t } = this.videoRef, { duration: n } = this.state;
    t && e && !Number.isNaN(e) && (t.currentTime = n * e);
  }
  handleVolume = (e) => {
    const { current: t } = this.videoRef;
    !t || typeof e > "u" || !Number.isFinite(e) || this.setState({ volume: e }, () => {
      this.setPlayerVolume(e);
    });
  };
  handleMute() {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { volume: t, prevVolume: n } = this.state, o = t === 0, r = o ? n : 0;
    this.setState(
      {
        volume: r,
        prevVolume: o ? n : t
      },
      () => {
        this.setPlayerVolume(r);
      }
    );
  }
  setPlayerVolume(e) {
    const { current: t } = this.videoRef;
    t && (t.volume = e / 100);
  }
  render() {
    const {
      className: e,
      mediaFile: { type: t },
      headers: n,
      isPrivateFile: o,
      width: r,
      controls: a,
      noControlsStyle: l,
      ...c
    } = this.props, {
      src: d,
      playing: h,
      duration: u,
      time: p,
      volume: m,
      hideControls: g,
      isFullScreen: b,
      isWaiting: y,
      buffer: _,
      asyncStatus: v
    } = this.state, S = a?.play ?? !0, C = a?.download ?? !0, x = a?.progress ?? !0, w = a?.volume ?? !0, I = a?.maximize ?? !0, T = S || C || x || w || I, N = typeof t == "string" && t.startsWith("audio"), H = !d || v === "loading", D = b ? "primary" : "secondary", R = f(
      J.root,
      {
        [J.rootFullScreen]: b,
        [J.rootHideControls]: g,
        [J.rootWaiting]: h && y,
        [J.rootAudio]: N
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...c,
        className: R,
        ref: this.playerRef,
        style: { width: r },
        children: [
          /* @__PURE__ */ s.jsx("div", { className: J.videoWrapper, children: !!d && /* @__PURE__ */ s.jsx(
            "video",
            {
              className: J.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ s.jsx("source", { src: d })
            }
          ) }),
          T && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: f(J.controls, {
                [J.unstyled]: l
              }),
              children: [
                S && /* @__PURE__ */ s.jsx(
                  U,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: J.control,
                    disabled: H,
                    icon: h ? "pause" : "play",
                    variant: D
                  }
                ),
                C && (o ? /* @__PURE__ */ s.jsx(
                  te,
                  {
                    variant: D,
                    className: J.control,
                    disabled: H,
                    children: /* @__PURE__ */ s.jsx(
                      "a",
                      {
                        href: d,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: J.downloadLink,
                        children: /* @__PURE__ */ s.jsx(P, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ s.jsx(
                  U,
                  {
                    icon: "download",
                    variant: D,
                    className: J.control,
                    disabled: H,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                x && /* @__PURE__ */ s.jsxs("div", { className: J.progress, children: [
                  /* @__PURE__ */ s.jsx(
                    Fs,
                    {
                      hideAnnotations: !0,
                      className: J.progressSlider,
                      min: 0,
                      max: u,
                      value: p,
                      onChange: (A) => !Array.isArray(A) && this.seek(A / u),
                      dark: b,
                      highlightRange: _?.map((A) => A * u)
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: J.timestamp, children: RS(u) })
                ] }),
                w && /* @__PURE__ */ s.jsxs("div", { className: J.volume, children: [
                  /* @__PURE__ */ s.jsx(
                    P,
                    {
                      className: J.volumeMuteControl,
                      name: m === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    Fs,
                    {
                      hideAnnotations: !0,
                      className: J.volumeSlider,
                      value: m,
                      onChange: (A) => !Array.isArray(A) && this.handleVolume(A),
                      dark: b
                    }
                  )
                ] }),
                I && !N && /* @__PURE__ */ s.jsx(
                  U,
                  {
                    variant: D,
                    onClick: this.handleFullscreenToggle,
                    className: J.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
const ES = "h-modalBody--modalBody__root", LS = {
  root: ES
};
class xD extends k {
  render() {
    const { className: e, children: t, ...n } = this.props, o = f(
      {
        [LS.root]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: t });
  }
}
const AS = "h-modalFoot--modalFoot__root", $S = "h-modalFoot--modalFoot__confirm", OS = "h-modalFoot--modalFoot__confirmSecondary", BS = "h-modalFoot--modalFoot__cancel", kn = {
  root: AS,
  confirm: $S,
  confirmSecondary: OS,
  cancel: BS
};
class HS extends k {
  static defaultProps;
  render() {
    const {
      className: e,
      confirmOnClick: t,
      confirmSecondaryOnClick: n,
      cancelOnClick: o,
      confirmName: r,
      confirmSecondaryName: a,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, m = f(
      {
        [kn.root]: !0
      },
      e
    ), g = f(
      {
        [kn.cancel]: !0
      },
      h?.className
    ), b = f(
      {
        [kn.confirm]: !0
      },
      c?.className
    ), y = f(
      {
        [kn.confirmSecondary]: !0
      },
      d?.className
    );
    return /* @__PURE__ */ s.jsxs("div", { ...p, className: m, children: [
      u,
      n && /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "secondary",
          ...d,
          className: y,
          onClick: n,
          children: a
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "tertiary",
          ...h,
          className: g,
          onClick: o,
          children: l
        }
      ),
      t && /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "primary",
          ...c,
          className: b,
          onClick: t,
          children: r
        }
      )
    ] });
  }
}
HS.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const WS = "h-modalHead--modalHead__root", MS = "h-modalHead--modalHead__top", zS = "h-modalHead--modalHead__title", VS = "h-modalHead--modalHead__buttons", KS = "h-modalHead--modalHead__caption", qt = {
  root: WS,
  top: MS,
  title: zS,
  buttons: VS,
  caption: KS
}, _D = ({
  className: i,
  title: e,
  children: t,
  onClose: n,
  secondaryButton: o,
  buttonsClassName: r,
  buttonsSlot: a,
  ...l
}) => {
  const c = f(
    {
      [qt.root]: !0
    },
    i
  );
  return /* @__PURE__ */ s.jsxs("div", { ...l, className: c, children: [
    /* @__PURE__ */ s.jsxs("div", { className: qt.top, children: [
      /* @__PURE__ */ s.jsx($.Heading, { className: qt.title, children: e }),
      /* @__PURE__ */ s.jsxs("div", { className: f(qt.buttons, r), children: [
        a,
        typeof o?.onClick == "function" && /* @__PURE__ */ s.jsx(se, { content: o?.tooltipContent, children: /* @__PURE__ */ s.jsx(
          U,
          {
            icon: o?.icon,
            variant: "tertiary",
            onClick: o?.onClick
          }
        ) }),
        typeof n == "function" && /* @__PURE__ */ s.jsx(
          U,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: n
          }
        )
      ] })
    ] }),
    !!t && /* @__PURE__ */ s.jsx(
      $.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: qt.caption,
        children: t
      }
    )
  ] });
}, US = "h-page-body--pageBody__root", qS = {
  root: US
}, GS = W(function({ children: e, className: t, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    ue.Row,
    {
      ...n,
      ref: o,
      className: f(qS.root, t),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: e
    }
  );
}), YS = "h-page-head--pageHead__root", QS = {
  root: YS
}, XS = W(function({ className: e, title: t, controls: n, ...o }, r) {
  return /* @__PURE__ */ s.jsxs(
    ue.Row,
    {
      ...o,
      ref: r,
      as: "header",
      className: f(QS.root, e),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ s.jsx(ue.Slot, { placement: "start", children: /* @__PURE__ */ s.jsx($.Heading, { variant: "heading-2", as: "h1", children: t }) }),
        n && /* @__PURE__ */ s.jsx(ue.Slot, { placement: "end", children: /* @__PURE__ */ s.jsx(B, { alignItems: "center", gap: "200", children: n }) })
      ]
    }
  );
}), ZS = "h-page-section--pageSection__root", JS = "h-page-section--pageSection__head", eI = "h-page-section--pageSection__callout", tI = "h-page-section--pageSection__content", Dn = {
  root: ZS,
  head: JS,
  callout: eI,
  content: tI
}, nI = W(function({
  children: e,
  className: t,
  title: n,
  titleMeta: o,
  controls: r,
  callout: a,
  ...l
}, c) {
  const d = !!(n || o || r);
  return /* @__PURE__ */ s.jsxs(
    ue.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: f(Dn.root, t),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ s.jsxs(
          ue.Row,
          {
            className: Dn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (n || o) && /* @__PURE__ */ s.jsx(ue.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsxs(B, { alignItems: "center", gap: "200", children: [
                n && /* @__PURE__ */ s.jsx($.Heading, { variant: "heading-3", as: "h2", children: n }),
                o && /* @__PURE__ */ s.jsx(B, { alignItems: "center", gap: "200", children: o })
              ] }) }),
              r && /* @__PURE__ */ s.jsx(ue.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsx(B, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        a && /* @__PURE__ */ s.jsx(
          ue.Row,
          {
            className: Dn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: a
          }
        ),
        /* @__PURE__ */ s.jsx(
          ue.Row,
          {
            className: Dn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: e
          }
        )
      ]
    }
  );
}), sI = W(function({ children: e, className: t, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    ue.Row,
    {
      ...n,
      ref: o,
      className: t,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: e
    }
  );
}), rr = ({ children: i, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Nc, { ...t, ref: n, as: "article", className: e, children: /* @__PURE__ */ s.jsx(ue, { children: i }) }), CD = Object.assign(W(rr), {
  name: rr.name,
  Head: XS,
  Body: GS,
  Section: nI,
  Tabs: sI
}), oI = "h-radio--radio__radio", rI = "h-radio--radio__radioDisabled", iI = "h-radio--radio__radioChecked", aI = "h-radio--radio__input", Tn = {
  radio: oI,
  radioDisabled: rI,
  radioChecked: iI,
  input: aI
}, vD = W(function(e, t) {
  const { id: n, checked: o, disabled: r, className: a, labelProps: l, ...c } = e, d = f(
    Tn.radio,
    { [Tn.radioChecked]: o },
    { [Tn.radioDisabled]: r },
    a
  ), h = n || `radio_${Math.random()}`;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ s.jsx(
        "input",
        {
          ...c,
          ref: t,
          id: h,
          onChange: c.onChange || L,
          checked: o,
          disabled: r,
          type: "radio",
          className: Tn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), lI = "h-reverseScroll--reverseScroll__root", cI = "h-reverseScroll--reverseScroll__column", dI = "h-reverseScroll--reverseScroll__row", hI = "h-reverseScroll--reverseScroll__scrollHandle", Gt = {
  root: lI,
  column: cI,
  row: dI,
  scrollHandle: hI
}, uI = "reverse-scroll", wD = W(function({
  children: e,
  className: t,
  direction: n = "column",
  ...o
}, r) {
  const a = Y(null), l = Y(null), c = Y(null), d = Yn(e), h = q(
    () => d.reverse(),
    [d]
  ), u = (b) => c.current?.scrollIntoView(b), p = (b) => l.current?.scrollIntoView(b), m = (b) => a.current?.children[1]?.scrollIntoView(b), g = (b) => a.current?.children[a.current.children.length - 2]?.scrollIntoView(b);
  return on(r, () => ({
    rootElem: a.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: g,
    scrollToLastChild: m
  })), /* @__PURE__ */ s.jsxs(
    "div",
    {
      ...o,
      "data-testid": uI,
      ref: a,
      className: f(t, Gt.root, {
        [Gt.row]: n === "row",
        [Gt.column]: n === "column"
      }),
      children: [
        /* @__PURE__ */ s.jsx("div", { ref: c, className: Gt.scrollHandle }),
        h,
        /* @__PURE__ */ s.jsx("div", { ref: l, className: Gt.scrollHandle })
      ]
    }
  );
}), pI = "h-removableCard--removableCard__root", mI = "h-removableCard--removableCard__close", gI = "h-removableCard--removableCard__title", fI = "h-removableCard--removableCard__titleIcon", Yt = {
  root: pI,
  close: mI,
  title: gI,
  titleIcon: fI
};
class SD extends k {
  render() {
    const { icon: e, title: t, children: n, onRemove: o, className: r, ...a } = this.props, l = f(
      {
        [Yt.root]: Yt.root
      },
      r
    );
    return /* @__PURE__ */ s.jsxs(
      ie,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...a,
        className: l,
        children: [
          /* @__PURE__ */ s.jsx(
            ie,
            {
              as: "button",
              "aria-label": "Remove",
              className: Yt.close,
              onClick: o,
              children: /* @__PURE__ */ s.jsx(P, { name: "close" })
            }
          ),
          /* @__PURE__ */ s.jsxs(
            B,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: Yt.title,
              children: [
                e && /* @__PURE__ */ s.jsx(P, { name: e, className: Yt.titleIcon }),
                t
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(ie, { margin: "300 0 0 0" }),
          n
        ]
      }
    );
  }
}
const ir = ({
  colorMode: i = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${i}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${i};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, bI = "h-sandboxIframe--sandboxIframe__frame", yI = {
  frame: bI
};
class Jr extends k {
  frameRef;
  static defaultProps;
  constructor(e) {
    super(e), this.state = {
      iframeHeight: 0
    }, this.frameRef = O(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(e) {
    const { content: t, headContent: n, colorMode: o } = this.props;
    (e.content !== t || e.headContent !== n || e.colorMode !== o) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
  buildSandbox() {
    const { content: e, headContent: t = "", colorMode: n = "light" } = this.props, { current: o } = this.frameRef;
    if (o) {
      let r = "";
      e.indexOf("</body>") !== -1 ? r = e.replace(
        "</body>",
        `${ir({ colorMode: n })}</body>`
      ) : r = `<html><head><meta charset="utf-8" /><base target="_parent" />${t}</head><body>${e}${ir(
        { colorMode: n }
      )}</body></html>`, o.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(r))
      )}`;
    }
  }
  handlePostMessage(e) {
    const { current: t } = this.frameRef;
    if (t && e.source === t.contentWindow) {
      const { data: n } = e;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: e,
      content: t,
      headContent: n,
      sandbox: o,
      colorMode: r,
      ...a
    } = this.props, { iframeHeight: l } = this.state, c = f({}, e);
    return /* @__PURE__ */ s.jsx("div", { ...a, className: c, children: /* @__PURE__ */ s.jsx(
      "iframe",
      {
        title: "message",
        sandbox: o ?? Jr.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${l}px` },
        className: yI.frame,
        ref: this.frameRef
      }
    ) });
  }
}
const xI = "h-scrollbar--scrollbar__track", _I = "h-scrollbar--scrollbar__handle", ar = {
  track: xI,
  handle: _I
};
class ID extends k {
  constructor(e) {
    super(e), this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: e } = this.props;
    e.current && e.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: e } = this.props;
    e.current && e.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  updateSize = () => {
    const { container: e } = this.props;
    if (e.current) {
      const { current: t } = e;
      this.setState({
        size: t.offsetHeight / t.scrollHeight,
        progress: t.scrollTop / t.scrollHeight
      });
    }
  };
  handleTrackClick(e) {
    const { container: t } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), t.current) {
      const o = t.current.getBoundingClientRect();
      let r = (e.clientY - o.top) / t.current.offsetHeight - n / 2;
      r < 0 && (r = 0), r + n > 1 && (r = 1 - n), t.current.scrollTop = r * t.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(e) {
    const { size: t } = this.state;
    if (e.stopPropagation(), !(e.target instanceof Element)) return;
    const n = e.target.getBoundingClientRect();
    this.setState({
      offset: (e.clientY - n.top) / n.height * t
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(e) {
    e.preventDefault();
    const { container: t } = this.props, { size: n, offset: o } = this.state;
    if (t.current) {
      const r = t.current.getBoundingClientRect();
      let a = (e.clientY - r.top) / t.current.offsetHeight - o;
      a < 0 && (a = 0), a + n > 1 && (a = 1 - n), t.current.scrollTop = a * t.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: e, thumbClassName: t, trackClassName: n, ...o } = this.props, { size: r, progress: a } = this.state, l = f(e);
    return /* @__PURE__ */ s.jsx("div", { ...o, className: l, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(ar.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: f(ar.handle, t),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${r * 100}%`,
              top: `${a * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const CI = "h-scrollShadow--scrollShadow__wrapper", vI = "h-scrollShadow--scrollShadow__content", lr = {
  wrapper: CI,
  content: vI
}, kD = ({
  className: i,
  children: e,
  ...t
}) => {
  const n = f(lr.wrapper, i);
  return /* @__PURE__ */ s.jsx("div", { className: n, ...t, children: /* @__PURE__ */ s.jsx("div", { className: lr.content, children: e }) });
}, wI = "h-searchInput--searchInput__root", SI = "h-searchInput--searchInput__input", II = "h-searchInput--searchInput__inputButton", jn = {
  root: wI,
  input: SI,
  inputButton: II
}, kI = 275, cr = 300, DD = ({
  className: i,
  initialSearch: e,
  maxWidth: t = kI,
  placeholder: n,
  onChange: o,
  onSubmit: r,
  onToggle: a,
  ...l
}) => {
  const c = Y(null), [d, h] = V(!!e), [u, p] = V(!1), [m, g] = V(e ?? "");
  Vi(
    () => {
      u && (h(!1), p(!1), g(""));
    },
    cr,
    [u]
  ), Qe(() => {
    a?.(d), d && requestAnimationFrame(() => c.current?.focus());
  }, [d]);
  const b = F(() => {
    h(!0);
  }, []), y = F(() => {
    p(!0);
  }, []), _ = F(
    (x) => {
      x.preventDefault(), r(m);
    },
    [r, m]
  ), v = F(
    (x) => {
      const {
        target: { value: w }
      } = x;
      g(w), o?.(w);
    },
    [o]
  ), S = F(
    ({ key: x }) => {
      x === "Enter" && b();
    },
    [b]
  ), C = F(
    ({ key: x }) => {
      (x === "Esc" || x === "Escape") && y();
    },
    [y]
  );
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: f(jn.root, i),
      style: {
        "--max-width": `${d && !u ? t : 32}px`,
        "--transition-delay": `${cr}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ s.jsx("form", { onSubmit: _, children: /* @__PURE__ */ s.jsx(
        Ge,
        {
          className: jn.input,
          ref: c,
          onChange: v,
          placeholder: n ?? "Search...",
          type: "search",
          value: m,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: _,
              className: jn.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: y,
              className: jn.inputButton
            }
          },
          onKeyDown: C
        }
      ) }) : /* @__PURE__ */ s.jsx(
        U,
        {
          icon: "search",
          variant: "secondary",
          onClick: b,
          onKeyDown: S,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, DI = "h-selectOption--selectOption__root", TI = "h-selectOption--selectOption__checkbox", jI = "h-selectOption--selectOption__content", _s = {
  root: DI,
  checkbox: TI,
  content: jI
}, TD = (i) => {
  const e = f(_s.root);
  return /* @__PURE__ */ s.jsxs("label", { className: e, children: [
    /* @__PURE__ */ s.jsx(
      an,
      {
        ...i,
        className: f(_s.checkbox, i.className)
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: _s.content, children: i.name })
  ] });
}, NI = "h-simpleProgressBar--simpleProgressBar__container", FI = "h-simpleProgressBar--simpleProgressBar__progressBar", PI = "h-simpleProgressBar--simpleProgressBar__progressBarFill", Cs = {
  container: NI,
  progressBar: FI,
  progressBarFill: PI
}, RI = "simpleProgressBarId";
function jD({
  progress: i,
  base: e = 100,
  progressColor: t = "purple.500",
  backgroundColor: n = "neutral.200",
  tooltipContent: o,
  tooltipProps: r,
  ...a
}) {
  const [l, c] = V(0), d = 4;
  X(() => c(i), [i]);
  const h = e >= l ? l / e : 1, u = () => d / h, p = {
    backgroundColor: Zt(n)
  }, m = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: Zt(t)
  };
  return /* @__PURE__ */ s.jsx(
    B,
    {
      "test-id": RI,
      "align-items": "center",
      "justify-content": "center",
      className: Cs.container,
      ...a,
      children: /* @__PURE__ */ s.jsx(
        se,
        {
          disabled: !o,
          content: o,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ s.jsx("div", { className: Cs.progressBar, style: p, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: Cs.progressBarFill,
              style: m
            }
          ) })
        }
      )
    }
  );
}
const EI = "h-tabsWithContent--tabsWithContent__container", LI = "h-tabsWithContent--tabsWithContent__containerTop", AI = "h-tabsWithContent--tabsWithContent__containerLeft", $I = "h-tabsWithContent--tabsWithContent__containerRight", OI = "h-tabsWithContent--tabsWithContent__containerBottom", BI = "h-tabsWithContent--tabsWithContent__childrenContainer", Ct = {
  container: EI,
  containerTop: LI,
  containerLeft: AI,
  containerRight: $I,
  containerBottom: OI,
  childrenContainer: BI
};
class Ps extends me {
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(e) {
    super(e), this.state = { activeTab: e.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(e) {
    this.ensureTabIsValid(e) && (this.setState({ activeTab: e }), this.props.onChange?.(e));
  }
  ensureTabIsValid(e) {
    return this.props.tabs.some((t) => t.id === e);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: e }) => e === this.state.activeTab);
  }
  render() {
    const {
      className: e,
      tabsClassName: t,
      tabClassName: n,
      tabSelectedClassName: o,
      childrenWrapperClassName: r,
      tabs: a,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Re.toArray(l);
    if (h.length !== a.length) {
      const g = `${Ps.name}: Number of tabs don't match the number of children.`;
      console.warn(g);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const g = `${Ps.name}: The selected tab does not exist in tabs array!`;
      console.warn(g);
    }
    const p = f(e, Ct.container, {
      [Ct.containerTop]: c === "top",
      [Ct.containerLeft]: c === "left",
      [Ct.containerBottom]: c === "bottom",
      [Ct.containerRight]: c === "right"
    }), m = f(
      r,
      Ct.childrenContainer
    );
    return /* @__PURE__ */ s.jsxs("section", { className: p, children: [
      /* @__PURE__ */ s.jsx(
        yf,
        {
          className: t,
          tabClassName: n,
          tabSelectedClassName: o,
          tabs: a,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: m, children: h[u] })
    ] });
  }
}
const HI = "h-tagsInput--tagsInput__root", WI = "h-tagsInput--tagsInput__wrapper", MI = "h-tagsInput--tagsInput__input", zI = "h-tagsInput--tagsInput__inputIsHidden", VI = "h-tagsInput--tagsInput__placeholder", KI = "h-tagsInput--tagsInput__placeholderText", UI = "h-tagsInput--tagsInput__iconBox", qI = "h-tagsInput--tagsInput__iconText", GI = "h-tagsInput--tagsInput__tag", YI = "h-tagsInput--tagsInput__tagIsActive", QI = "h-tagsInput--tagsInput__tagButton", be = {
  root: HI,
  wrapper: WI,
  input: MI,
  inputIsHidden: zI,
  placeholder: VI,
  placeholderText: KI,
  iconBox: UI,
  iconText: qI,
  tag: GI,
  tagIsActive: YI,
  tagButton: QI
};
function dr(i = [], e) {
  switch (e) {
    case "asc":
      return i.sort();
    case "desc":
      return i.sort().reverse();
    default:
      return i;
  }
}
const XI = 255, ND = ({
  className: i,
  disabled: e,
  limit: t,
  placeholder: n,
  selectedTags: o,
  sortDirection: r,
  onChange: a
}) => {
  const l = Y(null), c = Y(null), [d, h] = V(""), [u, p] = V(
    dr(o, r)
  ), [m, g] = V(""), [b, y] = V(!1);
  xr(l, () => y(!1)), Qe(() => a(u), [u, a]), Qe(() => {
    c.current && b && c.current.focus();
  }, [c.current, b]);
  const _ = (I) => {
    h(I.target.value ?? "");
  }, v = (I) => {
    const T = u.indexOf(m);
    switch (I.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !m && d && p((N) => {
          const H = Array.from(/* @__PURE__ */ new Set([...N, d]));
          return h(""), dr(H, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !m && d.length === 0 && g(u[u.length - 1]), m && (S(m), g(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        m && T > 0 && g(u[T - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        m && T < u.length - 1 && g(u[T + 1]);
        break;
      default:
        m && g("");
    }
  }, S = (I) => {
    p((T) => {
      const N = [...T];
      return N.splice(N.indexOf(I), 1), N;
    });
  }, C = b ? u.length : t || u.length, x = C < u.length, w = u.slice(0, C);
  return /* @__PURE__ */ s.jsx(
    Be,
    {
      ref: l,
      className: f(be.root, i),
      onClick: () => y(!0),
      disabled: e,
      children: /* @__PURE__ */ s.jsxs("div", { className: be.wrapper, "data-testid": "tags-wrapper", children: [
        w.map((I) => /* @__PURE__ */ s.jsx(
          kt,
          {
            className: f(be.tag, {
              [be.tagIsActive]: I === m
            }),
            onDelete: () => S(I),
            "data-testid": "tag",
            children: I
          },
          I
        )),
        !b && x && /* @__PURE__ */ s.jsxs(
          kt,
          {
            className: f(be.tag, be.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - C
            ]
          }
        ),
        !b && !u.length && !d && /* @__PURE__ */ s.jsx(B, { className: be.placeholder, alignItems: "center", gap: "200", children: n ? /* @__PURE__ */ s.jsx($.Paragraph, { className: be.placeholderText, variant: "2", children: n }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx($.Paragraph, { className: be.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ s.jsxs("div", { className: be.iconBox, children: [
            /* @__PURE__ */ s.jsx(P, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ s.jsx($.Paragraph, { className: be.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            className: f(be.input, {
              [be.inputIsHidden]: !b
            }),
            onChange: _,
            onKeyDown: v,
            maxLength: XI,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, ZI = "h-textWithHighlight--textWithHighlight__highlight", JI = {
  highlight: ZI
}, ek = ({
  text: i,
  highlight: e,
  className: t,
  highlightClassName: n,
  ignoreCase: o = !0
}) => {
  if (!e?.trim())
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const r = new RegExp(
    As(e.trim()),
    o ? "ig" : "g"
  ), a = i.match(r), l = i.split(r);
  return /* @__PURE__ */ s.jsx("span", { className: t, children: l.map((c, d) => /* @__PURE__ */ s.jsxs("span", { children: [
    c,
    a?.[d] && /* @__PURE__ */ s.jsx("em", { className: f(JI.highlight, n), children: a[d] })
  ] }, d)) });
}, tk = br(ek);
tk.name = "TextWithHighlight";
const nk = "h-timestamp--timestamp__timestamp", sk = "h-timestamp--timestamp__print", ok = "h-timestamp--timestamp__screen", vs = {
  timestamp: nk,
  print: sk,
  screen: ok
}, rk = 1e4;
class FD extends me {
  interval;
  static defaultProps = {
    refreshRate: rk
  };
  constructor(e) {
    super(e);
    const { relative: t, counter: n, initialFormat: o } = e;
    let r = o ?? "absolute";
    t ? r = "ago" : n && (r = "counter"), this.state = {
      format: r,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: e } = this.state;
    (e === "ago" || e === "counter") && this.startTicker();
  }
  componentDidUpdate(e) {
    const { relative: t, initialFormat: n } = this.props, { pristine: o } = this.state;
    t !== e.relative && o && this.setState({
      format: t ? "ago" : "absolute"
    }), n && n !== e.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(e) {
    const { onClick: t } = this.props, { format: n } = this.state;
    let o = this.state.format;
    n === "ago" ? (o = "full", this.stopTicker()) : n === "full" ? o = "absolute" : n === "absolute" && (o = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: o
    }), t?.(o, e);
  }
  getTimeString(e) {
    let { time: t } = this.props;
    const { isSecondsDisplayed: n, customFormatters: o } = this.props;
    let r = "";
    if (typeof t == "number") {
      const l = /* @__PURE__ */ new Date();
      l.setTime(t * 1e3), t = l;
    }
    const a = j(t).utc().local();
    if (e === "counter") {
      const l = j(t).utc(), d = j().utc().diff(l) / 1e3, h = Math.floor(d / 3600), u = Math.floor(h / 24), p = h % 24, m = h * 60 * 60, g = Math.floor((d - m) / 60), b = g * 60, y = Math.floor(
        d - m - b
      );
      r = [
        p.toString().padStart(2, "0"),
        g.toString().padStart(2, "0"),
        y.toString().padStart(2, "0")
      ].join(":"), u > 0 && (r = `${u} ${u === 1 ? "DAY" : "DAYS"} ${r}`);
    } else if (e === "full") {
      const l = o?.full ?? (n ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      r = a.format(l);
    } else if (e === "absolute")
      if (j().diff(j(t), "hours") > 12) {
        const l = o?.absolute ?? `D MMMM LT${n ? "S" : ""}`;
        r = a.format(l);
      } else {
        const l = o?.absolute ?? `LT${n ? "S" : ""}`;
        r = a.format(l);
      }
    else
      r = Ch(a);
    return r;
  }
  render() {
    const {
      className: e,
      relative: t,
      time: n,
      refreshRate: o,
      counter: r,
      customFormatters: a,
      isSecondsDisplayed: l,
      initialFormat: c,
      onClick: d,
      ...h
    } = this.props, u = f(
      {
        [vs.timestamp]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          ...h,
          ...Vn(this.handleClick),
          className: f(u, vs.screen),
          children: this.getTimeString(this.state.format)
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: f(u, vs.print), "aria-hidden": !0, children: this.getTimeString("full") })
    ] });
  }
}
const ik = "h-token--token__root", ak = "h-token--token__select", lk = "h-token--token__label", ck = "h-token--token__rootReadonly", dk = "h-token--token__rootPrimary", hk = "h-token--token__rootWithError", uk = "h-token--token__value", pk = "h-token--token__icon", Ae = {
  root: ik,
  select: ak,
  label: lk,
  rootReadonly: ck,
  rootPrimary: dk,
  rootWithError: hk,
  value: uk,
  icon: pk
};
class PD extends k {
  render() {
    const {
      onDelete: e,
      id: t,
      label: n,
      options: o,
      valueLabel: r,
      primary: a,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = f(
      {
        [Ae.root]: !0,
        [Ae.rootPrimary]: a,
        [Ae.rootWithError]: c?.error,
        [Ae.rootReadonly]: !o && !e
      },
      h
    );
    let m = r;
    if (!m && l && o && o.length) {
      const g = o.filter(({ value: b }) => l.value === b);
      g.length && (m = g[0].label);
    }
    return !m && d && (m = d), /* @__PURE__ */ s.jsxs("div", { ...u, className: p, children: [
      !!o && /* @__PURE__ */ s.jsxs("select", { ...l, className: Ae.select, id: t, children: [
        !!d && /* @__PURE__ */ s.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        o.map((g) => /* @__PURE__ */ s.jsx("option", { value: g.value, children: g.label }, g.value?.toString()))
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: Ae.label, htmlFor: t, children: [
        n,
        /* @__PURE__ */ s.jsx("span", { className: Ae.value, children: m }),
        !!o && /* @__PURE__ */ s.jsx(P, { className: Ae.icon, name: "angle-down" }),
        !!e && /* @__PURE__ */ s.jsx("span", { ...Vn(e), children: /* @__PURE__ */ s.jsx(P, { className: Ae.icon, name: "close", onClick: e }) })
      ] })
    ] });
  }
}
const mk = "h-skeleton--skeleton__root", gk = "h-skeleton--skeleton__rootAnimationPulse", fk = "h-skeleton--skeleton__rootAnimationWave", ws = {
  root: mk,
  rootAnimationPulse: gk,
  rootAnimationWave: fk
};
function hr({ className: i, animation: e = "pulse", ...t }, n) {
  const o = f(
    {
      [ws.root]: !0,
      [ws.rootAnimationPulse]: e === "pulse",
      [ws.rootAnimationWave]: e === "wave"
    },
    i
  );
  return /* @__PURE__ */ s.jsx(ie, { className: o, ...t, ref: n });
}
const RD = Object.assign(W(hr), {
  name: hr.name
}), bk = "h-breadcrumbs--breadcrumbs__root", yk = "h-breadcrumbs--breadcrumbs__list", xk = "h-breadcrumbs--breadcrumbs__item", _k = "h-breadcrumbs--breadcrumbs__separator", Nn = {
  root: bk,
  list: yk,
  item: xk,
  separator: _k
}, ED = W(function({
  className: e,
  children: t,
  as: n,
  separator: o = /* @__PURE__ */ s.jsx(P, { name: "angle-right" }),
  "aria-label": r = "breadcrumb",
  ...a
}, l) {
  const c = n ?? "nav", d = Re.toArray(t).filter(Boolean);
  return /* @__PURE__ */ s.jsx(
    c,
    {
      ...a,
      ref: l,
      className: f(Nn.root, e),
      "aria-label": r,
      children: /* @__PURE__ */ s.jsx("ol", { className: Nn.list, children: d.map((h, u) => {
        const p = u === d.length - 1, m = typeof h == "string" || typeof h == "number" ? /* @__PURE__ */ s.jsx("span", { children: h }) : h;
        return /* @__PURE__ */ s.jsxs(Xe, { children: [
          /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Nn.item,
              "aria-current": p ? "page" : void 0,
              children: m
            }
          ),
          !p && /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Nn.separator,
              "data-testid": "breadcrumbs-separator",
              "aria-hidden": "true",
              children: o
            }
          )
        ] }, u);
      }) })
    }
  );
});
export {
  og as AddonTriggerContext,
  rg as AddonTriggerEvents,
  Fk as Attachment,
  _r as Avatar,
  bu as AvatarSelectItem,
  Rk as Badge,
  Ek as Banner,
  ie as Box,
  ED as Breadcrumbs,
  te as Button,
  Lk as ButtonGroup,
  co as ButtonList,
  Kk as CheckableAvatarSelectItem,
  Ks as CheckableBaseItem,
  Mk as CheckableSelectItem,
  Vk as CheckableTagSelectItem,
  an as Checkbox,
  $u as Chip,
  $k as CollapseCard,
  Ok as Collapsible,
  Un as ColorPicker,
  ue as Column,
  Nc as Columns,
  Gc as CopyToClipboard,
  Bk as CopyToClipboardButton,
  dD as CountryFlag,
  Hk as DataTable,
  Yp as DatePicker,
  Qt as DatePickerOld,
  Wp as DateRangePicker,
  ku as DeselectItem,
  Gk as Dialer,
  zn as Divider,
  Je as Dropdown,
  ct as DropdownButton,
  ln as DropdownButtonContext,
  Vs as DropdownInfinite,
  jo as DropdownItem,
  Gs as DropdownSelect,
  $r as DropdownSelectContainer,
  Yk as DropdownSelectMultiple,
  Li as EMOJIS,
  $D as EmojiPicker,
  cn as EmptySelectItem,
  Cd as EmptyState,
  jt as ErrorBoundary,
  aa as ErrorBoundaryContext,
  cD as FieldAddonDropdown,
  Gn as FieldAlert,
  Qk as FieldButton,
  lD as FieldColorPicker,
  Xk as FieldDatePicker,
  Zk as FieldDateRangePicker,
  zs as FieldLabel,
  eD as FieldRichText,
  tD as FieldSelect,
  nD as FieldSelectionList,
  sD as FieldSlider,
  oD as FieldSwitch,
  Ds as FieldText,
  rD as FieldTextarea,
  iD as FieldTimePicker,
  aD as FieldTimeRangePicker,
  z as FieldWrapper,
  B as FlexBox,
  Cr as FocusScope,
  pD as FormField,
  uD as FormGrid,
  Ms as HelpIcon,
  mD as HelperField,
  P as Icon,
  U as IconButton,
  Bs as Image,
  Ty as InputColorPicker,
  Dm as InputDatePicker,
  nn as InputDateRangePicker,
  gD as InputDuration,
  to as InputRichText,
  Kb as InputSelectionList,
  Ge as InputText,
  Be as InputWrapper,
  fD as Lightbox,
  bD as List,
  bD as ListV2,
  yD as MediaPlayer,
  Rw as Modal,
  xD as ModalBody,
  HS as ModalFoot,
  _D as ModalHead,
  Pw as ModalStackContext,
  OD as NavigationButton,
  CD as Page,
  pd as Pagination,
  Cw as Portal,
  Er as Presets,
  vD as Radio,
  SD as RemovableCard,
  wD as ReverseScroll,
  Jr as SandboxIframe,
  kD as ScrollShadow,
  ID as Scrollbar,
  DD as SearchInput,
  pp as Select,
  Lr as SelectItem,
  TD as SelectOption,
  Db as SelectionList,
  Xc as SimplePagination,
  jD as SimpleProgressBar,
  RD as Skeleton,
  Fs as Slider,
  $s as Spinner,
  py as Switch,
  pe as Table,
  qn as TableContext,
  yf as Tabs,
  Ps as TabsWithContent,
  kt as Tag,
  qk as TagDeselectItem,
  zk as TagSelectItem,
  Uk as TagSelectSuggestion,
  ND as TagsInput,
  $ as Text,
  tk as TextWithHighlight,
  Yr as Textarea,
  tn as TimePicker,
  Pp as TimeRangePicker,
  FD as Timestamp,
  PD as Token,
  se as Tooltip,
  Mn as WindowContext,
  Nk as WindowProvider,
  BD as addSvgIconsToDocument,
  Aa as badgeTestId,
  kc as colorPickerTestId,
  hD as countryCodes,
  Wk as datepickerDisableWeekends,
  HD as defaultElementType,
  Xs as formatShortcut,
  zm as formattingOptions,
  Pt as getSelectionListContext,
  WD as iconMeta,
  zo as inputRichTextCommands,
  Vb as inputSelectionListTestId,
  uI as reverseScrollTestId,
  Os as useWindowContext,
  rn as withErrorBoundary
};
//# sourceMappingURL=index.js.map
